/**
 * featureBindings.js — AI, segmentation, clinical tools, TAVI, reports, comparison,
 * GPU compute, fusion, endoscopy, measurements, voice control, etc.
 * Extracted from uiManager.js (декомпозиция God Object)
 */

import { getRenderingEngine, getViewportIds, setWindowLevel, set3DPreset, enableMPRSync, applyRenderPreset, applyWindowToSlices, startCine, stopCine, loadStack, ensureCinematicRenderer , применитьМРПеренос } from '../core/viewport.js'; // [10.19.30] setOverlayOpacity/Colormap и addVolumeOverlay ушли вместе с кустом кнопок-призраков
import { getCinematicRenderer, cornerstone } from '../core/viewportState.js'; // [7.0.50/51] cine + overlay движок; [12.0.57] кэш томов для DSA
import { окноВыбранное, пробаПодМышью, срезОкна } from './specModes.js';   // [12.0.57] спец. режимы: выбранное окно и значения снимка
import { тканьПоHU, окноПоОбласти, медиана, статистика, гистограмма, мипРазности, геометрияСовпадает } from '../core/specModesCore.js';   // [12.0.57]
import { найтиТом, данныеТома } from '../core/volumePick.js';   // [12.0.57] DSA: том по имени из реестра
// [10.19.16] Один путь включения кинематографического рендеринга для ВСЕХ кнопок.
import { включитьКино, выключитьКино, переключитьКино, применитьНастройкиКино } from './cinematicControl.js'; // [12.0.51] настройки на ходу
import { getOrtBackend } from '../rendering/cinematic10/ortLoader.js'; // [10.19.24] фактический движок ONNX — для честной подписи ai-backend
import { setActiveTool, getActiveTool, clearAnnotations, getAnnotations, exportAnnotations, removeAnnotation, setBrushSize, setActiveSegment, getActiveSegmentationId, setSegmentationOpacity, getSegmentationData, обеспечитьХолстМаски } from '../tools/toolManager.js'; // [7.0.49] exportAnnotations — был ReferenceError на btn-meas-json; [11.0.2] removeAnnotation — крестик в таблице измерений; четыре последних — провода к движку сегментации
import { КЛАССЫ as КЛАССЫ_ОРГАНОВ } from '../ai/organsMath.js';   // [12.0.28] орган по имени файла маски
import { отметитьОрган, органИзИмениФайла } from '../core/organRegistry.js';   // [12.0.28] реестр орган → сегмент
import { getSeriesImageIds, loadDICOMFiles } from '../loaders/loaderManager.js'; // [7.0.49] prior-серия; getAllSeries ушёл с кустом призраков [10.19.30]
import { showToast, formatPatientName, downloadBlob, escapeHtml } from '../utils/helpers.js';
import { screenshotViewport } from '../core/viewport.js';
import { emit, on as on_, EVENTS } from '../core/eventBus.js';
import { registerAPIs } from '../core/viewerAPI.js';
import { getGPUInfo } from '../core/gpuDetector.js';
import { setVolumeClipping, setClipAxisEnabled, startAutoSpin, stopAutoSpin, isAutoSpinOn, setAutoSpinTurntable } from '../core/viewportEffects.js';
import { stopAutoRotate } from '../core/viewportCamera.js'; // [10.19.31] мост: выключатель глушит кнопочное вращение (Гориз./Верт.) // [10.19.30] выключатели осей и автовращение — настоящие
import { knownVolumeIds, onRegistryChange } from '../core/volumeRegistry.js'; // [10.19.30] список объёмов для DSA
import { _updateUndoRedoButtons, bindAnnotationEvents, bindUndoRedoKeys, отменитьМазокКисти, повторитьМазокКисти } from './toolBindings.js';   // [12.0.54] кнопки отмены вкладки — мазки, а не замеры
import { забытьМазки } from '../tools/toolManager.js';                         // [12.0.54] «Очистить» забывает и мазки
import { цветСегмента } from '../core/segColors.js';                          // [12.0.54] кружки списка = цвета движка
import { этоПолурешётка } from '../core/maskGrid.js';                         // [12.0.54] честные отказы на маске ½ шага
import { bindTFEditor } from './sidebarBindings.js';
import { changeLayout } from './layoutManager.js';
import { ЧИПЫ_ПО_ID } from '../core/wlChips.js';   // [12.0.49] голосовые окна — числа из каталога чипов
import { openPrintWindow } from './printUtil.js'; // [11.1.16] «Печать» выводит бланк отчёта, а не страницу приложения
import { открытьПечатное, отметитьЭкспорт } from './exportModule.js';
import { скачатьDocxОтчёт, собратьDocxБайты } from '../core/docxReport.js';
import { прочитатьБланк, записатьБланк, названиеОтделения, ОТДЕЛЕНИЕ_ПО_УМОЛЧАНИЮ, собратьШапку, разделВключён, шрифтыБланка, логотипБланка, поляБланка, НАБОРЫ_РАЗДЕЛОВ } from '../core/reportBlank.js'; // [11.1.30] разделы, шрифты, логотип
import { прочитатьЗаключения, сохранитьЗаключение, загрузитьЗаключение, удалитьЗаключение, ключЗаключения, собратьФайлЗаключения, разобратьФайлЗаключения, слитьЗаключения } from '../core/reportDrafts.js'; // [11.1.31] заключения в динамике // [11.1.20] шапка учреждения и автосбор из тегов
import { getDICOMTags } from '../loaders/loaderManager.js';
import { гпуСупВVtk } from '../compute/meshConvert.js';   // [11.1.22] сведение сеток: GPU-суп → общий формат
import { положитьСетку } from './toolsBindings.js';
import { изолироватьОрган, вернутьТело, stlОргана, томМаски, записатьМаску, подсчётВокселей, объёмМл, запомнитьПравкуМаски, отменитьПравкуМаски, естьПравкаМаски, забытьПравкиМаски } from '../core/organView.js'; // [11.1.24] мост маска→3D // [11.1.38] морфология маски
import { залитьКонтуры, интерполироватьСрезы, осьПоНормали } from '../core/maskMorph.js';
import { прочитатьМаску, сеткиСовпадают, этоGzip } from '../core/niftiRead.js';
import { прочитатьМетку } from '../io/niftiCore.js';   // [11.1.70] метка «откуда маска» в заголовке   // [11.1.50] мост: чужая маска → наш сегмент       // [11.1.38] заливка контуров и достройка между срезами
import { получитьПоследнийVRTПресет } from './sidebarBindings.js';               // [11.1.24] чем красить тело после возврата        // [11.1.22] построенное подхватывает ряд обработки // [11.1.20] теги открытого исследования для автозаполнения // [11.1.19] редактируемый бланк Word — кириллица гарантирована самим форматом // [11.1.18] в Electron окна запрещены — PDF идёт родной дверью printToPDF
import { log } from '../utils/logger.js';

const $ = (id) => document.getElementById(id);
const $$ = (sel) => document.querySelectorAll(sel);
let _cinematicHandle = null;
// [7.0.49] Были не объявлены → indexedDB.open(MEAS_DB_NAME, …) кидал ReferenceError,
// ломая сохранение измерения и график динамики.
const MEAS_DB_NAME = 'mikhmel-measurements';
const MEAS_DB_VERSION = 1;

// [FIX-LEAK] AbortController — один signal.abort() убирает все listener'ы
let _abortController = null;
function _getSignal() {
  if (!_abortController) _abortController = new AbortController();
  return _abortController.signal;
}
const on = (id, evt, fn) => { const el = $(id); if (el) el.addEventListener(evt, fn, { signal: _getSignal() }); };

/**
 * Окно результата расчёта. [10.19.30] Вынесено из bindGPUCompute на уровень
 * модуля: тем же окном пользуется DSA-вычитание — заводить второе, чуть иное,
 * значило бы разводить один показ по двум местам.
 */
const _окноРезультата = (заголовок) => {
  const фон = document.createElement('div');
  фон.style.cssText = 'position:fixed;inset:0;z-index:60000;background:rgba(5,8,14,0.72);display:flex;align-items:center;justify-content:center;padding:14px;overflow:auto;';
  const к = document.createElement('div');
  к.style.cssText = 'max-width:720px;width:100%;max-height:92vh;overflow:auto;background:#0f1420;border:1px solid #2a3546;border-radius:14px;padding:16px;color:#dbe6f5;font-size:13px;line-height:1.5;';
  к.innerHTML = `<div style="font-size:15px;font-weight:700;margin-bottom:10px;">${заголовок}</div>`;
  фон.appendChild(к);
  фон.addEventListener('click', (e) => { if (e.target === фон) фон.remove(); });
  const закр = document.createElement('button');
  закр.textContent = 'Закрыть';
  закр.style.cssText = 'margin-top:12px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;';
  закр.addEventListener('click', () => фон.remove());
  document.body.appendChild(фон);
  return { тело: к, закрыть: закр, фон };
};

/**
 * Взять выключатель СЕБЕ: клон узла снимает общий перещёлкиватель класса из
 * sidebarBindings, и состоянием управляет только этот обработчик. [10.19.30]
 * Тот же приём, что _rebind в proFeaturesBindings: у выключателя с делом не
 * должно быть второго хозяина, который щёлкает классом вслепую.
 * handler получает новое состояние и возвращает false, чтобы ОТКАЗАТЬ во
 * включении (например, крутить нечего) — класс тогда не меняется.
 */
function _ownToggle(id, handler) {
  const el = $(id);
  if (!el) return null;
  const св = el.cloneNode(true);
  el.parentNode.replaceChild(св, el);
  св.addEventListener('click', () => {
    const было = св.classList.contains('on');
    const хочет = !было;
    const ответ = handler(хочет, св);
    if (ответ === false) return; // отказ: состояние не меняем
    св.classList.toggle('on', хочет);
    св.setAttribute('aria-checked', String(хочет));
  }, { signal: _getSignal() });
  return св;
}
const onAll = (sel, evt, fn) => $$(sel).forEach(el => el.addEventListener(evt, fn, { signal: _getSignal() }));

/**
 * Cleanup — убирает все listener'ы, установленные через on()/onAll()
 */
export function destroyFeatureBindings() {
  if (_abortController) { _abortController.abort(); _abortController = null; }
}

// [12.0.56] Ленивые обёртки aiModule (runDetection, runClassification, runSegmentation,
// segmentOrgansByHU, segmentBrainByHU, classifyStroke…) удалены вместе с роутером
// карточек ИИ — их звал только он. Две из них (runDetection, runClassification)
// звали функции, которых в aiModule нет вовсе. «Проверить модели» грузит модуль сам.

let _gpuModule = null;
async function _gpu() { return _gpuModule || (_gpuModule = await import('../compute/gpuCompute.js')); }

let _dataModule = null;
async function _data() { return _dataModule || (_dataModule = await import('../managers/DatasetManager.js')); }

let _roiWlActive = false;
let _voiceRecognition = null;

let _ctx = null;

/**
 * @param {Object} ctx
 * @param {function():string} ctx.getCurrentViewportId
 * @param {function():string} ctx.getCurrentVolumeId
 * @param {function():string} ctx.getCurrentSeries
 * @param {function():string[]} ctx.getCurrentImageIds
 * @param {function():Object} ctx.getVolumeScalarData
 * @param {function():Array} ctx.getAllSeries
 * @param {function(string)} ctx.openModal
 * @param {function(string)} ctx.closeModal
 * @param {Object} ctx.VRT_PRESET_MAP
 * @param {function():Object} ctx.getCinematicHandle - returns _cinematicHandle
 * @param {function(Object)} ctx.setCinematicHandle
 */
export function initFeatureBindings(ctx) {
  _ctx = ctx;
  bindSegmentation();
  bindAI();
  bindCinematic();
  bindFusion4D();
  bindGPUCompute();
  bindEndoscopy();
  bindMeasurements();
  bindReports();
  bindComparison();
  bindMultiMonitor();
  bindSynchronizer();
  bindClinicalTools();
  bindSpecialModes();
  bindClinicalExtras();
}

function bindSegmentation() {
  // [11.0.2] ТРИ ПРОВОДА К ДВИЖКУ СЕГМЕНТАЦИИ.
  //
  // Пульт в правом сайдбаре был построен целиком, а провода к нему не
  // протянуты. Движок при этом собран и работает: кисть (BrushTool, клавиша D)
  // и пороговая кисть живут в тулбаре, сама сегментация создаётся сама при
  // первом включении кисти (toolManager.#tryCreateSegmentation), а функции
  // `setBrushSize`, `setActiveSegment`, `getSegmentationData` экспортированы
  // из toolManager. НИ ОДНА из них не вызывалась нигде в проекте — проверено
  // поиском. Пульт построили, провода забыли.
  //
  // Провод 1 — размер кисти. Ползунок менял только цифру рядом с собой.
  const кисть = $('brush-size');
  if (кисть) {
    кисть.addEventListener('change', () => {
      const r = Number(кисть.value) || 10;
      try {
        setBrushSize(r);
        showToast(`Радиус кисти: ${r} мм`, 'info', 900);
      } catch (e) { log.warn('[Сегментация] радиус кисти:', e.message); }
    }, { signal: _getSignal() });
    // [12.0.54] Значение ползунка — сразу, а не после первого касания: до
    // него кисть рисовала умолчанием движка, 25 мм, при подписи «10».
    try { setBrushSize(Number(кисть.value) || 10); } catch (e) { /* инструменты ещё не подняты — toolManager запомнит */ }
  }

  // Провод 2 — прозрачность маски поверх снимка.
  const прозрачность = $('seg-opacity');
  if (прозрачность) {
    прозрачность.addEventListener('change', () => {
      const доля = (Number(прозрачность.value) || 60) / 100;
      const вышло = setSegmentationOpacity(доля);
      if (!вышло) {
        // Молчать нельзя: ползунок двинулся, на экране ничего — ровно та
        // беда, из-за которой поломку не замечали годами.
        // [12.0.54] Теперь значение и правда запоминается (toolManager) и
        // встаёт на маску при её создании — прежде здесь обещалось то же, но
        // маска рождалась с умолчанием движка.
        showToast('Маски пока нет — прозрачность запомнена и встанет на маску, когда начнёте рисовать', 'info', 4000);
      }
    }, { signal: _getSignal() });
    try { setSegmentationOpacity((Number(прозрачность.value) || 60) / 100); } catch (e) { /* запомнится при подъёме */ }
  }

  // Провод 3 — выбор активного сегмента. Щелчок по строке красил класс
  // `active` и на этом заканчивался: кисть продолжала рисовать первым
  // сегментом, каким бы ни был выбран в списке.
  const список = $('segment-list');
  if (список) {
    // [11.1.21] Номер сегмента теперь ЖИВЁТ В СТРОКЕ (data-seg-index), а не
    // вычисляется по позиции. Прежний indexOf+1 лгал после удаления: убрали
    // «Сегмент 2» — строка «Сегмент 3» становилась второй и включала СЕГМЕНТ
    // 2 движка (аудит §2.2). Заодно у active-класса был ТРИ хозяина
    // (делегация + onAll по статичным + per-row у добавленных) — остался
    // один делегат: он и класс ведёт, и движок переключает, и удаляет.
    список.addEventListener('click', (e) => {
      const строка = e.target.closest('.seg-row');
      if (!строка) return;
      if (e.target.closest('.ann-del-btn')) {
        const н = строка.dataset.segIndex || '?';
        if (!confirm(`Убрать «Сегмент ${н}» из списка? Уже нарисованные мазки этого сегмента останутся на снимке под своим цветом.`)) return;
        строка.remove();
        return;
      }
      $$('.seg-row').forEach((r) => r.classList.remove('active'));
      строка.classList.add('active');
      const индекс = Number(строка.dataset.segIndex) || 1;
      const segId = getActiveSegmentationId();
      // [12.0.54] До первого мазка выбор ЗАПОМИНАЕТСЯ (toolManager ставит его
      // на маску при создании). Прежде он забывался: строка «Сегмент 3»
      // подсвечена, а кисть красила сегментом 1 — проверено на стенде.
      try { setActiveSegment(segId, индекс); } catch (err) { log.warn('[Сегментация] активный сегмент:', err.message); }
      showToast(segId ? `Рисуем сегментом ${индекс}` : `Сегмент ${индекс} выбран — кисть начнёт с него`, 'info', 1200);
    }, { signal: _getSignal() });
    // [12.0.54] Кружки — цветами движка (core/segColors.js): прежние свои
    // цвета расходились с маской у сегментов 3, 4, 5.
    список.querySelectorAll('.seg-row').forEach((r) => {
      const к = r.querySelector('.seg-color');
      if (к) к.style.background = цветСегмента(Number(r.dataset.segIndex) || 1);
    });
  }

  // [11.1.24] «Только орган в 3D» — мост от маски к объёмному виду
  // (проект по слову владельца). Активный сегмент берётся из строки списка
  // (data-seg-index, 11.1.21), цвет — из её кружка.
  const _активныйСегмент = () => {
    const строка = document.querySelector('#segment-list .seg-row.active') || document.querySelector('#segment-list .seg-row');
    return {
      индекс: Number(строка?.dataset.segIndex) || 1,
      цвет: строка?.querySelector('.seg-color')?.style.background || '#ef4444',
      имя: строка?.querySelector('.seg-label')?.textContent || 'Сегмент',
    };
  };

  on('btn-seg-organ-3d', 'click', async () => {
    const с = _активныйСегмент();
    showToast(`Прячу тело, оставляю «${с.имя}»…`, 'info', 1500);
    const р = await изолироватьОрган({ индекс: с.индекс, цвет: с.цвет });
    if (!р.ок) { showToast(р.причина, 'warning', 4500); return; }
    const w = _окноРезультата(`Только орган · ${с.имя}`);
    w.тело.insertAdjacentHTML('beforeend',
      `<div>Объём: <b>${р.мл.toFixed(1)} мл</b> · вокселей ${р.вокселей.toLocaleString('ru-RU')}</div>`
      + '<div style="margin-top:6px;color:#8fa3c0;">Объём посчитан по маске — он ровно настолько точен, насколько аккуратно обведён орган. Не для диагностики.</div>');
    const назад = document.createElement('button');
    назад.textContent = 'Вернуть тело';
    назад.style.cssText = 'margin-top:10px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;cursor:pointer;';
    назад.addEventListener('click', async () => {
      const в = await вернутьТело();
      if (!в.ок) { showToast(в.причина, 'warning', 3500); return; }
      // Тело вернулось «сырым» — пере-применяем последний выбранный пресет,
      // чтобы врач увидел ту же картинку, что была до изоляции.
      const посл = получитьПоследнийVRTПресет();
      if (посл) applyRenderPreset(посл.cs3d, { ww: посл.ww, wc: посл.wc });
      showToast('Тело возвращено', 'success', 1500);
      w.фон?.remove?.();   // окно результата закрывается вместе с возвратом тела
    });
    const стлКн = document.createElement('button');
    стлКн.textContent = 'Сохранить STL органа (мм)';
    стлКн.style.cssText = назад.style.cssText;
    стлКн.addEventListener('click', async () => {
      showToast('Строю поверхность органа по маске…', 'info', 2500);
      const r = await stlОргана({ индекс: с.индекс });
      if (!r.ок) { showToast(r.причина, 'warning', 4500); return; }
      отметитьЭкспорт('STL органа', r.имя, (r.sizeKb || 0) / 1024);
      showToast(`STL органа сохранён: ${r.треугольников.toLocaleString('ru-RU')} треуг., в миллиметрах`, 'success', 3000);
    });
    w.тело.appendChild(назад);
    w.тело.appendChild(стлКн);
    w.тело.appendChild(w.закрыть);
  });

  // [11.1.38] МОРФОЛОГИЯ МАСКИ — заливка контуров и достройка между срезами.
  // Повод: владелец обвёл селезёнку контуром в трёх проекциях и получил
  // 2,0 мл вместо ~840 см³. Программа считала верно — закрашена была
  // скорлупка. Обе операции работают на КОПИИ массива маски (Cornerstone 5
  // отдаёт копию) и кладут её обратно через organView.записатьМаску.
  const _осьПоПроекции = () => {
    // Заливать имеет смысл вдоль той оси, поперёк которой врач рисовал:
    // в аксиальном окне контур замкнут в плоскости XY (ось Z = 2).
    // Сагиттальные и корональные обводки замкнуты по своим осям — их
    // ось выбирается тем же списком; по умолчанию аксиальная.
    // [12.0.54] Ось — по КАМЕРЕ окна и осям ТОМА (maskMorph.осьПоНормали), а
    // не по имени окна: имя верно только для осевой КТ. У МРТ, снятой
    // сагиттально, «axial» лежит поперёк второй оси тома. По имени — только
    // запасной путь, если камеру не прочесть.
    const akt = String(window._mikhmelПоследнееОкно || '').toLowerCase();
    try {
      const re = getRenderingEngine?.();
      const vp = re?.getViewport?.(window._mikhmelПоследнееОкно || 'axial')
        || (re?.getViewports?.() || []).find((v) => v?.type === 'orthographic');
      const нормаль = vp?.getCamera?.()?.viewPlaneNormal;
      const м = томМаски();
      const dir = м?.том?.direction;
      if (нормаль && dir) return осьПоНормали(нормаль, dir);   // null — окно наклонено, скажет вызывающий
    } catch (e) { log.debug('[Сегментация] ось по камере не определилась:', e.message); }
    if (akt.includes('sagittal')) return 0;
    if (akt.includes('coronal')) return 1;
    return 2;
  };
  const _НАКЛОН = 'Окно наклонено к осям снимка — срезы маски в нём не лежат. Поверните окно к осевой, '
    + 'боковой или прямой проекции (сброс вида) и повторите';
  const _морфология = async (какая) => {
    const с = _активныйСегмент();
    const м = томМаски();
    if (м.ошибка) { showToast(м.ошибка, 'warning', 4500); return; }
    const пиксели = м.пиксели;
    const dims = Array.from(м.dims || []);
    const spacing = Array.from(м.spacing || [1, 1, 1]);
    const было = подсчётВокселей(пиксели, с.индекс);
    if (!было) { showToast(`Сегмент «${с.имя}» пуст — сначала обведите орган кистью`, 'warning', 4500); return; }
    const ось = _осьПоПроекции();
    if (ось == null) { showToast(_НАКЛОН, 'warning', 6000); return; }
    showToast(какая === 'заливка' ? 'Заливаю контуры…' : 'Достраиваю срезы между обводками…', 'info', 1500);
    let отчёт;
    try {
      отчёт = какая === 'заливка'
        ? залитьКонтуры(пиксели, dims, с.индекс, { ось })
        : интерполироватьСрезы(пиксели, dims, с.индекс, { ось });
    } catch (e) { showToast('Не вышло: ' + e.message, 'error', 4000); return; }
    // [11.1.40] Дельта для отмены запоминается ДО записи: «Вернуть маску»
    // откатывает ровно эту операцию, не трогая ручные мазки.
    запомнитьПравкуМаски(отчёт.изменённые || [], null,
      какая === 'заливка' ? 'заливка контуров' : 'достройка между срезами', отчёт.прежние || null);
    const зап = записатьМаску(пиксели);
    if (!зап.ок) { showToast(зап.причина, 'warning', 4500); return; }
    const стало = подсчётВокселей(пиксели, с.индекс);
    // [11.1.38.1] МОЙ ПРОМАХ, пойманный владельцем на живом: объёмМл имеет
    // подпись (данные, ИНДЕКС, spacing), а я звал её как (число, spacing) —
    // индексом уезжало количество вокселей, spacing уходил в никуда, и врач
    // видел «0.0 мл» при 14 371 закрашенном вокселе. Считаем по массиву.
    const мл = объёмМл(пиксели, с.индекс, spacing);
    const строки = [`Было вокселей: ${было.toLocaleString('ru-RU')} → стало ${стало.toLocaleString('ru-RU')}`,
      `Объём сегмента «${с.имя}»: <b>${мл.toFixed(1)} мл</b>`];
    if (какая === 'заливка') {
      строки.push(`Залито срезов: ${отчёт.срезов}`);
      if (отчёт.протекло.length) {
        строки.push(`<span style="color:#ffb4b4;">Не залито срезов: ${отчёт.протекло.length} — контур на них РАЗОМКНУТ `
          + `(номера: ${отчёт.протекло.slice(0, 12).join(', ')}${отчёт.протекло.length > 12 ? '…' : ''}). `
          + 'Замкните кольцо кистью и повторите — заливка через дыру вытекла бы на весь снимок.</span>');
      }
    } else {
      строки.push(`Ваших обводок: ${отчёт.срезов} · достроено промежутков: ${отчёт.пары}`);
      if (отчёт.пропущено.length) {
        строки.push(`<span style="color:#ffb4b4;">Пропущены слишком большие разрывы между срезами `
          + `${отчёт.пропущено.join(', ')} — это уже не интерполяция, а выдумывание органа. Обведите там ещё срез.</span>`);
      }
      строки.push('<span style="color:#8fa3c0;">Достроенное — геометрическая догадка между вашими обводками, не диагностическая правда. На резких изменениях формы обводите чаще.</span>');
    }
    const w = _окноРезультата(какая === 'заливка' ? 'Заливка контуров' : 'Достройка между срезами');
    w.тело.insertAdjacentHTML('beforeend', строки.map((т) => `<div style="margin-top:6px;">${т}</div>`).join(''));
    w.тело.appendChild(w.закрыть);
    showToast(`${какая === 'заливка' ? 'Залито' : 'Достроено'}: объём ${мл.toFixed(1)} мл`, 'success', 3000);
  };
  on('btn-seg-mask-undo', 'click', () => {
    const р = отменитьПравкуМаски();
    if (!р.ок) { showToast(р.причина, 'warning', 4000); return; }
    // [11.1.86] Говорим, сколько ступеней ОСТАЛОСЬ: с одной ступенью врач не
    // знал, можно ли отменять дальше, и потому боялся делать второй шаг.
    showToast(`Откатано: ${р.что} — ${р.вокселей.toLocaleString('ru-RU')} вокселей вернулись как было.`
      + (р.осталось ? ` Ещё можно отменить шагов: ${р.осталось}` : ' Отменять больше нечего'),
      'success', 4500);
    _обновитьПодписьОтмены();
  });

  // ══════════════════════════════════════════════════════════════
  //  [11.1.86] ДОВОДКА МАСКИ ПОСЛЕ АВТОШАГА
  //
  //  Слова владельца: «после любого автошага врачу нужно за минуту довести
  //  маску… у меня из набора есть заливка, достройка, рост области и отмена
  //  одной ступени — поэтому утёкший рост приходится откатывать целиком, а не
  //  подчищать».
  //
  //  Математика — src/core/maskClean.js, ноль импортов, проверяется числами в
  //  node. Здесь только клей: взять маску, позвать операцию, положить ступень
  //  отмены, показать ЦЕНУ шага. Цена обязательна: сглаживание съедает тонкие
  //  отростки, замыкание может слить соседние органы, «убрать острова» выбросит
  //  второй орган, если врач разметил два одним сегментом. Показать только
  //  результат и умолчать о цене значило бы соврать.
  // ══════════════════════════════════════════════════════════════

  const _подписьХода = (текст) => {
    const у = document.getElementById('mask-clean-hod');
    if (у) у.textContent = текст || '';
  };

  function _обновитьПодписьОтмены() {
    const к = document.getElementById('btn-seg-mask-undo');
    if (!к) return;
    const е = естьПравкаМаски();
    const подпись = к.querySelector('span.mask-undo-n');
    const текст = е ? ` (${е.ступеней})` : '';
    if (подпись) подпись.textContent = текст;
    else if (текст) k_добавить(к, текст);
    k_подсказка(к, е);
  }
  function k_добавить(к, текст) {
    const s = document.createElement('span');
    s.className = 'mask-undo-n'; s.textContent = текст;
    к.appendChild(s);
  }
  function k_подсказка(к, е) {
    к.title = е
      ? `Откатить последний шаг: ${е.что}. Запомнено шагов: ${е.ступеней} (${е.мб} МБ). `
        + 'Ручные мазки кистью не трогаются'
      : 'Откатить последний шаг с маской. Пока отменять нечего';
  }

  const _ммРадиус = () => Number(document.getElementById('mask-clean-radius')?.value) || 2;

  /** Общий путь для всех операций доводки: разница только в самой операции. */
  const _доводка = async (имя, сделать, {нуженСнимок = false} = {}) => {
    const с = _активныйСегмент();
    const м = томМаски();
    if (м.ошибка) { showToast(м.ошибка, 'warning', 4500); return; }
    const dims = Array.from(м.dims || []);
    const spacing = Array.from(м.spacing || [1, 1, 1]);
    const было = подсчётВокселей(м.пиксели, с.индекс);
    if (!было) {
      showToast(`Сегмент «${с.имя}» пуст — доводить нечего. Сначала разметка, потом доводка`, 'warning', 4500);
      return;
    }
    let яркость = null;
    if (нуженСнимок) {
      яркость = _пикселиСнимка(dims);
      if (!яркость) {
        // [12.0.54] На маске половинного шага сетки маски и снимка разные —
        // прежняя подсказка «исследование ещё грузится?» уводила не туда.
        const сетка = _сеткаСнимка();
        showToast(сетка && этоПолурешётка(dims, сетка)
          ? 'На маске половинного шага обвод по плотности не работает: у маски и снимка разные сетки. '
            + 'Нужна полная маска — снимите галочку «Маска ½ шага» и начните новую'
          : 'Пиксели снимка недоступны — обвод по плотности без них невозможен. Исследование ещё грузится?',
        'warning', 7000);
        return;
      }
    }
    _подписьХода(`${имя}…`);
    let отчёт;
    try { отчёт = сделать({ пиксели: м.пиксели, dims, spacing, индекс: с.индекс, яркость }); }
    catch (e) { _подписьХода(''); showToast('Не вышло: ' + e.message, 'error', 4500); return; }
    if (!отчёт) { _подписьХода(''); showToast(`${имя}: сегмент «${с.имя}» пуст`, 'warning', 4000); return; }
    if (отчёт.ошибка) { _подписьХода(''); showToast(`${имя}: ${отчёт.ошибка}`, 'warning', 6000); return; }
    if (!отчёт.изменённые?.length) {
      _подписьХода('ничего не изменилось');
      showToast(`${имя}: менять оказалось нечего — маска уже такая. Ступень отмены не заведена`, 'info', 4500);
      return;
    }
    запомнитьПравкуМаски(отчёт.изменённые, null, имя.toLowerCase(), отчёт.прежние || null);
    const зап = записатьМаску(м.пиксели);
    if (!зап.ок) { _подписьХода(''); showToast(зап.причина, 'warning', 4500); return; }
    const стало = подсчётВокселей(м.пиксели, с.индекс);
    const мл = объёмМл(м.пиксели, с.индекс, spacing);
    const дельта = стало - было;
    _подписьХода(`${имя}: ${мл.toFixed(1)} мл (${дельта >= 0 ? '+' : ''}${дельта.toLocaleString('ru-RU')} вокс.)`);
    _обновитьПодписьОтмены();
    return { отчёт, было, стало, мл, с, spacing };
  };

  /** [12.0.54] Размеры тома в срезовом окне — чтобы назвать причину отказа. */
  const _сеткаСнимка = () => {
    try {
      for (const vp of (getRenderingEngine?.()?.getViewports?.() || [])) {
        if (vp?.type === 'orthographic' && vp.getImageData?.()?.dimensions) return Array.from(vp.getImageData().dimensions);
      }
    } catch (e) { /* */ }
    return null;
  };

  /** [12.0.54] Модальность тома в срезовом окне (getImageData().metadata у Cornerstone 5). */
  const _модальностьСнимка = () => {
    try {
      for (const vp of (getRenderingEngine?.()?.getViewports?.() || [])) {
        if (vp?.type !== 'orthographic') continue;
        const м = vp.getImageData?.()?.metadata?.Modality;
        if (м) return м;
      }
    } catch (e) { /* */ }
    return null;
  };

  /** Пиксели снимка той же сетки, что маска — для обвода по плотности. */
  const _пикселиСнимка = (dims) => {
    try {
      const re = getRenderingEngine?.();
      for (const vp of (re?.getViewports?.() || [])) {
        if (vp?.type !== 'orthographic') continue;
        const и = vp.getImageData?.();
        const d = и?.dimensions;
        if (!d || d[0] !== dims[0] || d[1] !== dims[1] || d[2] !== dims[2]) continue;
        let п = null;
        try { п = и.voxelManager?.getCompleteScalarDataArray?.(); } catch (e) { п = null; }
        if (!п?.length) { try { п = и.scalarData; } catch (e) { п = null; } }
        if (п?.length) return п;
      }
    } catch (e) { /* скажем словами выше */ }
    return null;
  };

  on('btn-mask-smooth', 'click', async () => {
    const { сгладить } = await import('../core/maskClean.js');
    const и = await _доводка('Сглаживание',
      ({ пиксели, dims, spacing, индекс }) => сгладить(пиксели, dims, индекс, { ммРадиус: _ммРадиус(), spacing }));
    if (!и) return;
    showToast(`Сглажено радиусом ${_ммРадиус()} мм: добавлено ${и.отчёт.добавлено.toLocaleString('ru-RU')}, `
      + `снято ${и.отчёт.снято.toLocaleString('ru-RU')} вокселей. Объём ${и.мл.toFixed(1)} мл. `
      + 'Если у органа были тонкие отростки — их могло съесть; «Вернуть маску» отменит один этот шаг',
      'success', 9000);
  });

  on('btn-mask-close', 'click', async () => {
    const { замкнуть } = await import('../core/maskClean.js');
    const и = await _доводка('Замыкание',
      ({ пиксели, dims, spacing, индекс }) => замкнуть(пиксели, dims, индекс, { ммРадиус: _ммРадиус(), spacing }));
    if (!и) return;
    showToast(`Замкнуто радиусом ${_ммРадиус()} мм: добавлено ${и.отчёт.добавлено.toLocaleString('ru-RU')} вокселей, `
      + `объём ${и.мл.toFixed(1)} мл. Проверьте границу с соседним органом: щель уже двух радиусов замыкание сливает`,
      'success', 9000);
  });

  on('btn-mask-islands', 'click', async () => {
    const { убратьОстрова } = await import('../core/maskClean.js');
    const и = await _доводка('Уборка островов',
      ({ пиксели, dims, spacing, индекс }) => убратьОстрова(пиксели, dims, индекс,
        { толькоКрупнейшую: true, spacing }));
    if (!и) return;
    const о = и.отчёт;
    const млУбрано = о.убраноВокселей * о.млВокселя;
    showToast(`Частей было ${о.частей}, осталась одна. Убрано частей: ${о.убраноЧастей} `
      + `(${о.убраноВокселей.toLocaleString('ru-RU')} вокселей, ${млУбрано.toFixed(1)} мл; крупнейшая из убранных — `
      + `${о.самаяКрупнаяИзУбранных.toLocaleString('ru-RU')} вокселей). `
      + 'Если в сегменте законно было два органа, второй сейчас удалён — отмените', 'success', 11000);
  });

  on('btn-mask-holes', 'click', async () => {
    const { залитьДыры } = await import('../core/maskClean.js');
    const поСрезам = document.querySelector('input[name="mask-holes-mode"]:checked')?.value === 'срезы';
    if (поСрезам && _осьПоПроекции() == null) { showToast(_НАКЛОН, 'warning', 6000); return; }
    const и = await _доводка('Заливка дыр',
      ({ пиксели, dims, индекс }) => залитьДыры(пиксели, dims, индекс,
        { поСрезам, ось: _осьПоПроекции() }));
    if (!и) return;
    showToast(`Залито ${и.отчёт.добавлено.toLocaleString('ru-RU')} вокселей `
      + `${поСрезам ? 'по срезам' : 'объёмно'}, объём ${и.мл.toFixed(1)} мл.`
      + (поСрезам ? ' По срезам закрываются и полости, законно открытые в другую сторону — проверьте' : ''),
      'success', 9000);
  });

  on('btn-mask-density', 'click', async () => {
    const { обводПоПлотности } = await import('../core/maskClean.js');
    // [12.0.54] Полоса — 3 вокселя по самому мелкому шагу, по остальным осям те
    // же миллиметры (maskClean.полосаПоОсям): прежде 3 вокселя по всем осям
    // давали ±7,5 мм вверх-вниз на КТ с шагом срезов 2,5 мм.
    const и = await _доводка('Обвод по плотности',
      ({ пиксели, dims, spacing, индекс, яркость }) => обводПоПлотности(пиксели, яркость, dims, индекс, { полоса: 3, spacing }),
      { нуженСнимок: true });
    if (!и) return;
    const о = и.отчёт;
    // [12.0.54] «HU» — только у КТ: у МРТ и прочих это единицы яркости снимка.
    const модальность = String(_модальностьСнимка() || '').toUpperCase();
    const ед = (!модальность || модальность === 'CT') ? 'HU' : 'ед. яркости снимка';
    showToast(`Граница притянута к перепаду яркости. Диапазон взят из вашей же разметки: `
      + `${Math.round(о.низ)}…${Math.round(о.верх)} ${ед}. Добавлено ${о.добавлено.toLocaleString('ru-RU')}, `
      + `снято ${о.снято.toLocaleString('ru-RU')} вокселей; объём ${и.мл.toFixed(1)} мл. `
      + 'Там, где орган и сосед одной плотности, притягивать нечему — такие места остались как были',
      'success', 12000);
  });

  on('btn-mask-subtract', 'click', async () => {
    const { вычестьСегмент } = await import('../core/maskClean.js');
    const что = Number(document.getElementById('mask-subtract-from')?.value) || 0;
    const зазор = Number(document.getElementById('mask-subtract-gap')?.value);
    const и = await _доводка('Вычитание сегмента',
      ({ пиксели, dims, spacing, индекс }) => вычестьСегмент(пиксели, dims,
        { из: индекс, что, ммОтступ: Number.isFinite(зазор) ? зазор : 1, spacing,
          отступ: зазор === 0 ? 0 : undefined }));
    if (!и) return;
    showToast(`Из «${и.с.имя}» снято ${и.отчёт.снято.toLocaleString('ru-RU')} вокселей, `
      + `прилегавших к сегменту ${что} (зазор ${зазор} мм). Объём ${и.мл.toFixed(1)} мл`, 'success', 8000);
  });

  _обновитьПодписьОтмены();
  on('btn-seg-fill', 'click', () => _морфология('заливка'));
  on('btn-seg-interp', 'click', () => _морфология('интерполяция'));

  on('btn-seg-organ-stl', 'click', async () => {
    const с = _активныйСегмент();
    showToast(`Строю поверхность «${с.имя}» по маске…`, 'info', 2500);
    const r = await stlОргана({ индекс: с.индекс });
    if (!r.ок) { showToast(r.причина, 'warning', 4500); return; }
    отметитьЭкспорт('STL органа', r.имя, (r.sizeKb || 0) / 1024);
    showToast(`STL органа сохранён: ${r.треугольников.toLocaleString('ru-RU')} треуг., в миллиметрах`, 'success', 3000);
  });

  // Экспорт маски в NIfTI и очистка — двум кнопкам, у которых раньше не было
  // даже id, дана работа. Обе идут через уже существующие модули: маска
  // лежит в кэше томов Cornerstone, писатель NIfTI — в io/niftiModule.
  // [11.1.50] ИМПОРТ МАСКИ ИЗ .nii — мост к чужой автосегментации.
  on('btn-seg-import-nifti', 'click', () => {
    const поле = $('seg-import-file');
    if (!поле) { showToast('Поле выбора файла не найдено', 'error', 3000); return; }
    поле.value = '';        // чтобы повторный выбор ТОГО ЖЕ файла дал событие
    поле.click();
  });
  on('seg-import-file', 'change', async (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    const с = _активныйСегмент();
    try {
      // [11.1.53] Импорт отчитывается В ЖУРНАЛ, а не только тостами.
      // Тосты в файл не попадают: в журнале владельца между созданием холста
      // и первой ошибкой были 29 секунд полной тишины, и разбирать пришлось
      // по чужой отладочной строке голосового модуля.
      log.info(`[Импорт маски] файл «${файл.name}», ${(файл.size / 1048576).toFixed(1)} МБ, сегмент ${с.индекс}`);
      showToast(`Читаю ${файл.name}…`, 'info', 2000);
      let buffer = await файл.arrayBuffer();
      if (этоGzip(buffer)) {
        // .nii.gz распаковываем средствами браузера: своей библиотеки не
        // заводим ради одного формата. DecompressionStream есть во всех
        // современных браузерах; если нет — честный отказ, а не тишина.
        if (typeof DecompressionStream !== 'function') {
          showToast('Этот браузер не умеет распаковывать .nii.gz — сохраните из Slicer как .nii', 'warning', 6000);
          return;
        }
        const поток = new Blob([buffer]).stream().pipeThrough(new DecompressionStream('gzip'));
        buffer = await new Response(поток).arrayBuffer();
      }
      // [11.1.52] ХОЛСТ ЗАВОДИМ САМИ. Прежде здесь стоял отказ с советом
      // «возьмите кисть и мазните один раз»: человек нёс готовую разметку из
      // Slicer, а мы просили сперва порисовать от руки — только чтобы в
      // памяти появился пустой labelmap-том. Требование к пользователю
      // вместо работы. Теперь недостающий холст создаётся тем же
      // единственным путём, что и для кисти (toolManager.обеспечитьХолстМаски).
      let м = томМаски();
      if (м.ошибка && !getActiveSegmentationId()) {
        showToast('Холста ещё нет — готовлю под маску…', 'info', 2500);
        log.info('[Импорт маски] холста нет — готовлю');
        const готов = await обеспечитьХолстМаски();
        if (!готов) {
          log.warn('[Импорт маски] холст не создался — срезовых окон нет');
          showToast('Холст не создался: маске нужны срезовые окна — включите раскладку MPR с загруженной серией и повторите', 'warning', 7000);
          return;
        }
        м = томМаски();
      }
      if (м.ошибка) { log.warn('[Импорт маски] маска недоступна:', м.ошибка); showToast(м.ошибка, 'warning', 6000); return; }
      log.info(`[Импорт маски] маска исследования: сетка ${м.dims?.join?.('×')}, шаг ${м.spacing?.map?.((ч) => ч.toFixed(2)).join('×')}`);
      const р = прочитатьМаску(buffer, с.индекс);
      if (!р.ок) { log.warn('[Импорт маски] файл не прочитан:', р.причина); showToast(р.причина, 'error', 7000); return; }
      if (р.пусто) {
        // [11.1.89] ЗДЕСЬ БЫЛА ТИШИНА В ЖУРНАЛЕ, и она стоила владельцу часа.
        //
        // Его журнал обрывался ровно на предыдущей строке:
        //     [Импорт маски] маска исследования: сетка 512×512×808, шаг 0.74×…
        // и дальше — ничего. Ни ошибки, ни причины. Потому что эта ветка
        // говорила только плашкой, а плашку перекрывал наш же победный итог
        // «Разметка внесена в сегменты». Врач спросил «что я делаю
        // неправильно?» — ничего; молчал журнал.
        log.warn(`[Импорт маски] файл «${файл.name}» (${(файл.size / 1048576).toFixed(1)} МБ) `
          + `прочитан, сетка ${р.dims?.join?.('×')}, но размеченных вокселей в нём НЕТ — `
          + 'записывать нечего. Так бывает, когда разметка посчитана не по серии КТ, '
          + 'а по другому файлу, или когда сеть не нашла орган в поданном объёме');
        showToast(`В файле «${файл.name}» нет ни одного размеченного вокселя — `
          + 'записывать нечего. Причина в журнале строкой «[Импорт маски]»', 'error', 12000);
        return;
      }
      // [11.1.70] СНАЧАЛА ОТКРЫТЬ СВОЮ СЕРИЮ, А ПОТОМ СВЕРЯТЬ.
      //
      // ЧТО БЫЛО. Владелец сделал маску на серии 818 срезов, открыл серию 661 и
      // импортировал — маска легла криво, «съехала везде». Сверка сеток при
      // этом не отказала, и вот почему: она сравнивала файл с ХОЛСТОМ, а холст
      // остался от прежней серии, тоже 818. То есть 818 сверялось с 818, всё
      // сходилось, и маска писалась в холст, к открытой серии не относящийся.
      //
      // Сверять надо было с ОТКРЫТЫМ ИССЛЕДОВАНИЕМ, а не с холстом: холст —
      // производное, он может быть от чего угодно.
      //
      // Но владелец потребовал большего, и он прав: «должна открыться именно
      // эта серия». Отказ переложил бы работу на человека — вспоминать, где
      // чья маска, искать серию в списке, переключать. Программа это может
      // сама, если знает, куда идти. Теперь знает: метку пишет экспорт.
      const метка = прочитатьМетку(buffer);
      if (метка?.seriesUID) {
        const сейчас = _ctx?.getCurrentSeries?.();
        if (сейчас && метка.seriesUID !== сейчас) {
          const есть = (_ctx?.getAllSeries?.() || []).some((с) => с.seriesUID === метка.seriesUID);
          if (!есть) {
            log.warn(`[Импорт маски] серия метки ${метка.seriesUID} не найдена среди открытых`);
            showToast(`Эта маска сделана на серии «${метка.описание || метка.seriesUID}», `
              + 'а её нет среди загруженных. Откройте это исследование и повторите', 'error', 12000);
            return;
          }
          log.info(`[Импорт маски] маска от другой серии — открываю «${метка.описание || метка.seriesUID}»`);
          showToast(`Маска сделана на серии «${метка.описание || метка.seriesUID}» — открываю её…`, 'info', 5000);
          const открыть = window.MikhmelViewer?.loadSeriesIntoViewport;
          if (typeof открыть !== 'function') {
            showToast('Не удалось переключить серию: обработчик недоступен. '
              + `Откройте серию «${метка.описание || метка.seriesUID}» вручную и повторите`, 'error', 12000);
            return;
          }
          await открыть(метка.seriesUID);
          // Холст теперь принадлежит ДРУГОЙ серии; берём его заново — при
          // расхождении сеток он пересоздастся сам (см. [11.1.66]).
          if (!await обеспечитьХолстМаски()) {
            showToast('Серия открыта, но холст под маску не создался. Повторите импорт', 'warning', 8000);
            return;
          }
          м = томМаски();
          if (м.ошибка) { showToast(м.ошибка, 'warning', 6000); return; }
          log.info(`[Импорт маски] после переключения: сетка ${м.dims?.join?.('×')}`);
        }
      } else {
        // Старые файлы — те, что выгружены до этой версии, — метки не имеют.
        // Для них остаётся сверка по сеткам, но с подсказкой, что делать.
        log.info('[Импорт маски] метки серии в файле нет (чужая программа или наш файл до 11.1.70) — сверяю только сетки');   // [12.0.54] уточнено
      }

      // [11.1.71] СВЕРЯЕМ С ОТКРЫТЫМ ИССЛЕДОВАНИЕМ, А НЕ С ХОЛСТОМ.
      //
      // Вчера я это назвал и НЕ СДЕЛАЛ: в 11.1.70 добавил переключение серии по
      // метке, а саму сверку на окно не перевёл. Для файлов БЕЗ метки — а их
      // отдаёт, например, TotalSegmentator, он о нашем формате не знает, —
      // дыра осталась открытой: файл сравнивался с холстом, холст мог быть от
      // прежней серии, и совпадение 818 с 818 пропускало чужую маску.
      //
      // Правда одна — сетка тома в срезовых окнах. Холст производен от неё; при
      // расхождении он пересоздаётся сам (см. [11.1.66]), но полагаться на это
      // при сверке нельзя: сверка обязана смотреть на исследование.
      const сеткаОкна = (() => {
        try {
          for (const vp of (getRenderingEngine()?.getViewports?.() || [])) {
            if (vp?.type !== 'orthographic' || !vp.element) continue;
            const и = vp.getImageData?.();
            if (и?.dimensions) return { dims: и.dimensions, spacing: и.spacing };
          }
        } catch (e) { log.debug('[Импорт маски] сетку окна не прочесть:', e.message); }
        return null;
      })();
      // [12.0.54] Сама сверка с окном — НИЖЕ, после разворота: у файла с
      // переставленными осями (сагиттальная МРТ из другой программы) размеры
      // идут в другом порядке, и сверка «как есть» отказывала верному файлу.

      // [11.1.76] РАЗВЕРНУТЬ ЧУЖУЮ МАСКУ ПОД НАШ ТОМ.
      //
      // Жалоба владельца: «в сагиттальной проекции маска легла на 180
      // горизонтально в другую сторону». Файл от TotalSegmentator, сетка
      // сошлась, импорт доложил «готово» — а лежала зеркально.
      //
      // Причина: в niftiRead записано «матрицы поворота разбираются, но НЕ
      // применяются», и на деле они даже не читались. Для НАШИХ файлов это
      // неважно — они в той же раскладке. Чужой написан в своей, и маска
      // ложится зеркально МОЛЧА: сетка та же, объём правдоподобный, орган не
      // на месте. Это опаснее отказа.
      //
      // Числа владельца: файл ('L','A','S'), наш том ('L','P','S'). Разница в
      // одной оси — у файла вторая смотрит вперёд, у нас назад. Отсюда и
      // картина: в сагиттальной горизонталь это и есть ось «вперёд-назад», там
      // зеркало видно; в коронарной её нет вовсе, потому она и была верна.
      let рМаска = р.пиксели;
      let рDims = р.dims;
      let рSpacing = р.spacing;   // [12.0.54] шаг переставляется вместе с осями
      try {
        const ор = await import('../core/niftiOrient.js');
        const мат = ор.матрицаRAS(buffer);
        if (!мат) {
          log.warn('[Импорт маски] в файле нет матрицы ориентации (sform/qform) — '
            + 'кладу как есть; если маска ляжет зеркально, дело в этом');
        } else {
          const осиФайла = ор.осиИзМатрицы(мат.m, true);
          const осиНашего = ор.осиТома(м.том?.direction);
          const план = ор.планРазворота(осиФайла, осиНашего);
          log.info(`[Импорт маски] ориентация: файл ${осиФайла.join('')} (${мат.откуда}), `
            + `том ${осиНашего.join('')}`);
          if (!план.ок) {
            showToast(`Ориентацию файла (${осиФайла.join('')}) не удалось привести к тому `
              + `(${осиНашего.join('')}): ${план.причина}. Класть нельзя — маска ляжет мимо`, 'error', 12000);
            return;
          }
          if (план.надо) {
            const рв = ор.развернуть(р.пиксели, р.dims, план.план);
            if (!рв.ок) { showToast('Разворот маски не удался: ' + рв.причина, 'error', 9000); return; }
            рМаска = рв.пиксели;
            рDims = рв.dims;
            рSpacing = план.план.map((п) => р.spacing[п.изОси]);
            log.info(`[Импорт маски] маска развёрнута под том: ${ор.планСловами(план.план)}, `
              + `сетка ${р.dims.join('×')} → ${рв.dims.join('×')}`);
            showToast(`Маска развёрнута под ориентацию исследования (${осиФайла.join('')} → ${осиНашего.join('')})`, 'info', 5000);
          } else {
            log.info('[Импорт маски] ориентации совпадают — разворот не нужен');
          }
        }
      } catch (eОр) {
        log.warn('[Импорт маски] ориентация не проверена:', eОр.message);
      }

      if (сеткаОкна) {
        const сОкном = сеткиСовпадают(рDims, рSpacing, сеткаОкна.dims, сеткаОкна.spacing);
        if (!сОкном.ок) {
          log.warn(`[Импорт маски] файл ${рDims.join('×')} не сходится с ОТКРЫТЫМ исследованием `
            + `${сеткаОкна.dims.join('×')}: ${сОкном.причина}`);
          showToast(`Маска не от этого исследования: в файле ${рDims.join('×')}, `
            + `открыто ${сеткаОкна.dims.join('×')}. Откройте нужную серию и повторите`, 'error', 12000);
          return;
        }
        log.info(`[Импорт маски] сетка файла сошлась с открытым исследованием ${сеткаОкна.dims.join('×')}`);
        // [12.0.54] Файл полного размера, а холст — половинного шага: прежде
        // это кончалось «Сетки разные… маска от другой серии», что неправда.
        if (этоПолурешётка(м.dims, сеткаОкна.dims)) {
          showToast('Маска этого исследования заведена с половинным шагом, а файл — полного размера: '
            + 'положить его в такую маску нельзя. Снимите галочку «Маска ½ шага», обновите страницу и повторите импорт', 'error', 12000);
          return;
        }
      } else {
        log.warn('[Импорт маски] срезовых окон нет — сверяю только с холстом');
      }
      const сверка = сеткиСовпадают(рDims, рSpacing, м.dims, м.spacing);
      if (!сверка.ок) {
        log.warn('[Импорт маски] сетки не сошлись:', сверка.причина);
        showToast(сверка.причина + (метка ? '' : ' В файле нет метки серии (выгружен до 11.1.70) — '
          + `откройте серию с ${р.dims[2]} срезами и повторите.`), 'error', 12000);
        return;
      }
      // [11.1.76] Дальше работаем с РАЗВЁРНУТОЙ маской. Прежде здесь стояло
      // р.пиксели — то есть развернуть развернул, а записал бы прежнее. Ровно
      // та половина работы, за которую владелец меня и ругает.
      if (рМаска.length !== м.пиксели.length) {
        showToast('Размер файла не сошёлся с маской исследования', 'error', 6000); return;
      }
      // Дельта для отмены — как у заливки: «Вернуть маску» откатит импорт.
      // РАЗВЁРНУТАЯ маска двоичная (0/1), а не с номерами сегментов: разворот
      // приводит к единицам. Поэтому сравниваем с единицей, а не с с.индекс.
      const развёрнута = рМаска !== р.пиксели;
      const искать = развёрнута ? 1 : с.индекс;
      const изменённые = []; const прежние = [];
      for (let i = 0; i < рМаска.length; i++) {
        if (рМаска[i] === искать && м.пиксели[i] !== с.индекс) { изменённые.push(i); прежние.push(м.пиксели[i]); }
      }
      запомнитьПравкуМаски(изменённые, null, `импорт «${файл.name}»`, прежние);
      for (const i of изменённые) м.пиксели[i] = с.индекс;
      const зап = записатьМаску(м.пиксели);
      if (!зап.ок) { showToast(зап.причина, 'error', 6000); return; }
      const мл = объёмМл(м.пиксели, с.индекс, м.spacing);
      const w = _окноРезультата('Импорт маски');
      w.тело.insertAdjacentHTML('beforeend',
        [`Файл: <b>${файл.name}</b> · тип ${р.тип} · сетка ${р.dims.join('×')}`,
         `Размечено в файле: ${р.ненулевых.toLocaleString('ru-RU')} вокселей`,
         // [12.0.54] Файл с несколькими органами (у TotalSegmentator — общий
         // файл со всеми метками) ложится ЦЕЛИКОМ в один сегмент. Так было и
         // раньше, но молча.
         р.меток > 1 ? `<span style="color:#ffb4b4;">В файле ${р.меток} разных меток (несколько органов) — `
           + `все легли в один сегмент «${с.имя}». Чтобы разнести органы по сегментам, загружайте их отдельными файлами</span>` : '',
         `Добавлено в сегмент «${с.имя}»: ${изменённые.length.toLocaleString('ru-RU')}`,
         `Объём сегмента: <b>${мл.toFixed(1)} мл</b>`,
         сверка.тревога ? `<span style="color:#ffb4b4;">${сверка.тревога}</span>` : '',
         '<span style="color:#8fa3c0;">Не то загрузилось — «Вернуть маску» в этой же панели.</span>',
        ].filter(Boolean).map((т) => `<div style="margin-top:6px;">${т}</div>`).join(''));
      w.тело.appendChild(w.закрыть);
      log.info(`[Импорт маски] готово: добавлено вокселей ${изменённые.length}, объём сегмента ${мл.toFixed(1)} мл`);
      // [12.0.28] Файл назван по структуре (так называет их TotalSegmentator:
      // liver.nii.gz) — записываем в реестр, и органные кнопки 3D возьмут
      // ЭТУ разметку вместо того, чтобы гнать грубую модель заново.
      const органФайла = органИзИмениФайла(файл.name, КЛАССЫ_ОРГАНОВ);
      if (органФайла && мл > 0) {   // и при повторном импорте того же файла — сегмент ведь не пуст
        отметитьОрган(органФайла, с.индекс, { источник: 'файл', модель: null, шагМм: null, segId: getActiveSegmentationId() });
        log.info(`[Импорт маски] ${органФайла} → сегмент ${с.индекс}: записано в реестр органов`);
      }
      showToast(`Маска загружена: ${мл.toFixed(1)} мл`, 'success', 3500);
    } catch (err) {
      log.warn('[Импорт маски] сорвался:', err.message);
      showToast('Импорт не вышел: ' + err.message, 'error', 6000);
    }
  });

  on('btn-seg-export-nifti', 'click', async () => {
    const segId = getActiveSegmentationId();
    if (!segId) { showToast('Сегментации ещё нет: возьмите кисть и проведите по снимку', 'info', 3500); return; }
    try {
      // [11.1.45] ВТОРАЯ ДОРОГА К МАСКЕ ПОХОРОНЕНА: своя копия старого поиска
      // (Labelmap.volumeId пустует в Cornerstone 5) — NIfTI говорил «маска не
      // найдена», когда STL уже работал. Хозяин один — томМаски().
      const м = томМаски();
      if (м.ошибка) { showToast(м.ошибка, 'warning', 3500); return; }
      const пиксели = м.пиксели;
      if (!пиксели?.length) { showToast('Маска пуста: рисовать ещё нечего', 'info', 3000); return; }
      const { exportToNifti } = await import('../io/niftiModule.js');
      // [11.1.70] В ФАЙЛ ПИШЕТСЯ, ОТКУДА МАСКА.
      //
      // Слова владельца: «я делал эту маску на 818 срезах, значит после импорта
      // должна открыться именно эта серия». До этой версии в файле не было
      // НИЧЕГО о серии, и человек должен был помнить это сам. По числу срезов
      // не угадать: серий с одинаковой сеткой в исследовании бывает несколько.
      const { собратьМетку } = await import('../io/niftiCore.js');
      const серияUID = _ctx?.getCurrentSeries?.() || '';
      const описание = (_ctx?.getAllSeries?.() || [])
        .find((с) => с.seriesUID === серияUID)?.seriesDesc || '';
      const метка = серияUID ? собратьМетку(серияUID, описание) : null;
      if (!метка) log.warn('[Экспорт NIfTI] серия не определилась — файл уйдёт без метки');
      // [12.0.54] И ПОЛОЖЕНИЕ В ТЕЛЕ (sform/qform) — без него 3D Slicer и
      // ITK-SNAP ставили маску в начало координат, мимо снимка (niftiCore.аффинRAS).
      const геометрия = (м.том?.origin && м.том?.direction)
        ? { origin: Array.from(м.том.origin), direction: Array.from(м.том.direction) } : null;
      if (!геометрия) log.warn('[Экспорт NIfTI] положение тома не прочиталось — файл уйдёт без sform/qform');
      exportToNifti(пиксели, м.dims, м.spacing, `segmentation_${Date.now()}.nii`, метка, геометрия);
      showToast(метка
        ? 'Маска сохранена. В файл записано, к какой серии она относится'
        : 'Маска сохранена, но серию определить не удалось — метки в файле нет',
        метка ? 'success' : 'warning', 4000);
    } catch (e) {
      log.warn('[Сегментация] экспорт NIfTI:', e.message);
      showToast('Экспорт маски не удался: ' + e.message, 'error', 4000);
    }
  });

  /** [12.0.54] Есть ли в маске хоть один размеченный воксель (любого сегмента). */
  const подсчётВокселейВсех = (п) => { for (let i = 0; i < п.length; i++) if (п[i]) return true; return false; };

  on('btn-seg-clear', 'click', () => {
    const segId = getActiveSegmentationId();
    if (!segId) { showToast('Стирать нечего: сегментации ещё нет', 'info', 3000); return; }
    try {
      // [12.0.54] «ОЧИСТИТЬ» НЕ СТИРАЛО НИЧЕГО. Том маски искался через
      // window.cornerstone, а программа это имя не выставляет (как и
      // window.cornerstoneTools — см. toolsBindings [11.1.18]). Поиск давал
      // пусто, и на размеченной маске врач видел «Маска пуста — стирать
      // нечего». На стенде: 3 556 вокселей в маске — ответ тот же. Хозяин
      // маски один — томМаски/записатьМаску, как у всех кнопок вкладки.
      const м = томМаски();
      if (м.ошибка) { showToast(м.ошибка, 'warning', 4000); return; }
      const пиксели = м.пиксели;
      if (!пиксели?.length || !подсчётВокселейВсех(пиксели)) { showToast('Маска пуста — стирать нечего', 'info', 2500); return; }
      // [12.0.54] Спросить: стирание ВСЕХ сегментов не отменяется, а кнопка
      // стоит в одном ряду с «Экспорт» — промахнуться легко. Удаление строки
      // сегмента спрашивало всегда, стирание всей работы — нет.
      if (!confirm('Стереть ВСЮ маску — все сегменты сразу? Отменить это будет нельзя. Сохранить работу можно кнопкой «Экспорт NIFTI».')) return;
      пиксели.fill(0);
      const зап = записатьМаску(пиксели);
      if (!зап.ок) { showToast('Очистить маску не удалось: ' + зап.причина, 'error', 5000); return; }
      забытьМазки();
      _updateUndoRedoButtons();
      // [11.1.86] Ступени отмены забываем: они хранят прежние значения ДО
      // стирания, и наложить их на стёртую маску значило бы «отменой» вернуть
      // обрывки прежней работы поверх пустоты. Лучше честно сказать, что
      // отменять больше нечего.
      const забыто = забытьПравкиМаски();
      _обновитьПодписьОтмены();
      showToast('Маска сегментации стёрта'
        + (забыто ? `. Ступеней отмены забыто: ${забыто} — стирание не отменяется` : ''),
        'success', забыто ? 5000 : 2000);
    } catch (e) {
      log.warn('[Сегментация] очистка:', e.message);
      showToast('Очистить маску не удалось: ' + e.message, 'error', 4000);
    }
  });

  on('btn-add-seg', 'click', () => {
    const list = $('segment-list'); if (!list) return;
    // [12.0.54] Свой список цветов (красный, зелёный, синий, жёлтый…) снят:
    // маску красит движок своей таблицей — кружок берётся из неё (segColors).
    // [11.1.21] Номер — max существующих + 1, а не length: после удалений
    // length врал и раздавал занятые номера. Подпись — по-русски: «Segment N»
    // из JS-строки проскакивал мимо русскоязычного сторожа, который читает
    // только разметку (аудит §2.3). Слушателей на строку не вешаем — всё
    // делает делегат списка выше.
    const занятые = [...list.querySelectorAll('.seg-row')].map((r) => Number(r.dataset.segIndex) || 0);
    const индекс = (занятые.length ? Math.max(...занятые) : 0) + 1;
    const div = document.createElement('div');
    div.className = 'seg-row';
    div.dataset.segIndex = String(индекс);
    div.innerHTML = `<div class="seg-color" style="background:${цветСегмента(индекс)};"></div><span class="seg-label">Сегмент ${индекс}</span><button class="ann-del-btn"><svg class="ico" aria-hidden="true"><use href="#i-x"/></svg></button>`;
    list.appendChild(div);
  });
  // [11.1.21] Прежние onAll по статичным строкам и крестикам СНЯТЫ — их
  // работу целиком забрал делегат списка (см. выше): у active был бы третий
  // хозяин, а у крестиков — удаление без предупреждения о мазках.
  // [12.0.54] «↩ Отмена / ↪ Повтор» — МАЗКИ КИСТИ. Прежде здесь звались
  // undoAnnotation/redoAnnotation — отмена ЗАМЕРОВ: мазков в ней нет, и на
  // стенде после двух мазков «Отмена» отвечала «Нечего отменять». Откат
  // заливки, доводки и импорта — «Вернуть маску» (своя стопка, organView).
  on('btn-seg-undo', 'click', () => отменитьМазокКисти());
  on('btn-seg-redo', 'click', () => повторитьМазокКисти());
  _updateUndoRedoButtons();
  // Подсказка с числом мазков — по знаку от toolManager: мазок записан.
  document.addEventListener('mikhmel-мазок', () => _updateUndoRedoButtons(), { signal: _getSignal() });

  // Запускаем подписку на события аннотаций
  bindAnnotationEvents();
  bindUndoRedoKeys();
}

// ============================================================
// AI
// ============================================================
function bindAI() {
  // [10.19.29] «Проверить модели» — перенесена из Enterprise-панели в саму
  // вкладку ИИ: спрашивать про модели естественно там, где ими пользуются.
  // Показ окном, а не всплывающей плашкой на 15 секунд: список из шести строк
  // за это время не прочитать, а прокрутить плашку нельзя.
  // [11.1.29] УКАЗАТЕЛЬ ВЛАДЕНИЯ (аудит §2.4): btn-ai-release обрабатывается в
  // proFeaturesBindings (bindAI), «Прогрев» — там же (bindAIControls), «Лёгкие
  // автоматом» — в clinicalTools рядом с печенью. [12.0.56] btn-ai-export-stl и
  // btn-ai-detect-body удалены вместе с карточками. Двойных слушателей нет — пин
  // verify_11_1_29 пересчитывает on(«id») по всему src и требует ровно одного.
  on('btn-ai-check-models', 'click', async () => {
    showToast('Проверяю модели…', 'info', 1500);
    try {
      const m = await import('../ai/aiModule.js');
      const текст = await m.сводкаПоМоделям();
      const фон = document.createElement('div');
      фон.style.cssText = 'position:fixed;inset:0;z-index:60000;background:rgba(5,8,14,0.72);display:flex;align-items:center;justify-content:center;padding:14px;';
      const к = document.createElement('div');
      к.style.cssText = 'max-width:640px;width:100%;max-height:88vh;overflow:auto;background:#0f1420;border:1px solid #2a3546;border-radius:14px;padding:16px;color:#dbe6f5;font-size:13px;line-height:1.6;white-space:pre-line;user-select:text;';
      к.textContent = текст;
      const закр = document.createElement('button');
      закр.textContent = 'Закрыть';
      закр.style.cssText = 'margin-top:12px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;';
      закр.addEventListener('click', () => фон.remove());
      к.appendChild(закр);
      фон.appendChild(к);
      фон.addEventListener('click', (e) => { if (e.target === фон) фон.remove(); });
      document.body.appendChild(фон);
    } catch (e) {
      showToast('Проверка моделей не удалась: ' + e.message, 'error', 6000);
    }
  });

  // [10.19.26] Кнопки-перехода btn-open-cinematic больше нет: кинематика
  // объединена с «Объём 3D» в один раздел, как и просили, — переходить некуда.
  // Контейнер #tab-cinematic остался ВНУТРИ вкладки: «Сброс» ниже находит его
  // ползунки и списки по тому же id, что и раньше.

  // [10.19.24] «Движок» ИИ (ai-backend) БЫЛ ПУСТЫШКОЙ: список рисовался, выбор
  // никуда не шёл. Теперь выбор сохраняется, ortLoader читает его при подъёме
  // рантайма (см. cinematic10/ortLoader.js), а надпись говорит правду: рантайм
  // ONNX поднимается один на страницу, поэтому смена движка вступает в силу при
  // следующей загрузке страницы — врать «переключено» мгновенным тостом нельзя.
  {
    const сп = $('ai-backend');
    if (сп) {
      try {
        const сохранён = localStorage.getItem('mikhmel.ortBackend');
        if (сохранён && [...сп.options].some((o) => o.value === сохранён)) сп.value = сохранён;
      } catch (e) { log.debug('[ИИ/движок]', e.message); }
      сп.addEventListener('change', () => {
        try { localStorage.setItem('mikhmel.ortBackend', сп.value); } catch (e) { log.debug('[ИИ/движок]', e.message); }
        const текущий = getOrtBackend?.();
        if (текущий && текущий !== сп.value) {
          showToast(`Выбор запомнен: ${сп.value.toUpperCase()}. Сейчас работает ${текущий.toUpperCase()}; `
            + 'рантайм ONNX один на страницу, смена вступит в силу после перезагрузки страницы.', 'info', 7000);
        } else {
          showToast(`Движок ИИ: ${сп.value.toUpperCase()}. Применится при первом запуске ИИ.`, 'success', 4000);
        }
      });
    }
  }

  // [10.19.24] «Авто-наложение» оживлялось флагом для applyLabelMapToCornerstone.
  // [12.0.56] «Авто-наложение» (ai-auto-overlay) УДАЛЕНО: его читала одна точка —
  // наложение маски лёгких в отдельную сегментацию, которой больше нет. Маски
  // сетей ложатся в сегменты «Сегментации»; спрятать их — «Прозрачность» там же.

  // [12.0.56] ОБЩИЙ РОУТЕР КАРТОЧЕК ИИ (.ai-run-btn[data-model]) УДАЛЁН вместе с
  // карточками. Он гнал «Органы», «Лёгкие», «Мозг», «Сердце», «RT контур», «Узлы
  // лёгких» и «Инсульт» через пороговые «алгоритмы», даже когда файл модели лежал:
  // органы — гистограмма HU всего тома, подписанная именами органов; лёгкие — поле
  // lungs, которого нет (всегда «не выделены»); мозг — те же пороги по всему тому;
  // «RT контур» — счёт вокселей −100…200 HU; «Инсульт» — разница средних HU
  // половин кадра. Настоящие сети вкладки ИИ (MedSAM, лёгкие, печень, органы)
  // привязаны к своим кнопкам в ui/clinicalTools.js.
}

// ============================================================
// CINEMATIC RENDERING
// ============================================================
/**
 * [10.19.12] «Качество» → длинная сторона кадра в пикселях.
 * Ровно те числа, что написаны в списке: 256 / 512 / 1024 / 2048.
 */
const КАЧЕСТВО_В_ПИКСЕЛИ = { preview: 256, draft: 512, high: 1024, ultra: 2048 };

/**
 * [10.19.12] «Освещение» → расстановка источников света рендерера.
 *
 * Освещение в кинематографическом рендеринге — это лампы (setLights), а не
 * набор пост-эффектов, поэтому выбор идёт сюда. Координаты в системе сцены,
 * intensity — яркость, radius — мягкость (чем больше, тем шире полутень).
 */
const СВЕТ = {
  studio:   [{ position: [3, 3, 4],  intensity: 1.0, color: [1, 0.96, 0.9],  radius: 14 },
             { position: [-4, 1, 2], intensity: 0.35, color: [0.85, 0.9, 1], radius: 18 }],
  surgical: [{ position: [0, 4, 1],  intensity: 1.6, color: [1, 1, 1],       radius: 8 }],
  dramatic: [{ position: [5, 2, 1],  intensity: 1.4, color: [1, 0.9, 0.75],  radius: 6 }],
  outdoor:  [{ position: [2, 6, 3],  intensity: 1.1, color: [1, 0.97, 0.88], radius: 20 },
             { position: [-3, 4, -2], intensity: 0.5, color: [0.7, 0.82, 1], radius: 25 }],
};

/**
 * [10.19.12] «Перенос» → настоящий идентификатор объёмного пресета (КТ).
 *
 * [10.19.14] МР-пункты сюда НЕ входят намеренно: у МРТ нет единиц Хаунсфилда, и
 * фиксированный пресет на другой серии дал бы другую картинку. Они идут через
 * `применитьМРПеренос`, который считает окно по гистограмме этой серии.
 */
const ПЕРЕНОС_В_ПРЕСЕТ = { ct_default: 'ct-overview', ct_bone: 'ct-bone-clean', ct_vessels: 'ct-vascular' };

/** [10.19.14] МР-переносы: считаются по гистограмме серии (core/mrNormalize.js). */
const ПЕРЕНОС_МР = { 'mr-brain': 'МР мозг', 'mr-vessels': 'МР сосуды TOF', 'mr-overview': 'МР обзор' };

/** Полоса прогресса кинематографического рендера. */
function _прогрессРендера(доля, подпись) {
  const bar = $('render-progress-bar'), val = $('render-progress-val');
  const проц = Math.max(0, Math.min(100, Math.round(доля * 100)));
  if (bar) bar.style.width = проц + '%';
  if (val) val.textContent = подпись || (проц + '%');
}

/**
 * Дождаться НАСТОЯЩЕГО кадра: счётчик кадров рендерера обязан вырасти.
 *
 * Именно здесь ловится разница между «включили» и «рисует». До 10.19.12 панель
 * ставила 100% и писала «Done» сразу после вызова, ничего не проверяя, — и на
 * машине врача это выглядело как успешный рендер при пустой полосе прогресса.
 */
function _ждатьКадрРендера(cr, ждатьМс = 8000) {
  return new Promise((resolve) => {
    const было = cr.getMetrics?.()?.totalFrames || 0;
    const t0 = Date.now();
    const тик = () => {
      const стало = cr.getMetrics?.()?.totalFrames || 0;
      if (стало > было) return resolve(стало - было);
      if (Date.now() - t0 > ждатьМс) return resolve(0);
      setTimeout(тик, 200);
    };
    тик();
  });
}

function bindCinematic() {
  let _идёт = false;

  /** Настройки из правой панели — один источник для всех кнопок. */
  /**
   * [10.19.18] Переключатели «AO» и «Тени» — по факту наличия карты глубины.
   *
   * ПОВОД. В 10.19.17 они были выключены НАСМЕРТЬ прямо в разметке: глубины не
   * существовало, и включать было нечего. Теперь глубина считается по объёму, и
   * состояние переключателей обязано следовать за фактом, а не за моим
   * предположением полугодовой давности. Подпись под ними — тоже: она либо
   * называет числа, либо называет причину отказа.
   */
  const обновитьГлубинуВПанели = (д) => {
    const ao = $('render-ao');
    const тени = $('render-shadows');
    const плашка = $('render-depth-note');
    const есть = !!д?.isUsingRealDepth;
    for (const кн of [ao, тени]) {
      if (!кн) continue;
      кн.disabled = !есть;
      кн.setAttribute('aria-disabled', есть ? 'false' : 'true');
      кн.title = есть ? 'Затенение по карте глубины' : (д?.причина || 'Карта глубины пока не посчитана');
      if (!есть) { кн.classList.remove('on'); кн.setAttribute('aria-checked', 'false'); }
    }
    if (плашка) {
      // [10.19.21] Доля нормалей — тем же языком чисел: 0% при живой глубине
      // значит, что полусферный SSAO и N·L честно работают старым путём.
      const нормали = есть && д.доляНормалей > 0
        ? `, нормалей ${((д.доляНормалей || 0) * 100).toFixed(0)}%`
        : '';
      плашка.textContent = есть
        ? `Карта глубины посчитана по объёму окна: ${д.размер || '?'}, попаданий `
          + `${((д.доляПопаданий || 0) * 100).toFixed(0)}%${нормали}, ${Math.round(д.extractionTimeMs || 0)} мс. `
          + 'Затенение и тени работают по ней, а не по яркости картинки.'
        : `Затенение и тени требуют карты глубины. Сейчас её нет: ${д?.причина || 'причина не названа'}.`;
    }
  };
  on_(EVENTS.DEPTH_UPDATED, обновитьГлубинуВПанели);
  // Первый опрос: событие могло пройти до того, как панель подписалась.
  import('../rendering/depthExtractor.js')
    .then((м) => обновитьГлубинуВПанели(м.getDepthDiagnostics()))
    .catch(() => { /* модуль не загрузился — плашка останется исходной */ });

  const изПанели = () => ({
    качество: $('render-quality')?.value || 'high',
    освещение: $('render-lighting')?.value || 'studio',
    перенос: $('render-tf')?.value || 'ct_default',
    ao: !!$('render-ao')?.classList.contains('on'),
    тени: !!$('render-shadows')?.classList.contains('on'),
    прогресс: _прогрессРендера,
  });

  // [12.0.51] Настройки — НА ХОДУ. «Качество», «Освещение», «Перенос», AO и
  // тени читались только кнопкой «Рендер»: при идущем рендере их смена не
  // меняла ничего, пока врач не нажмёт «Рендер» ещё раз. Теперь меняется
  // только то, что тронули. Рендер не идёт — настройки дождутся «Рендер».
  // AO и тени: их щелчок ведёт общий перещёлкиватель (bindToggles), он
  // срабатывает раньше; здесь читаем уже новое состояние — в следующем кадре.
  for (const [ид, событие, часть] of [
    ['render-quality', 'change', 'качество'], ['render-lighting', 'change', 'свет'],
    ['render-tf', 'change', 'перенос'], ['render-ao', 'click', 'глубина'], ['render-shadows', 'click', 'глубина'],
  ]) {
    on(ид, событие, () => { setTimeout(() => применитьНастройкиКино(изПанели(), часть), 0); });
  }

  on('btn-render-start', 'click', async () => {
    if (_идёт) { showToast('Рендер уже запускается — подождите', 'info', 1500); return; }
    _идёт = true;
    const кнопка = $('btn-render-start');
    if (кнопка) кнопка.disabled = true;
    try {
      // [10.19.16] Весь путь — в ui/cinematicControl.js: там же ожидание кадра и
      // ЗАМЕР кадра. Раньше эта кнопка и кнопки «Кино вкл/выкл» шли разными
      // путями и вели себя по-разному — врач это заметил сразу.
      await включитьКино(изПанели());
    } catch (e) {
      _прогрессРендера(0);
      showToast('Ошибка рендера: ' + (e?.message || e), 'error', 7000);
      log.warn('[Cinematic]', e);
    } finally {
      _идёт = false;
      if (кнопка) кнопка.disabled = false;
    }
  });

  /**
   * [10.19.19] «Сброс» — заводские значения ТЕКУЩЕГО пресета.
   *
   * ПОВОД, прямая просьба: «в разделе Кинематический рендеринг нет кнопки СБРОС
   * для возврата установок по умолчанию». Её и правда не было: двадцать ползунков
   * тонкой настройки уводились руками, а исходные значения нужно было помнить
   * наизусть. Сброс возвращает пресет, а не «нули»: нули — это не настройки по
   * умолчанию, это отсутствие эффектов.
   */
  on('btn-render-reset', 'click', async () => {
    // [10.19.24] СБРОС — ПОЛНЫЙ: настройки И изображение.
    //
    // ПОВОД, приёмка: «кнопка СБРОС должна приводить настройки по умолчанию И
    // изображение по умолчанию, а не оставлять изображение изменённым». Прежний
    // обработчик пере-применял ТЕКУЩИЙ пресет к живому рендереру: ползунки
    // возвращались, а кинослой оставался на экране — и, хуже того,
    // ensureCinematicRenderer СОЗДАВАЛ рендерер, если его не было: кнопка
    // сброса могла что-то ВКЛЮЧИТЬ.
    //
    // Теперь порядок такой:
    //   1) кинослой снимается — на экране обычный объёмный рендер, то самое
    //      «изображение по умолчанию»;
    //   2) панель возвращается к заводским значениям ИЗ РАЗМЕТКИ
    //      (defaultValue/defaultSelected): второго списка заводских значений в
    //      коде нет, поэтому разъехаться им не с чем;
    //   3) живому рендереру (если он был) ставится заводской пресет, чтобы при
    //      следующем включении внутренние настройки не расходились с панелью;
    //      если рендерера нет — он НЕ создаётся;
    //   4) выбор движка возвращается на «авто» и в хранилище.
    // [12.0.51] Тихо: итог говорит тост «Сброс выполнен» ниже. Без «тихо» при
    // выключенном рендере сперва всплывало «выключать нечего» — два тоста подряд.
    выключитьКино({ тихо: true });
    _прогрессРендера(0);

    const панель = document.getElementById('tab-cinematic');
    let ползунков = 0, списков = 0;
    if (панель) {
      for (const el of панель.querySelectorAll('input[type="range"]')) {
        if (el.value !== el.defaultValue) {
          el.value = el.defaultValue;
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
        ползунков++;
      }
      for (const el of панель.querySelectorAll('select')) {
        const заводской = [...el.options].findIndex((o) => o.defaultSelected);
        const к = заводской >= 0 ? заводской : 0;
        if (el.selectedIndex !== к) {
          el.selectedIndex = к;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
        списков++;
      }
      // AO и тени: вернуть в «выкл». Их ДОСТУПНОСТЬ и дальше решает карта
      // глубины (depth:updated) — сброс трогает только состояние.
      for (const ид of ['render-ao', 'render-shadows']) {
        const т = document.getElementById(ид);
        if (т?.classList.contains('on')) {
          т.classList.remove('on');
          т.setAttribute('aria-checked', 'false');
        }
      }
    }
    try { localStorage.setItem('mikhmel.cinematicEngine', 'auto'); } catch (e) { log.debug('[Кино/сброс]', e.message); }

    // Живому рендереру — заводской пресет; несуществующий НЕ создаётся.
    const cr = getCinematicRenderer();
    if (cr && !cr.isDisposed?.()) {
      try { cr.setPreset?.('cinematic'); } catch (e) { log.debug('[Кино/сброс]', e.message); }
    }
    showToast(`Сброс выполнен: кинослой снят, на экране обычный объёмный рендер. `
      + `Панель возвращена к заводским (${ползунков} ползунков, ${списков} списков, движок «авто»).`, 'success', 5000);
  });

  /**
   * [10.19.19] Выбор движка. На RTX 4060 путь WebGPU кадра не даёт, а WebGL2
   * работает — пока причина WebGPU не найдена, у врача должен быть рычаг.
   */
  on('render-engine', 'change', async () => {
    const режим = $('render-engine')?.value || 'auto';
    try { localStorage.setItem('mikhmel.cinematicEngine', режим); } catch (e) { log.debug('[Кино/движок]', e.message); }
    if (режим !== 'webgl2') {
      showToast('Движок: авто. Смена вступит в силу при следующем включении рендера.', 'info', 5000);
      return;
    }
    const { рендерер: cr } = ensureCinematicRenderer();
    if (!cr) { showToast('Движок запомнен: WebGL2. Применится при включении рендера.', 'info', 4000); return; }
    const р = await cr.перейтиНаWebGL2?.('выбор в панели');
    showToast(р?.success ? 'Движок переключён на WebGL2' : 'Переключить не удалось: ' + (р?.error || 'причина не названа'),
      р?.success ? 'success' : 'error', 5000);
  });

  /**
   * [10.19.20] Отчёт WebGPU. Печатается в консоль и копируется в буфер: врач
   * присылает его одним сообщением, и путь WebGPU перестаёт чиниться вслепую.
   */
  on('btn-webgpu-diag', 'click', async () => {
    const кнопка = $('btn-webgpu-diag');
    if (кнопка) { кнопка.disabled = true; }
    showToast('Собираю отчёт WebGPU: адаптер, возможности, каждый проход по одному…', 'info', 4000);
    try {
      const м = await import('../rendering/webgpuDiag.js');
      const итог = await м.диагностикаWebGPU({ рендерер: getCinematicRenderer() });
      console.log(итог.текст);
      let вБуфере = false;
      try { await navigator.clipboard.writeText(итог.текст); вБуфере = true; } catch (e) { log.debug('[WebGPU/отчёт]', e.message); }
      const битых = (итог.данные?.проходы || []).filter((п) => п.ошибки.length).length;
      if (!итог.ок) {
        showToast('Отчёт готов: ' + (итог.причина || 'WebGPU недоступен') + '. Полный текст — в консоли (F12)'
          + (вБуфере ? ' и в буфере обмена.' : '.'), 'warning', 9000);
      } else {
        showToast(`Отчёт WebGPU готов: проходов с ошибками ${битых} из ${итог.данные?.проходы?.length ?? 0}. `
          + `Полный текст — в консоли (F12)${вБуфере ? ' и в буфере обмена' : ''}. Пришлите его целиком.`,
          битых ? 'warning' : 'success', 10000);
      }
    } catch (e) {
      showToast('Отчёт WebGPU не собрался: ' + e.message, 'error', 8000);
      log.warn('[WebGPU/отчёт]', e);
    } finally {
      if (кнопка) кнопка.disabled = false;
    }
  });

  on('btn-render-stop', 'click', () => {
    const дескриптор = _ctx.getCinematicHandle?.();
    if (дескриптор) {
      try { дескриптор.stop(); } catch (e) { log.debug('[Cinematic] stop:', e.message); }
      _ctx.setCinematicHandle(null);
      showToast('Запись остановлена', 'info', 2500);
    }
    выключитьКино();
    _прогрессРендера(0);
  });

  // [10.19.16] Кнопка «Кино вкл/выкл» — тот же путь: она была пустышкой,
  // печатала «включён», а isEnabled() оставался false.
  // [10.19.19] Из левого сайдбара кнопку убрали совсем (просьба врача: «может она
  // вообще в этом разделе не нужна»), обработчик оставлен для оставшейся.
  for (const ид of ['btn-cinematic-toggle']) {
    on(ид, 'click', async () => {
      const кнопка = $(ид);
      if (кнопка) кнопка.disabled = true;
      try {
        const итог = await переключитьКино(изПанели());
        if (кнопка) кнопка.classList.toggle('active', !!итог.включено);
      } finally {
        if (кнопка) кнопка.disabled = false;
      }
    });
  }

  // 3D Renderer presets
  onAll('.preset-chip[data-render-preset]', 'click', (e) => {
    const preset = e.currentTarget.dataset.renderPreset;
    // [FIX-P1] Используем единую карту пресетов
    const p = _ctx.VRT_PRESET_MAP[preset] || { cs3d: 'CT-Chest', ww: 400, wc: 40 };
    // [10.0.2] В своё окно, а не во все шесть сразу.
    applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
    $$('.preset-chip[data-render-preset]').forEach(c => c.classList.remove('active'));
    e.currentTarget.classList.add('active');
    showToast(`Пресет: ${preset}`, 'info', 1200);
  });
}

// ============================================================
// FUSION / 4D
// ============================================================
// [10.19.30] Куст «оверлей-фьюжн» 7.0.51 ВЫКОРЧЕВАН ЦЕЛИКОМ: все пять его
// обработчиков висели на кнопках-призраках — id btn-apply-fusion, btn-load-pet,
// btn-load-ct-fusion, fusion-opacity и fusion-colormap в разметке отсутствуют
// давно. Хуже: плашки-подсказки отправляли к кнопке «Наложить фьюжн», которой
// не существует. Живой путь слияния ПЭТ-КТ ОДИН — раздел «Слияние PET-CT»
// (ds-petct-*, кнопка «Применить») в proFeaturesBindings → DatasetManager.
// Само слово «фьюжн» из плашек переведено: «слияние» — перевод владельца;
// моё промежуточное «наложение» описывало механизм показа, а не операцию.

function bindFusion4D() {
  // [7.0.50] CINE → реальный движок startCine/stopCine (как в enterprisePanel). null = активный вьюпорт.
  // [10.19.32] Сирота btn-cine-show-bar удалён: кнопки нет в разметке.
  // Кино-панель показывает живая кнопка тулбара btn-cine-toolbar (toolBindings).
}

// ============================================================
// GPU COMPUTE
// ============================================================
function bindGPUCompute() {
  // [10.19.29] Раздел «GPU вычисления» разобран кнопка за кнопкой. Нашлось два
  // рода бед, и обе молчаливые.
  //
  // 1. ДВЕ КНОПКИ ИЗ ТРЁХ ЗВАЛИ РАСЧЁТ С НЕВЕРНЫМИ АРГУМЕНТАМИ. Подписи:
  //      runMarchingCubes(volumeData, dims, isoValue, cacheKey)
  //      runThreshold(volumeData, lower, upper, cacheKey)
  //    А звали их так:
  //      runMarchingCubes(scalarData, dims, spacing, iso)  → isoValue = spacing (массив!)
  //      runThreshold(scalarData, dims, low, high)         → lower = dims (массив!)
  //    То есть порог сравнивал яркость с массивом, поверхность строилась по
  //    «изозначению»-массиву. Ошибки не было: сравнение с NaN просто не
  //    срабатывает, и кнопка бодро печатала «готов».
  //
  // 2. РЕЗУЛЬТАТ НИКУДА НЕ ШЁЛ. Все три расчёта возвращают данные (MIP —
  //    картинку, поверхность — вершины, порог — маску), а обработчик их
  //    выбрасывал и показывал «готов». Считать минуту и выбросить — это не
  //    работа, а её вид. Теперь результат ПОКАЗЫВАЕТСЯ: MIP рисуется на холсте
  //    в окне, поверхность отдаёт число треугольников и выгрузку STL, порог —
  //    объём в миллилитрах и долю кадра.
  // [10.19.30] окноРезультата вынесено на уровень модуля (см. _окноРезультата
  // выше): тем же окном теперь пользуется DSA-вычитание.

  on('btn-run-mip', 'click', async () => {
    const axis = parseInt($('mip-axis')?.value || '0');
    const vi = _ctx.getVolumeScalarData();
    if (!vi) { showToast('MIP: сначала загрузите объём', 'warning', 3000); return; }
    showToast('Считаю MIP…', 'info', 1500);
    const t0 = Date.now();
    try {
      const r = await (await _gpu()).runMIP(vi.scalarData, vi.dimensions, axis);
      if (!r?.data?.length) { showToast('MIP не посчитан: расчёт вернул пустой результат', 'error', 5000); return; }
      // Показ: проекция рисуется на холсте с растяжкой по своим min/max —
      // иначе на экране был бы чёрный прямоугольник.
      let мин = Infinity, макс = -Infinity;
      for (const v of r.data) { if (v < мин) мин = v; if (v > макс) макс = v; }
      const разм = макс - мин || 1;
      const холст = document.createElement('canvas');
      холст.width = r.width; холст.height = r.height;
      холст.style.cssText = 'max-width:100%;height:auto;image-rendering:pixelated;border:1px solid #2a3546;border-radius:8px;';
      const ctx2 = холст.getContext('2d');
      const img = ctx2.createImageData(r.width, r.height);
      for (let i = 0; i < r.data.length; i++) {
        const g = Math.round(((r.data[i] - мин) / разм) * 255);
        img.data[i * 4] = img.data[i * 4 + 1] = img.data[i * 4 + 2] = g;
        img.data[i * 4 + 3] = 255;
      }
      ctx2.putImageData(img, 0, 0);
      const w = _окноРезультата(`MIP · ось ${['аксиальная', 'сагиттальная', 'корональная'][axis] || axis}`);
      w.тело.appendChild(холст);
      w.тело.insertAdjacentHTML('beforeend',
        `<div style="margin-top:8px;color:#9fb3cf;">Размер ${r.width}×${r.height} · яркости ${Math.round(мин)}…${Math.round(макс)} · `
        + `${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
        + '<div style="margin-top:6px;color:#8fa3c0;">Это отдельная проекция для просмотра: в окна просмотра она не подставляется и на измерения не влияет. Не для диагностики.</div>');
      w.тело.appendChild(w.закрыть);
    } catch (e) {
      showToast('MIP: ' + e.message, 'error', 5000);
    }
  });

  on('btn-run-mc', 'click', async () => {
    const vi = _ctx.getVolumeScalarData();
    if (!vi) { showToast('Поверхность: сначала загрузите объём', 'warning', 3000); return; }
    const iso = parseInt($('mc-iso')?.value || '300');
    showToast(`Строю поверхность по ISO ${iso}…`, 'info', 2000);
    const t0 = Date.now();
    try {
      // [10.19.29] Аргументы по подписи: (данные, размеры, ИЗОЗНАЧЕНИЕ).
      // Здесь стояло vi.spacing на месте изозначения — сюда и уходил шаг вокселя.
      const r = await (await _gpu()).runMarchingCubes(vi.scalarData, vi.dimensions, iso);
      // [10.19.30] Процессорный откат в gpuCompute — НЕ marching cubes, а
      // точечное приближение: по одной точке на приграничную ячейку, без
      // треугольников. Выдавать его число за «треугольники» и сшивать точки в
      // STL значило бы отдать врачу файл-обманку с тостом «сохранён». На
      // машине без WebGPU честно отказываем и объясняем, чем это отличается.
      if (r && r.gpu === false) {
        const ячеек = r.vertexCount || 0;
        const w = _окноРезультата(`Поверхность · ISO ${iso} — только оценка`);
        w.тело.insertAdjacentHTML('beforeend',
          `<div>На этой машине нет WebGPU, и настоящий marching cubes не считается. `
          + `Процессорный путь лишь ОЦЕНИВАЕТ границу: приграничных ячеек при ISO ${iso} — <b>${ячеек.toLocaleString('ru-RU')}</b>.</div>`
          + '<div style="margin-top:6px;color:#8fa3c0;">Треугольников здесь нет, поэтому и выгрузки STL нет: файл из этих точек был бы обманкой. '
          + 'Настоящая сетка с STL строится процессорным путём РАЗДЕЛОМ НИЖЕ — «3D модель: обработка и выгрузка» (в 11.0.9 он переехал сюда из меню «Инструменты») — или здесь же на машине с WebGPU.</div>');
        w.тело.appendChild(w.закрыть);
        return;
      }
      const треуг = Math.floor((r?.vertexCount || 0) / 3);
      if (!треуг) {
        showToast(`Поверхность пуста: при ISO ${iso} в объёме нет границы. Попробуйте другое значение — для костей 300…700, для кожи около −300`, 'warning', 8000);
        return;
      }
      // [11.1.22] СВЕДЕНИЕ (по слову владельца): построенное здесь кладётся
      // в общий кэш ряда «3D модель: обработка и выгрузка». Суп с видеокарты
      // конвертируется в points/polys с переводом ВОКСЕЛЕЙ В МИЛЛИМЕТРЫ —
      // без умножения на шаг среза модель по Z была бы сплющена, и STL лгал
      // бы геометрией.
      let подхват = '';
      try {
        const vtk = гпуСупВVtk(r.vertices, r.vertexCount, vi.spacing || [1, 1, 1]);
        if (vtk && положитьСетку(vi.scalarData, { points: vtk.points, polys: vtk.polys }, vtk.triangleCount, `построена в «GPU Вычислениях», ISO ${iso}`)) {
          подхват = ' Раздел «3D модель: обработка и выгрузка» ниже подхватит её без пересчёта — Децимация, GLTF, VRML и STL возьмут именно эту сетку.';
        }
      } catch (e) { log.debug('[GPU→сетка] конвертация:', e.message); }
      const w = _окноРезультата(`Поверхность · ISO ${iso}`);
      w.тело.insertAdjacentHTML('beforeend',
        `<div>Треугольников: <b>${треуг.toLocaleString('ru-RU')}</b> · вершин ${r.vertexCount.toLocaleString('ru-RU')} · `
        + `${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
        + `<div style="margin-top:6px;color:#8fa3c0;">Сетка построена в памяти. В окна просмотра она не подставляется — объёмный вид рисуется своим путём; забрать её можно файлом STL.${подхват}</div>`);
      const стл = document.createElement('button');
      стл.textContent = 'Сохранить STL';
      стл.style.cssText = 'margin-top:10px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;';
      стл.addEventListener('click', () => {
        // [11.1.23] STL пишется В МИЛЛИМЕТРАХ из уже сконвертированной сетки
        // (та же, что ушла в кэш обработки): прежний писатель брал сырые
        // r.vertices в ВОКСЕЛЯХ — при срезе 0.7×0.7×3 модель по Z была
        // сплющена вчетверо. Нормали считаются заново из мм-точек: старые,
        // вексельные, после анизотропного масштаба лгали бы направлением.
        const vtkСетка = гпуСупВVtk(r.vertices, r.vertexCount, vi.spacing || [1, 1, 1]);
        if (!vtkСетка) { showToast('Сетка пуста — сохранять нечего', 'warning', 2500); return; }
        const P = vtkСетка.points;
        const строки = ['solid mikhmel'];
        for (let t = 0; t < vtkСетка.triangleCount; t++) {
          const a = t * 9, b = a + 3, c = a + 6;
          const ux = P[b] - P[a], uy = P[b + 1] - P[a + 1], uz = P[b + 2] - P[a + 2];
          const vx = P[c] - P[a], vy = P[c + 1] - P[a + 1], vz = P[c + 2] - P[a + 2];
          let nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
          const дл = Math.hypot(nx, ny, nz) || 1;
          nx /= дл; ny /= дл; nz /= дл;
          строки.push(`facet normal ${nx} ${ny} ${nz}`, ' outer loop');
          for (const j of [a, b, c]) {
            строки.push(`  vertex ${P[j]} ${P[j + 1]} ${P[j + 2]}`);
          }
          строки.push(' endloop', 'endfacet');
        }
        строки.push('endsolid mikhmel');
        downloadBlob(new Blob([строки.join('\n')], { type: 'model/stl' }), `surface_iso${iso}_${Date.now()}.stl`);
        showToast('STL сохранён — в миллиметрах', 'success', 1800);
      });
      w.тело.appendChild(стл);
      w.тело.appendChild(w.закрыть);
    } catch (e) {
      showToast('Поверхность: ' + e.message, 'error', 5000);
    }
  });

  on('btn-run-thresh', 'click', async () => {
    const vi = _ctx.getVolumeScalarData();
    if (!vi) { showToast('Порог: сначала загрузите объём', 'warning', 3000); return; }
    const low = parseInt($('thresh-low')?.value || '100');
    const high = parseInt($('thresh-high')?.value || '500');
    if (low >= high) { showToast(`Порог: нижний (${low}) должен быть меньше верхнего (${high})`, 'warning', 4000); return; }
    showToast(`Считаю порог ${low}…${high}…`, 'info', 1500);
    const t0 = Date.now();
    try {
      // [10.19.29] Подпись: (данные, НИЖНИЙ, ВЕРХНИЙ). Здесь вторым шли
      // размеры объёма — то есть яркость сравнивалась с массивом.
      const r = await (await _gpu()).runThreshold(vi.scalarData, low, high);
      if (!r?.data?.length) { showToast('Порог не посчитан: расчёт вернул пустой результат', 'error', 5000); return; }
      let внутри = 0;
      for (const v of r.data) if (v > 0) внутри++;
      const [sx, sy, sz] = vi.spacing || [1, 1, 1];
      const мл = внутри * sx * sy * sz / 1000;
      const доля = внутри / r.data.length * 100;
      const w = _окноРезультата(`Порог ${low}…${high} HU`);
      w.тело.insertAdjacentHTML('beforeend',
        `<div>Вокселей в диапазоне: <b>${внутри.toLocaleString('ru-RU')}</b> из ${r.data.length.toLocaleString('ru-RU')} (${доля.toFixed(1)}%)</div>`
        + `<div>Объём: <b>${мл.toFixed(1)} мл</b> при шаге вокселя ${sx}×${sy}×${sz} мм</div>`
        + `<div style="color:#9fb3cf;">${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
        + '<div style="margin-top:6px;color:#8fa3c0;">Считается весь кадр целиком, без разделения на органы: в диапазон попадает всё, что в него попадает — и кость, и стол, и контраст. Не для диагностики.</div>');
      w.тело.appendChild(w.закрыть);
    } catch (e) {
      showToast('Порог: ' + e.message, 'error', 5000);
    }
  });
}

// ============================================================
// 3D ENDOSCOPY
// ============================================================
function bindEndoscopy() {
}

// ============================================================
// MEASUREMENTS
// ============================================================
function bindMeasurements() {
  on('btn-meas-csv', 'click', () => {
    // [11.0.2] CSV собирается ИЗ ТОГО ЖЕ разбора, что и таблица на экране.
    // Раньше здесь стояло `a.data?.cachedStats?.mean` — обращение на уровень
    // выше, чем лежат числа: cachedStats это словарь «идентификатор объёма →
    // статистика», и `.mean` у самого словаря нет. В файл уходил столбец из
    // пустот, а единица измерения всегда писалась «mm», даже для углов и HU.
    const строки = _собратьИзмерения();
    const csv = 'Тип,Значение,Ед.\n' + строки.map((и) => `${и.тип},${и.значение},${и.ед}`).join('\n');
    downloadBlob(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' }), `measurements_${Date.now()}.csv`);
    showToast(строки.length ? `📊 CSV: ${строки.length} измерений` : '📊 CSV пуст: измерений нет', строки.length ? 'success' : 'info');
  });
  // [11.1.21] Кнопка «JSON» УДАЛЕНА (аудит §1.2): она делала ровно то же,
  // что «Экспорт аннотаций» двумя разделами ниже — exportAnnotations() в
  // файл, — отличаясь лишь именем файла. Две кнопки одной работы в одной
  // вкладке. Оставлен «Экспорт аннотаций»: он парный к импорту.
  on('btn-meas-clear', 'click', () => { clearAnnotations(); showToast('Измерения очищены', 'info'); _обновитьТаблицуИзмерений(); });
  _подключитьТаблицуИзмерений();
}

// ============================================================
// ТАБЛИЦА ИЗМЕРЕНИЙ [11.0.2]
// ============================================================
/**
 * Таблица и статистика на вкладке «Измерения» НИКОГДА НЕ ЗАПОЛНЯЛИСЬ.
 *
 * Разметка была на месте с давних пор: `#measurements-body`, `#meas-count`,
 * `#meas-sum`, `#meas-mean`, `#meas-minmax`. Ни одно из этих имён не
 * встречалось в коде ни разу — проверено поиском по всему проекту. Врач делал
 * десять измерений и видел «Нет измерений» и четыре прочерка, при том что
 * кнопки CSV/JSON рядом выгружали те же самые данные.
 *
 * Сторож мёртвых органов их не ловил: он следит за КНОПКАМИ, списками и
 * полями ввода — за тем, что можно нажать. Пустая таблица нажатия не ждёт, и
 * под правило не попадала. Это не дыра в стороже, а граница его зоны: строку
 * «показывать то, что посчитано» проверкой разметки не поймать.
 */

/** Человеческие имена инструментов Cornerstone. */
const _ИМЕНА_ИНСТРУМЕНТОВ = Object.freeze({
  Length: 'Длина', Bidirectional: 'Двунаправл.', Angle: 'Угол', CobbAngle: 'Угол Кобба',
  EllipticalROI: 'Эллипс ROI', RectangleROI: 'Прямоуг. ROI', CircleROI: 'Круг ROI',
  PlanarFreehandROI: 'Свободное ROI', Probe: 'Зонд', ArrowAnnotate: 'Стрелка',
  SplineROI: 'Сплайн ROI', UltrasoundDirectional: 'УЗИ направл.',
});

/**
 * Достать из аннотации число и единицу.
 *
 * Тонкость, на которой спотыкался прежний экспорт: `cachedStats` — это НЕ
 * статистика, а СЛОВАРЬ «идентификатор объёма → статистика». У самого словаря
 * нет ни `mean`, ни `length`; они лежат внутри, под ключом вида
 * `volumeId:cornerstoneStreamingImageVolume:…`. Берём первую запись словаря:
 * измерение живёт в одном окне, и записей там ровно одна.
 */
function _числоИзмерения(ann) {
  const инстр = ann?.metadata?.toolName || '';
  const словарь = ann?.data?.cachedStats;
  const первый = словарь && typeof словарь === 'object' ? Object.values(словарь)[0] : null;
  const с = (первый && typeof первый === 'object') ? первый : {};
  const чис = (v) => (typeof v === 'number' && isFinite(v)) ? v : null;

  // Порядок важен: у ROI есть и площадь, и средняя плотность — показываем
  // площадь как основное число, плотность уводим в подпись строки.
  if (чис(с.length) != null) return { значение: с.length, ед: 'мм', подпись: '' };
  if (чис(с.angle) != null) return { значение: с.angle, ед: '°', подпись: '' };
  if (чис(с.area) != null) {
    const hu = чис(с.mean);
    return { значение: с.area, ед: 'мм²', подпись: hu != null ? `${hu.toFixed(0)} HU` : '' };
  }
  if (чис(с.length1) != null || чис(с.longestDiameter) != null) {
    const дл = чис(с.longestDiameter) ?? чис(с.length1);
    const кор = чис(с.shortestDiameter) ?? чис(с.length2);
    return { значение: дл, ед: 'мм', подпись: кор != null ? `× ${кор.toFixed(1)} мм` : '' };
  }
  if (чис(с.value) != null) return { значение: с.value, ед: 'HU', подпись: '' };   // Зонд
  if (чис(с.mean) != null) return { значение: с.mean, ед: 'HU', подпись: '' };
  // Стрелка и подписи чисел не несут — это не поломка, им нечего показывать.
  if (инстр === 'ArrowAnnotate') return { значение: null, ед: '', подпись: ann?.data?.text || '' };
  return { значение: null, ед: '', подпись: '' };
}

/** Собрать измерения в плоский список — общий источник для таблицы и CSV. */
function _собратьИзмерения() {
  let все = [];
  try { все = getAnnotations() || []; } catch (e) { log.debug('[Измерения]', e.message); return []; }
  if (!Array.isArray(все)) все = Object.values(все).flat();
  return все.map((a) => {
    const инстр = a?.metadata?.toolName || '—';
    const { значение, ед, подпись } = _числоИзмерения(a);
    return {
      uid: a?.annotationUID || '',
      тип: _ИМЕНА_ИНСТРУМЕНТОВ[инстр] || инстр,
      значение: значение != null ? Number(значение).toFixed(1) : '—',
      число: значение,
      ед, подпись,
    };
  });
}

function _обновитьТаблицуИзмерений() {
  const тело = $('measurements-body');
  if (!тело) return;
  const строки = _собратьИзмерения();

  if (!строки.length) {
    тело.innerHTML = '<tr><td colspan="4" style="padding:12px; text-align:center; color:var(--text-dim);">Нет измерений</td></tr>';
  } else {
    тело.innerHTML = строки.map((и) => `<tr data-uid="${escapeHtml(и.uid)}">`
      + `<td style="padding:4px 6px;">${escapeHtml(и.тип)}</td>`
      + `<td style="padding:4px 6px;">${escapeHtml(и.значение)}${и.подпись ? ` <span style="color:var(--text-dim);">${escapeHtml(и.подпись)}</span>` : ''}</td>`
      + `<td style="padding:4px 6px;">${escapeHtml(и.ед)}</td>`
      + '<td style="padding:4px; text-align:center;"><button class="ann-del-btn" title="Удалить измерение">✕</button></td></tr>').join('');
  }

  // ── Статистика ──
  //
  // Складывать миллиметры с градусами и единицами Хаунсфилда нельзя, а
  // прежняя разметка предлагала одну «Сумму» на всё. Поэтому считаем по
  // САМОЙ ЧАСТОЙ единице и честно подписываем, по какой именно: «сумма 43.2
  // мм» осмысленна, «сумма 43.2» — нет.
  const счётЕдиниц = {};
  for (const и of строки) if (и.число != null && и.ед) счётЕдиниц[и.ед] = (счётЕдиниц[и.ед] || 0) + 1;
  const ведущая = Object.entries(счётЕдиниц).sort((a, b) => b[1] - a[1])[0]?.[0] || '';
  const числа = строки.filter((и) => и.число != null && и.ед === ведущая).map((и) => и.число);

  const впиши = (id, текст) => { const el = $(id); if (el) el.textContent = текст; };
  впиши('meas-count', String(строки.length));
  if (!числа.length) {
    впиши('meas-sum', '—'); впиши('meas-mean', '—'); впиши('meas-minmax', '—');
  } else {
    const сумма = числа.reduce((s, v) => s + v, 0);
    впиши('meas-sum', `${сумма.toFixed(1)} ${ведущая}`);
    впиши('meas-mean', `${(сумма / числа.length).toFixed(1)} ${ведущая}`);
    впиши('meas-minmax', `${Math.min(...числа).toFixed(1)} / ${Math.max(...числа).toFixed(1)} ${ведущая}`);
  }
  // Если единиц несколько — говорим, по какой посчитано, а не молчим.
  const шапка = $('meas-count')?.closest('.ctrl-row')?.previousElementSibling;
  if (шапка && шапка.classList?.contains('section-title')) {
    const разных = Object.keys(счётЕдиниц).length;
    шапка.textContent = разных > 1 ? `Статистика (по «${ведущая}»)` : 'Статистика';
  }
}

function _подключитьТаблицуИзмерений() {
  // Крестик в строке — делегированием: строки перерисовываются целиком, и
  // вешать слушателя на каждую заново значило бы плодить их при каждом
  // обновлении.
  const тело = $('measurements-body');
  if (тело) {
    тело.addEventListener('click', (e) => {
      const кн = e.target.closest('.ann-del-btn');
      if (!кн) return;
      const uid = кн.closest('tr')?.dataset?.uid;
      if (!uid) return;
      try { removeAnnotation(uid); } catch (err) { log.debug('[Измерения] удаление:', err.message); }
      _обновитьТаблицуИзмерений();
    }, { signal: _getSignal() });
  }

  // Живое обновление по событиям самих аннотаций — тем же путём, каким
  // работает отмена/повтор (toolBindings.bindAnnotationEvents).
  const подписаться = () => {
    const csTools = window.cornerstoneTools || window.MikhmelViewer?._csTools;
    const Events = csTools?.Enums?.Events;
    if (!Events) return false;
    const цель = csTools.eventTarget || document;
    for (const имя of ['ANNOTATION_COMPLETED', 'ANNOTATION_REMOVED', 'ANNOTATION_MODIFIED']) {
      if (Events[имя]) цель.addEventListener(Events[имя], () => _обновитьТаблицуИзмерений(), { signal: _getSignal() });
    }
    log.debug('[Измерения] таблица подписана на события аннотаций');
    return true;
  };
  if (!подписаться()) {
    // Инструменты ещё не поднялись — ждём их готовности, как и соседи.
    const когдаГотовы = () => { document.removeEventListener('cornerstoneToolsReady', когдаГотовы); подписаться(); };
    document.addEventListener('cornerstoneToolsReady', когдаГотовы, { signal: _getSignal() });
    setTimeout(() => подписаться(), 3000);
  }

  // Открытие вкладки «Измерения» — тоже повод пересчитать: аннотацию могли
  // удалить с самого снимка, пока вкладка была закрыта.
  document.querySelector('.right-tab[data-tab="tab-measure"]')
    ?.addEventListener('click', () => setTimeout(_обновитьТаблицуИзмерений, 50), { signal: _getSignal() });

  _обновитьТаблицуИзмерений();
}

// ============================================================
// REPORTS
// ============================================================
// [11.1.16] Тела шаблонов. До этого выбор из двенадцати пунктов менял ОДНУ
// строку в шапке бланка («Шаблон: ct-chest») — вывеска-лайт: «CT Мозг» и
// «Маммография» давали одинаково пустой лист. Теперь выбор предзаполняет
// «Находки» скелетом разделов по модальности. Скелеты — только структура
// (заголовки с многоточиями), БЕЗ предзаполненных «норм»: писать «не
// выявлено» за врача бланк не смеет. Пустое поле заполняется молча, непустое
// — только после подтверждения. Тексты правятся прямо здесь.
const ТЕЛА_ШАБЛОНОВ = Object.freeze({
  'general': 'Область исследования: …\nКачество исследования: …\nНаходки: …\nСравнение с предыдущими исследованиями: …',
  'ct-chest': 'Лёгкие: …\nПлевральные полости: …\nСредостение и корни: …\nЛимфатические узлы: …\nСердце и сосуды: …\nКости грудной клетки и мягкие ткани: …',
  'ct-abdomen': 'Печень: …\nЖёлчный пузырь и протоки: …\nПоджелудочная железа: …\nСелезёнка: …\nПочки и надпочечники: …\nКишечник: …\nЛимфатические узлы: …\nСосуды: …\nКости и мягкие ткани: …',
  'ct-brain': 'Вещество головного мозга: …\nЖелудочковая система: …\nСрединные структуры: …\nСубарахноидальные пространства: …\nКости свода и основания черепа: …\nПридаточные пазухи: …',
  'mri-brain': 'Вещество головного мозга (T1/T2/FLAIR/DWI): …\nЖелудочковая система: …\nСрединные структуры: …\nГипофиз: …\nКраниовертебральный переход: …\nПосле контрастирования: …',
  'mri-spine': 'Статика и ось: …\nТела позвонков: …\nМежпозвонковые диски: …\nПозвоночный канал и корешковые каналы: …\nСпинной мозг: …\nПаравертебральные ткани: …',
  'mri-knee': 'Мениски (медиальный/латеральный): …\nКрестообразные связки: …\nКоллатеральные связки: …\nСуставной хрящ: …\nКостный мозг: …\nСуставная жидкость и сумки: …',
  'xr-chest': 'Лёгочные поля: …\nКорни лёгких: …\nСинусы: …\nТень сердца и средостения: …\nДиафрагма: …\nКостный каркас: …',
  'mammo': 'Тип строения (ACR): …\nОбразования: …\nКальцинаты: …\nАсимметрии и нарушения архитектоники: …\nКожа и сосок: …\nАксиллярные области: …\nКатегория BI-RADS: …',
  'us-abdomen': 'Печень (размеры, эхоструктура): …\nЖёлчный пузырь: …\nПоджелудочная железа: …\nСелезёнка: …\nПочки: …\nСвободная жидкость: …',
  'cardiac': 'Камеры сердца (размеры): …\nСократимость (глобальная/локальная): …\nКлапанный аппарат: …\nПерикард: …\nКоронарные артерии/кальциноз: …\nКрупные сосуды: …',
  // 'custom' — тела нет нарочно: «Свой» значит свой.
});

function bindReports() {
  // [11.1.16] Бланк собирается ОДНОЙ функцией для обеих кнопок. До этого
  // «Печать», стоя в форме под галочкой «Измерения», исполняла голый
  // window.print(): на бумагу шёл тёмный интерфейс, а форму и галочку читал
  // только «PDF отчёт» двумя разделами ниже. Комментарий 10.19.32 («теперь в
  // отчёт входит таблица») был правдой лишь для PDF. Теперь обе кнопки
  // печатают ОДИН И ТОТ ЖЕ бланк; разница только в доставке: PDF открывает
  // окно с кнопкой «Сохранить», Печать сразу зовёт диалог печати через
  // printUtil.openPrintWindow (с iframe-запаской от блокировщика всплывающих).
  // [11.1.19] ДАННЫЕ бланка собираются один раз и одной функцией — их едят
  // все три выхода: Печать, PDF (HTML) и DOCX. Три формы одного отчёта не
  // разъедутся по построению.
  const собратьДанныеОтчёта = () => {
    const шаблонСел = $('report-template');
    const измерения = [];
    if ($('report-inc-meas')?.checked) {
      for (const a of (getAnnotations() || [])) {
        const с = a.data?.cachedStats || {};
        const з = с.length != null ? `${(+с.length).toFixed(1)} мм`
          : с.mean != null ? `${(+с.mean).toFixed(1)} HU (сред.)`
          : с.angle != null ? `${(+с.angle).toFixed(1)}°` : '—';
        измерения.push({ инструмент: a.metadata?.toolName || '—', значение: з });
      }
    }
    const бланк = прочитатьБланк();
    const п = (id) => $(id)?.value?.trim() || '';
    // [11.1.30] Галочки разделов — воля врача. Раньше решала ПУСТОТА поля:
    // текст, оставшийся от прошлого пациента, уезжал в документ молча.
    const разделы = {};
    document.querySelectorAll('#report-sections input[data-section]')
      .forEach((г) => { разделы[г.dataset.section] = !!г.checked; });
    return {
      // Шапка учреждения — из настроек (заполняется один раз)
      учреждение: бланк.учреждение || '',
      реквизиты: бланк.реквизиты || '',
      логотип: бланк.логотип || '',
      логотипВид: логотипБланка(бланк),
      шрифты: шрифтыБланка(бланк),
      разделы,
      // [11.1.35] Отделение — ПО ЯВНОМУ ВЫБОРУ врача из списка, авто лишь по
      // умолчанию. Раньше решала модальность ПЕРВОЙ серии сеанса
      // (_модальностьСейчас берёт getAllSeries()[0]): открыл врач сперва КТ,
      // потом МРТ — и в заключение МРТ уезжало «ОТДЕЛЕНИЕ КОМПЬЮТЕРНОЙ
      // ТОМОГРАФИИ», а строки «MR = …» из настроек бланка не спасали: их
      // никто не спрашивал о НУЖНОЙ модальности. Замечание владельца.
      отделение: (() => {
        const выбор = $('report-dept')?.value || 'авто';
        return названиеОтделения(выбор === 'авто' ? _модальностьСейчас() : выбор, бланк);
      })(),
      поля: поляБланка(бланк),   // [11.1.35] поля листа — в печать и DOCX
      // Шапка исследования — автоподстановка с правкой
      patientName: п('report-patient') || ($('overlay-patient')?.textContent || ''),
      датаРождения: п('report-birth'),
      studyDate: п('report-studydate') || ($('overlay-date')?.textContent || ''),
      номерИстории: п('report-accession'),
      аппарат: п('report-device'),
      последовательности: п('report-sequences'),
      контраст: п('report-contrast'),
      modality: _модальностьСейчас(),
      // Тело
      шаблонИмя: шаблонСел?.selectedOptions?.[0]?.text || шаблонСел?.value || 'standard',
      клинические: п('report-clinical'),
      findings: п('report-findings'),
      сравнение: п('report-comparison'),
      impression: п('report-impression'),
      рекомендации: п('report-recommendations'),
      включитьИзмерения: !!$('report-inc-meas')?.checked,
      измерения,
      // Подпись
      physician: п('report-physician'),
      должность: п('report-physician-title'),
    };
  };

  const _модальностьСейчас = () => {
    try { return (_ctx?.getAllSeries?.() || []).map((с) => с.modality).filter(Boolean)[0] || ''; }
    catch (e) { return ''; }
  };

  // [11.1.20] Бланк собран по образцу настоящего заключения: шапка
  // учреждения с реквизитами и логотипом, название отделения, паспортная
  // часть (ФИО, дата рождения, дата исследования, № истории, аппарат),
  // строка «Исследование проведено в ИП», клинические данные, находки,
  // сравнение с предыдущим, ЗАКЛЮЧЕНИЕ, рекомендации и подпись с
  // должностью. Пустые разделы не печатаются — лист не должен пестреть
  // прочерками там, где врачу нечего сказать.
  const сформироватьHtmlОтчёта = () => {
    const д = собратьДанныеОтчёта();
    const э = escapeHtml;
    const абзацы = (т) => String(т || '').split('\n').filter((с) => с.trim()).map((с) => `<div>${э(с)}</div>`).join('');
    const раздел = (заг, текст) => текст?.trim() ? `<h2>${э(заг)}</h2><div class="txt">${абзацы(текст)}</div>` : '';
    // [11.1.30] Разделы — по галочкам врача (см. собратьДанныеОтчёта).
    const вкл = (к) => разделВключён(д.разделы, к);
    const измеренияHtml = д.включитьИзмерения
      ? (д.измерения.length
          ? `<h2>ИЗМЕРЕНИЯ (${д.измерения.length})</h2><table class="meas">${д.измерения.map((и) => `<tr><td>${э(и.инструмент)}</td><td>${э(и.значение)}</td></tr>`).join('')}</table>`
          : '<h2>ИЗМЕРЕНИЯ</h2><div class="txt" style="color:#666;">Измерений нет</div>')
      : '';
    // [11.1.30] Логотип: ширина в МИЛЛИМЕТРАХ и место — из настроек бланка
    // (бланк печатают на бумаге, а не смотрят в пикселях).
    const л = д.логотипВид || {};
    const лоГотов = д.логотип && л.место !== 'нет';
    const лоТег = лоГотов ? `<img src="${д.логотип}" alt="" style="width:${л.ширинаМм || 22}mm;">` : '';
    const текстШапки = `<div class="orgname">${абзацы(д.учреждение)}</div>${д.реквизиты ? `<div class="req">${абзацы(д.реквизиты)}</div>` : ''}`;
    const шапкаУчр = (д.учреждение || д.реквизиты || лоГотов) ? (
      л.место === 'сверху'
        ? `<div style="text-align:center;margin-bottom:2mm;">${лоТег}</div>${текстШапки}<hr>`
        : `<table class="org"><tr>
  ${лоГотов && л.место !== 'справа' ? `<td class="logo">${лоТег}</td>` : ''}
  <td>${текстШапки}</td>
  ${лоГотов && л.место === 'справа' ? `<td class="logo">${лоТег}</td>` : ''}
</tr></table><hr>`) : '';

    // [11.1.35] Поля — из настроек бланка (по умолчанию 15 мм = 1,5 см с
    // каждой стороны, просьба владельца). Зашитые 18 мм похоронены.
    const пл = д.поля || {};
    const мм = (v, у) => (Number.isFinite(Number(v)) && Number(v) >= 5 && Number(v) <= 40 ? Number(v) : у);
    return `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Заключение</title>
<style>
  @page { margin: ${мм(пл.верхМм, 15)}mm ${мм(пл.правоМм, 15)}mm ${мм(пл.низМм, 15)}mm ${мм(пл.левоМм, 15)}mm; size: A4; }
  body { font-family: '${д.шрифты?.телоИмя || 'Times New Roman'}', serif; font-size: ${д.шрифты?.телоПт || 12}pt; color: #111; line-height: 1.45; }
  .org, .dept { font-family: '${д.шрифты?.шапкаИмя || 'Times New Roman'}', serif; }
  .orgname { font-size: ${д.шрифты?.шапкаПт || 12}pt; }
  .org { width: 100%; border-collapse: collapse; }
  .org td { vertical-align: middle; }
  .logo { vertical-align: middle; padding: 0 3mm; }
  .orgname { text-align: center; font-weight: bold; }
  .req { text-align: center; font-size: 10pt; margin-top: 2mm; }
  hr { border: none; border-top: 1.5px solid #000; margin: 2mm 0 4mm; }
  .dept { text-align: center; font-weight: bold; font-size: 13pt; letter-spacing: .5px; margin-bottom: 6mm; }
  .pass div { margin: 1mm 0; } .pass b { display: inline-block; min-width: 46mm; }
  h2 { font-size: 12pt; margin: 5mm 0 1mm; }
  .txt div { margin: .6mm 0; text-align: justify; }
  .meas { border-collapse: collapse; font-size: 11pt; }
  .meas td { border: 1px solid #bbb; padding: 1mm 3mm; }
  .concl { font-weight: bold; }
  .sig { margin-top: 12mm; text-align: right; }
  .sig .post { font-weight: bold; }
  @media print { .no-print { display: none; } }
</style></head><body>
<div class="no-print" style="text-align:center;margin-bottom:6mm;">
  <button onclick="window.print()" style="padding:8px 24px;font-size:14px;cursor:pointer;background:#3b82f6;color:#fff;border:none;border-radius:6px;">📄 Сохранить PDF / Печать</button>
</div>
${шапкаУчр}
${д.отделение ? `<div class="dept">${э(д.отделение)}</div>` : ''}
<div class="pass">
  <div><b>Ф.И.О. пациента:</b> ${э(д.patientName || '—')}</div>
  ${д.датаРождения ? `<div><b>Дата рождения:</b> ${э(д.датаРождения)}</div>` : ''}
  <div><b>Дата исследования:</b> ${э(д.studyDate || '—')}</div>
  ${д.номерИстории ? `<div><b>№ истории болезни:</b> ${э(д.номерИстории)}</div>` : ''}
  ${д.аппарат ? `<div><b>Аппарат:</b> ${э(д.аппарат)}</div>` : ''}
</div>
${вкл('ип') && д.последовательности ? `<div class="txt" style="margin-top:5mm;">Исследование проведено в ИП: ${э(д.последовательности)}.</div>` : ''}
${вкл('ип') && д.контраст ? `<div class="txt">Контрастирование: ${э(д.контраст)}.</div>` : ''}
${вкл('клинические') ? раздел('КЛИНИЧЕСКИЕ ДАННЫЕ', д.клинические) : ''}
${вкл('описание') ? раздел('ОПИСАНИЕ', д.findings || '—') : ''}
${вкл('измерения') ? измеренияHtml : ''}
${вкл('сравнение') ? раздел('СРАВНЕНИЕ С ПРЕДЫДУЩИМ ИССЛЕДОВАНИЕМ', д.сравнение) : ''}
<h2>ЗАКЛЮЧЕНИЕ:</h2><div class="txt concl">${абзацы(д.impression || '—')}</div>
${вкл('рекомендации') ? раздел('РЕКОМЕНДАЦИИ', д.рекомендации) : ''}
<div class="sig">
  ${д.должность ? `<div class="post">${э(д.должность)}</div>` : ''}
  <div>${э(д.physician || '___________________')}</div>
</div>
</body></html>`;
  };

  on('btn-report-pdf', 'click', async () => {
    // [11.1.18] Первое замечание владельца: в настольной сборке «PDF отчёт»
    // говорил «всплывающие окна заблокированы» — оболочка честно запрещает
    // window.open (setWindowOpenHandler → deny). Открыватель exportModule
    // идёт тремя дверями по старшинству: родная Electron (printToPDF +
    // диалог сохранения), браузерная (window.open blob), запасная
    // (iframe-печать, где «Сохранить как PDF» выбирается в диалоге).
    const printHtml = сформироватьHtmlОтчёта();
    const дверь = await открытьПечатное(printHtml, 'width=800,height=600',
      прочитатьБланк().открыватьПослеСохранения !== false);   // [11.1.30]
    if (дверь === 'window') showToast('📄 Отчёт открыт — нажмите "Сохранить PDF"', 'success', 3000);
    if (дверь !== 'none') отметитьЭкспорт('PDF отчёт', '');
  });

  on('btn-report-print', 'click', () => {
    const via = openPrintWindow(сформироватьHtmlОтчёта(), window);
    if (via === 'none') { showToast('❌ Окно печати не открылось', 'error'); return; }
    отметитьЭкспорт('печать бланка', '');
    showToast('🖨 Бланк отчёта отправлен на печать', 'success', 2500);
  });

  // [11.1.20] Автозаполнение паспортной части из тегов открытого
  // исследования. Половина шапки живого бланка (ФИО, дата рождения, дата
  // исследования, № истории = AccessionNumber, аппарат = производитель +
  // модель + поле в теслах, перечень ИП = описания серий, препарат
  // контраста) уже лежит в памяти программы — раньше просто никуда не
  // подавалась. Поля остаются правимыми: часть ПАКС пишет имя транслитом,
  // и последнее слово за врачом.
  // [11.1.35] Список отделений в форме заключения. Первый пункт — «авто»:
  // модальность текущего исследования, как раньше. Остальные — все строки
  // «MR = НАЗВАНИЕ» из настроек бланка, слитые с заготовками: врач ВЫБИРАЕТ,
  // а не гадает, почему в МРТ-заключении оказалась компьютерная томография
  // (см. надгробие у поля «отделение» в собратьДанныеОтчёта).
  const _наполнитьОтделения = () => {
    const сел = $('report-dept');
    if (!сел) return;
    const было = сел.value || 'авто';
    const бланк = прочитатьБланк();
    const карта = { ...ОТДЕЛЕНИЕ_ПО_УМОЛЧАНИЮ, ...(бланк.отделения || {}) };
    const авто = названиеОтделения(_модальностьСейчас(), бланк);
    const экрА = (т) => String(т).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    сел.innerHTML = `<option value="авто">авто${авто ? ` — ${экрА(авто)}` : ' (по модальности исследования)'}</option>`
      + Object.entries(карта).map(([к, з]) => `<option value="${экрА(к)}">${экрА(к)} — ${экрА(з)}</option>`).join('');
    if ([...сел.options].some((о) => о.value === было)) сел.value = было;
  };
  _наполнитьОтделения();
  on('report-dept', 'focus', _наполнитьОтделения);   // список свеж к моменту выбора

  const заполнитьИзСнимка = async ({ тихо = false } = {}) => {
    try {
      const серии = _ctx?.getAllSeries?.() || [];
      if (!серии.length) { if (!тихо) showToast('Сначала откройте исследование', 'warning', 2500); return false; }
      const uid = серии[0]?.seriesUID;
      const ids = uid ? (getSeriesImageIds(uid) || []) : [];
      const теги = ids.length ? await getDICOMTags(ids[0]) : {};
      const ш = собратьШапку(теги, серии);
      const поставить = (id, зн) => {
        const эл = $(id);
        if (эл && зн && !эл.value.trim()) эл.value = зн;   // не затираем правку врача
      };
      поставить('report-patient', formatPatientName(ш.фио) || ш.фио);
      поставить('report-birth', ш.датаРождения);
      поставить('report-studydate', ш.датаИсследования);
      поставить('report-accession', ш.номерИстории);
      поставить('report-device', ш.аппарат);
      поставить('report-sequences', ш.последовательности);
      поставить('report-contrast', ш.контраст);
      if (!тихо) showToast('Паспортная часть заполнена из снимка — проверьте и правьте', 'success', 3000);
      return true;
    } catch (e) {
      if (!тихо) showToast('Не удалось прочитать теги: ' + e.message, 'error', 3500);
      return false;
    }
  };
  on('btn-report-autofill', 'click', () => заполнитьИзСнимка());

  // [11.1.30] Готовые наборы. Текст снятых разделов НЕ стирается: вернул
  // галочку — всё на месте.
  const _применитьНабор = (имя) => {
    const н = НАБОРЫ_РАЗДЕЛОВ[имя] || {};
    document.querySelectorAll('#report-sections input[data-section]')
      .forEach((г) => { г.checked = н[г.dataset.section] !== false; });
    showToast(имя === 'кратко' ? 'Набор «Кратко»: Описание и Заключение' : 'Набор «Полный»: все разделы', 'info', 1800);
  };
  // ══ [11.1.31] СОХРАНЁННЫЕ ЗАКЛЮЧЕНИЯ ══
  const _вФормуЗаключение = (д) => {
    const п = (id, зн) => { const э = $(id); if (э) э.value = зн || ''; };
    п('report-patient', д.patientName); п('report-birth', д.датаРождения);
    п('report-studydate', д.studyDate); п('report-accession', д.номерИстории);
    п('report-device', д.аппарат); п('report-sequences', д.последовательности);
    п('report-contrast', д.контраст); п('report-clinical', д.клинические);
    п('report-findings', д.findings); п('report-comparison', д.сравнение);
    п('report-impression', д.impression); п('report-recommendations', д.рекомендации);
    п('report-physician', д.physician); п('report-physician-title', д.должность);
    if (д.разделы) {
      document.querySelectorAll('#report-sections input[data-section]')
        .forEach((г) => { г.checked = д.разделы[г.dataset.section] !== false; });
    }
  };
  const _наполнитьЧерновики = (выбрать = '') => {
    const сел = $('report-draft-pick');
    if (!сел) return;
    const список = прочитатьЗаключения();
    сел.innerHTML = '<option value="">— сохранённые заключения —</option>'
      + список.map((з) => `<option value="${escapeHtml(з.ключ)}"${з.ключ === выбрать ? ' selected' : ''}>${escapeHtml(з.подпись)}</option>`).join('');
  };
  on('btn-report-draft-save', 'click', () => {
    const д = собратьДанныеОтчёта();
    const р = сохранитьЗаключение(д);
    if (!р.ок) { showToast(р.причина, 'error', 3500); return; }
    _наполнитьЧерновики(ключЗаключения(д));
    showToast(р.обновлено
      ? 'Заключение обновлено — прежняя запись этого исследования заменена'
      : `Заключение сохранено (всего ${р.всего})`, 'success', 2800);
  });
  on('btn-report-draft-load', 'click', () => {
    const з = загрузитьЗаключение($('report-draft-pick')?.value || '');
    if (!з) { showToast('Сначала выберите заключение в списке', 'info', 2200); return; }
    _вФормуЗаключение(з.данные);
    showToast(`Загружено: ${з.подпись}. Правьте и сохраняйте заново`, 'success', 3200);
  });
  on('btn-report-draft-del', 'click', () => {
    const ключ = $('report-draft-pick')?.value;
    if (!ключ) { showToast('Сначала выберите заключение в списке', 'info', 2200); return; }
    if (!confirm('Удалить это сохранённое заключение? Уже выгруженные файлы не тронутся.')) return;
    удалитьЗаключение(ключ);
    _наполнитьЧерновики();
    showToast('Заключение удалено', 'info', 1800);
  });
  on('btn-report-draft-export', 'click', () => {
    const з = загрузитьЗаключение($('report-draft-pick')?.value || '');
    if (!з) { showToast('Выберите заключение — или сперва сохраните текущее', 'info', 2500); return; }
    downloadBlob(new Blob([собратьФайлЗаключения(з)], { type: 'application/json' }), `заключение_${(з.данные.patientName || 'пациент').split(' ')[0]}_${new Date().toISOString().slice(0, 10)}.json`);
    отметитьЭкспорт('заключение (файл)', з.подпись);
  });
  on('btn-report-draft-import', 'click', () => $('report-draft-file')?.click());
  on('report-draft-file', 'change', async (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    const р = разобратьФайлЗаключения(await файл.text());
    e.target.value = '';
    if (!р.ок) { showToast(р.причина, 'error', 4000); return; }
    слитьЗаключения(р.записи);   // слияние, а не замена: свои записи целы
    _наполнитьЧерновики(р.записи[0].ключ);
    _вФормуЗаключение(р.записи[0].данные);
    showToast(`Загружено заключений: ${р.записи.length}. Первое подставлено в форму`, 'success', 3500);
  });
  _наполнитьЧерновики();

  on('btn-report-set-short', 'click', () => _применитьНабор('кратко'));
  on('btn-report-set-full', 'click', () => _применитьНабор('полный'));
  // Открыли вкладку «Отчёты» — заполняем молча то, что ещё пусто.
  document.querySelector('.right-tab[data-tab="tab-report"]')
    ?.addEventListener('click', () => setTimeout(() => заполнитьИзСнимка({ тихо: true }), 60), { signal: _getSignal() });

  // ── Справочник врачей и настройки бланка ──
  const наполнитьВрачей = () => {
    const сел = $('report-physician-pick');
    if (!сел) return;
    const бланк = прочитатьБланк();
    сел.innerHTML = '<option value="">— выбрать из справочника —</option>'
      + бланк.врачи.map((в, i) => `<option value="${i}">${escapeHtml(в.фио)}${в.должность ? ' — ' + escapeHtml(в.должность) : ''}</option>`).join('');
  };
  on('report-physician-pick', 'change', (e) => {
    const в = прочитатьБланк().врачи[+e.target.value];
    if (!в) return;
    if ($('report-physician')) $('report-physician').value = в.фио || '';
    if ($('report-physician-title')) $('report-physician-title').value = в.должность || '';
  });

  const разобратьПары = (текст) => String(текст || '').split('\n')
    .map((с) => с.split('='))
    .filter((ч) => ч.length >= 2 && ч[0].trim())
    .map((ч) => [ч[0].trim(), ч.slice(1).join('=').trim()]);

  const показатьНастройкиБланка = () => {
    // [11.1.31] Заполнение УБРАНО отсюда целиком: у модалки было два
    // хозяина, и побеждал этот — знавший только четыре поля, отчего шрифты
    // и вид логотипа оставались пустыми на экране (замечание владельца).
    // Теперь наполняет один — sidebarBindings, где эти поля и живут.
    window.__mikhmelЗаполнитьБланк?.();
    _ctx?.openModal?.('modal-report-blank');
  };
  on('btn-report-blank-setup', 'click', показатьНастройкиБланка);
  // [11.1.31] Видимая кнопка обзора: голое input[type=file] в проекте скрыто
  // общим правилом стиля — потому поле и не показывалось.
  on('btn-blank-logo-pick', 'click', () => $('blank-logo-file')?.click());
  on('blank-logo-file', 'change', (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    if (файл.size > 512 * 1024) { showToast('Логотип крупнее 512 КБ — возьмите файл поменьше', 'warning', 3500); return; }
    const ч = new FileReader();
    ч.onload = () => {
      const п = $('blank-logo-prev');
      if (п) { п.src = String(ч.result); п.style.display = ''; }
      const имя = $('blank-logo-name');
      if (имя) имя.textContent = файл.name;
    };
    ч.readAsDataURL(файл);
  });
  on('blank-logo-clear', 'click', () => {
    const п = $('blank-logo-prev');
    if (п) { п.src = ''; п.style.display = 'none'; }
    const имя = $('blank-logo-name');
    if (имя) имя.textContent = 'файл не выбран';
  });
  on('btn-blank-save', 'click', () => {
    const б = {
      // [11.1.30] Вид логотипа, шрифты, автооткрытие и набор разделов —
      // части ОДНОГО бланка: в профиль они должны попадать вместе с шапкой,
      // иначе перенос на другой компьютер привезёт герб без оформления.
      логотипВид: {
        ширинаМм: Number($('blank-logo-width')?.value) || 22,
        место: $('blank-logo-place')?.value || 'слева',
      },
      шрифты: {
        шапкаИмя: $('blank-font-head')?.value || 'Times New Roman',
        шапкаПт: Number($('blank-font-head-size')?.value) || 12,
        телоИмя: $('blank-font-body')?.value || 'Times New Roman',
        телоПт: Number($('blank-font-body-size')?.value) || 12,
      },
      открыватьПослеСохранения: $('blank-open-after-save') ? !!$('blank-open-after-save').checked : true,
      // [11.1.35] Поля листа: одно число на печать и Word (просьба владельца)
      поля: {
        верхМм: Number($('blank-margin-top')?.value) || 15,
        низМм: Number($('blank-margin-bottom')?.value) || 15,
        левоМм: Number($('blank-margin-left')?.value) || 15,
        правоМм: Number($('blank-margin-right')?.value) || 15,
      },
      разделы: Object.fromEntries([...document.querySelectorAll('#report-sections input[data-section]')]
        .map((г) => [г.dataset.section, !!г.checked])),
      учреждение: $('blank-org')?.value || '',
      реквизиты: $('blank-req')?.value || '',
      логотип: $('blank-logo-prev')?.src?.startsWith('data:') ? $('blank-logo-prev').src : '',
      отделения: Object.fromEntries(разобратьПары($('blank-depts')?.value).map(([к, з]) => [к.toUpperCase(), з])),
      врачи: разобратьПары($('blank-docs')?.value).map(([фио, должность]) => ({ фио, должность })),
    };
    if (!записатьБланк(б)) { showToast('Не удалось сохранить (приватный режим?)', 'error', 3000); return; }
    наполнитьВрачей();
    _наполнитьОтделения();   // [11.1.35] новые строки «MR = …» сразу в списке формы
    _ctx?.closeModal?.('modal-report-blank');
    showToast('Бланк сохранён — он подставляется во все заключения', 'success', 2500);
  });
  наполнитьВрачей();

  // [11.1.19] Предложение владельца: бланк в DOCX. Кириллица тут верна ПО
  // ПОСТРОЕНИЮ (document.xml — обычный UTF-8), а главное — файл открывается
  // в Word и ДОПИСЫВАЕТСЯ. PDF остаётся рядом как формат обмена/печати.
  on('btn-report-docx', 'click', async () => {
    try {
      const д = собратьДанныеОтчёта();
      const имя = `Заключение_${(д.patientName || 'пациент').split(' ')[0]}_${new Date().toISOString().slice(0, 10)}.docx`;
      const хотятОткрыть = прочитатьБланк().открыватьПослеСохранения !== false;
      const дверь = window.MikhmelDesktop?.saveReportFile;
      if (дверь) {
        // [11.1.30] Настольный путь: байты → системный диалог → запись →
        // открытие в Word. Браузерное «скачать в Загрузки» пути не даёт, а
        // без пути открывать нечего — поэтому в оболочке ходим этой дверью.
        const байты = await собратьDocxБайты(д);
        const р = await дверь(имя, байты, хотятОткрыть);
        if (!р?.saved) {
          showToast(р?.error ? '❌ Не сохранилось: ' + р.error : 'Сохранение отменено', р?.error ? 'error' : 'info', 2500);
          return;
        }
        отметитьЭкспорт('DOCX отчёт', имя, байты.length / 1048576);
        showToast(хотятОткрыть ? '📝 Заключение сохранено и открыто в Word' : '📝 Заключение сохранено: ' + р.path, 'success', 3000);
        return;
      }
      // Браузер: файл уходит в «Загрузки», и открыть его САМА СТРАНИЦА НЕ
      // МОЖЕТ — это запрет безопасности, а не наша недоработка. Говорим
      // правду вместо обещания.
      const размер = await скачатьDocxОтчёт(д, имя);
      отметитьЭкспорт('DOCX отчёт', имя, размер / 1048576);
      showToast(хотятОткрыть
        ? '📝 Заключение сохранено в «Загрузки». Открыть файл сама страница не может — это запрет браузера; откройте из папки загрузок'
        : '📝 Заключение сохранено в «Загрузки»', 'success', хотятОткрыть ? 5000 : 2500);
    } catch (e) { showToast('❌ DOCX не собрался: ' + e.message, 'error', 4000); }
  });

  // [11.1.16] Предзаполнение «Находок» скелетом выбранного шаблона.
  on('report-template', 'change', (e) => {
    const тело = ТЕЛА_ШАБЛОНОВ[e.target.value];
    const поле = $('report-findings');
    if (!тело || !поле) return;
    if (поле.value.trim() && !confirm('Заменить текст «Находок» скелетом шаблона?')) return;
    поле.value = тело;
  });
}

// ============================================================
// COMPARISON
// ============================================================
function bindComparison() {
  let _comparisonMode = 'off';
  let _раскладкаДоСравнения = null;   // [11.1.16] куда возвращаться при «Выкл.»
  let _priorViewportId = null;
  let _priorImageIds = [];
  let _syncScrollHandler = null;

  on('comparison-mode', 'change', (e) => {
    _comparisonMode = e.target.value;
    if (_comparisonMode === 'off') {
      disableComparison();
      showToast('Сравнение отключено', 'info', 800);
    } else {
      showToast(`Сравнение: ${_comparisonMode} — загрузите предыдущее исследование`, 'info');
    }
  });

  on('btn-load-prior', 'click', () => {
    // [11.1.16] Кнопка уважает селектор: раньше при «Выкл.» она всё равно
    // строила сравнение — селектор говорил одно, экран делал другое. Нажатие
    // на «Загрузить предыдущее» — это и есть намерение сравнивать, поэтому
    // режим включается честно: и в состоянии, и В САМОМ селекторе.
    if (_comparisonMode === 'off') {
      _comparisonMode = 'side-by-side';
      const сел = $('comparison-mode');
      if (сел) сел.value = 'side-by-side';
    }
    // Создаём скрытый file input для prior study
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.dcm,.dicom,.dic,.DCM,application/dicom';
    input.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;
      showToast(`📂 Загрузка предыдущего исследования (${files.length} файлов)...`, 'info');
      try {
        await loadPriorStudy(files);
      } catch (err) {
        showToast(`❌ Ошибка: ${err.message}`, 'error');
      }
    };
    input.click();
  });

  async function loadPriorStudy(files) {
    // Загружаем файлы через существующий loader
    // [FIX-P3] loadDICOMFiles возвращает объект {seriesUID: {…}}, НЕ {seriesUIDs: [...]}
    const result = await loadDICOMFiles(files);
    const seriesUIDs = result ? Object.keys(result) : [];
    if (seriesUIDs.length === 0) {
      showToast('❌ Не найдены DICOM серии в файлах', 'error');
      return;
    }

    const priorSeriesUID = seriesUIDs[0];
    _priorImageIds = getSeriesImageIds(priorSeriesUID);

    if (_priorImageIds.length === 0) {
      showToast('❌ Серия пуста', 'error');
      return;
    }

    // [11.1.16] Раскладка ДО сравнения запоминается — выключение вернёт её,
    // а не выкинет в жёсткое 1×1 (на десктопе по умолчанию открыт MPR:
    // «Выкл.» стоил врачу трёх окон реформатов). Запоминаем только при ВХОДЕ
    // в сравнение: повторная загрузка prior поверх идущего сравнения не
    // должна затирать настоящую «прежнюю» раскладку двухоконной.
    if (!_priorViewportId) {
      _раскладкаДоСравнения = _ctx?.getCurrentLayout?.() || null;
    }
    // Переключаем layout на 1x2
    changeLayout('1x2');
    await new Promise(r => setTimeout(r, 300));

    // Загружаем prior в правый viewport
    const vpIds = getViewportIds();
    if (vpIds.length >= 2) {
      _priorViewportId = vpIds[1];
      await loadStack(_priorViewportId, _priorImageIds);

      // Синхронизируем скролл между viewport'ами
      enableSyncScroll(vpIds[0], vpIds[1]);

      showToast(`✅ Сравнение: ${_priorImageIds.length} срезов загружено`, 'success');
    }
  }

  function enableSyncScroll(vpId1, vpId2) {
    disableSyncScroll();
    const re = getRenderingEngine();
    if (!re) return;

    // Общая логика синхронизации
    const syncFromTo = (sourceId, targetId) => {
      try {
        const sourceVp = re.getViewport(sourceId);
        const targetVp = re.getViewport(targetId);
        if (!sourceVp || !targetVp) return;
        const srcIdx = sourceVp.getCurrentImageIdIndex?.() || 0;
        const srcTotal = sourceVp.getImageIds?.()?.length || 1;
        const tgtTotal = targetVp.getImageIds?.()?.length || 1;
        const tgtIdx = Math.round((srcIdx / srcTotal) * tgtTotal);
        targetVp.setImageIdIndex?.(Math.min(tgtIdx, tgtTotal - 1));
        targetVp.render();
      } catch (err) { log.debug('[Features]', err.message); }
    };

    // #15: Подписываемся через Cornerstone eventTarget (надёжнее setTimeout)
    _syncScrollHandler = (evt) => {
      const detail = evt.detail || {};
      const vpId = detail.viewportId;
      if (vpId === vpId1) syncFromTo(vpId1, vpId2);
      else if (vpId === vpId2) syncFromTo(vpId2, vpId1);
    };

    try {
      const csCore = window.cornerstone || (window.MikhmelViewer?._csCore);
      const stackEvent = csCore?.Enums?.Events?.STACK_NEW_IMAGE;
      if (stackEvent && csCore?.eventTarget) {
        csCore.eventTarget.addEventListener(stackEvent, _syncScrollHandler);
        log.debug('[Comparison] Sync via Cornerstone STACK_NEW_IMAGE event');
      }
    } catch (e) { log.debug('[FeatureBindings]', e.message); }

    // Fallback: DOM event на viewport container
    const vc = $('viewport-container');
    if (vc) vc.addEventListener('STACK_NEW_IMAGE', _syncScrollHandler);
  }

  function disableSyncScroll() {
    if (_syncScrollHandler) {
      // Отписываемся от Cornerstone eventTarget
      try {
        const csCore = window.cornerstone || (window.MikhmelViewer?._csCore);
        const stackEvent = csCore?.Enums?.Events?.STACK_NEW_IMAGE;
        if (stackEvent && csCore?.eventTarget) {
          csCore.eventTarget.removeEventListener(stackEvent, _syncScrollHandler);
        }
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
      // Отписываемся от DOM
      const vc = $('viewport-container');
      if (vc) vc.removeEventListener('STACK_NEW_IMAGE', _syncScrollHandler);
    }
    _syncScrollHandler = null;
  }

  function disableComparison() {
    disableSyncScroll();
    _priorViewportId = null;
    _priorImageIds = [];
    // [11.1.16] Возврат к раскладке, что была ДО сравнения. 1×1 остаётся
    // только запаской на случай, когда сравнение включили раньше, чем
    // раскладка успела определиться.
    changeLayout(_раскладкаДоСравнения || '1x1');
    _раскладкаДоСравнения = null;
  }
}

// ============================================================
// MULTI-MONITOR
// ============================================================
// [12.0.51] «Отсоединить вьюпорт» был вывеской: открывал пустое окно с
// английской надписью «Viewport content syncs from main window» — ничего не
// синхронизировалось, в окне не было ни одного пикселя снимка, а тост
// говорил «Окно отсоединено». Теперь это честная копия: в новое окно идёт
// живая трансляция холста выбранного окна (canvas.captureStream), её можно
// перетащить на второй монитор. Управление — в основном окне; это сказано
// и на кнопке, и в самом окне.
export function открытьКопиюОкна(vpId) {
  const vp = getRenderingEngine()?.getViewport(vpId);
  const холст = vp?.canvas || vp?.element?.querySelector('canvas');
  if (!холст) return { ok: false, причина: 'нет открытого окна со снимком' };
  if (typeof холст.captureStream !== 'function') return { ok: false, причина: 'эта среда не умеет транслировать окно (нет captureStream)' };
  // Имя окна — то самое, что настольная оболочка пропускает (electron/main.cjs);
  // остальные окна она запрещает.
  const win = window.open('', 'mikhmel-kopiya-okna', 'width=900,height=700');
  if (!win) return { ok: false, причина: 'браузер не дал открыть окно — разрешите всплывающие окна для программы' };
  // Повторное нажатие попадает в ТО ЖЕ окно (одно имя): прежняя копия гасится.
  try { for (const т of win.__копияПоток?.getTracks?.() || []) т.stop(); } catch (e) { /* окно уже закрыто */ }
  const поток = холст.captureStream(30);
  win.__копияПоток = поток;
  const д = win.document;
  д.body.replaceChildren();
  д.title = `Копия окна «${vpId}» — только просмотр`;
  д.body.style.cssText = 'margin:0;background:#000;height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#9fb3cf;font:12px system-ui,sans-serif;';
  const видео = д.createElement('video');
  видео.autoplay = true; видео.muted = true; видео.playsInline = true;
  видео.style.cssText = 'max-width:100%;max-height:calc(100vh - 24px);background:#000;';
  видео.srcObject = поток;
  const подпись = д.createElement('div');
  подпись.style.cssText = 'padding:4px 8px;';
  подпись.textContent = `Копия окна «${vpId}». Только просмотр: листать, вращать и менять окно — в основном окне программы.`;
  д.body.append(видео, подпись);
  win.addEventListener('beforeunload', () => { for (const т of поток.getTracks()) т.stop(); });
  // Неподвижный холст кадр в поток не отдаёт — перерисуем, чтобы копия не стояла чёрной.
  try { vp.render?.(); } catch (e) { log.debug('[Копия окна]', e.message); }
  return { ok: true, окно: win, поток };
}

function bindMultiMonitor() {
  on('btn-detach-viewport', 'click', () => {
    const vpId = _ctx.getCurrentViewportId?.() || getViewportIds()[0];
    const р = vpId ? открытьКопиюОкна(vpId) : { ok: false, причина: 'нет открытого окна со снимком' };
    if (!р.ok) { showToast('Копия окна: ' + р.причина, 'warning', 5000); return; }
    showToast('Копия окна открыта — перетащите её на второй монитор. Управление — здесь', 'success', 4000);
  });
}

// ============================================================
// SYNCHRONIZER
// ============================================================
function bindSynchronizer() {
  // Toggles already bound via bindToggles
  // State is read from toggle.classList.contains('on') when needed
}

// ============================================================
// SLAB / THICKNESS
// ============================================================
// [11.0.2] bindSlabControls УДАЛЕНА. Вся её работа состояла из одной строки:
// список «Режим» менял всплывающую плашку с собственным названием и НЕ трогал
// проекцию. Это вывеска — та самая порода, что выкорчёвывалась весь месяц.
// Настоящее переключение проекции живёт в proFeaturesBindings
// (btn-pro-slab-mip / minip / avg / cycle → viewportEffects.setSlabProjection).

// ============================================================
// CLINICAL TOOLS
// ============================================================
function bindClinicalTools() {
  // [REFACTOR] Единый источник привязки — никаких stub-обработчиков, никакого cloneNode.
  // Кнопки disabled до загрузки clinicalTools.js, затем привязываются реальные обработчики.
  const CLINICAL_BTNS = [
    // [10.19.28] Пять незаконченных кнопок удалены из программы — их id ушли
    // и отсюда: список включает/выключает кнопки на время загрузки модуля, и
    // ссылки на несуществующие элементы делали бы его молча неполным.
    // [12.0.52] btn-pneumothorax, btn-aorta-diameter, btn-fracture-detect — удалены.
    'btn-agatston','btn-ctr','btn-emphysema','btn-bmd','btn-medsam',
    'btn-sam-undo','btn-sam-clear','btn-sam-run','btn-region-grow'
  ];

  // Шаг 1: disable все кнопки пока модуль грузится
  CLINICAL_BTNS.forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.disabled = true;
      el.style.opacity = '0.5';
    }
  });

  // Шаг 2: загрузить реальный модуль — единственный источник обработчиков
  import('./clinicalTools.js').then(m => {
    if (m?.bindAllClinicalTools) {
      m.bindAllClinicalTools(() => _ctx.getCurrentVolumeId());
      // [10.19.24] Флаг «клинический модуль на месте»: по нему bindAI понимает,
      // что ONNX-моделями без отката есть кому владеть (см. ранний return там).
      try { document.body.dataset.clinicalToolsReady = '1'; } catch (e) { /* */ }
      // Шаг 3: enable кнопки
      CLINICAL_BTNS.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
          el.disabled = false;
          el.style.opacity = '';
        }
      });
      log.debug('[UI] clinicalTools.js loaded — real AI tools active');
    }
  }).catch(() => {
    // Модуль недоступен — пометить кнопки как "в разработке"
    const STUB_BTNS = ['btn-ctr', 'btn-emphysema'];
    CLINICAL_BTNS.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.disabled = false;
        el.style.opacity = '';
        if (STUB_BTNS.includes(id)) {
          el.classList.add('stub-btn');
          el.title = (el.title || el.textContent.trim()) + ' (в разработке)';
        } else {
          // Fallback: показать toast при клике
          el.addEventListener('click', () => showToast('⚠️ Модуль клинических инструментов не загружен', 'warning'), { once: true });
        }
      }
    });
    log.debug('[UI] clinicalTools.js not found — buttons in fallback mode');
  });
}

// ============================================================
// SPECIAL MODES
// ============================================================
function bindSpecialModes() {
  // [10.3.5] Здесь был список из девяти кнопок, которым проставляли пометку
  // «(в разработке)». Восемь из них были обещанием без исполнения: нажатие
  // показывало тост и на этом всё — ни DSA, ни стоматологической панорамы, ни
  // экспорта NIfTI / RT-STRUCT / MP4, ни эндоскопии, ни обзорного скана, ни
  // удаления костей не происходило. Кнопки убраны из разметки вместе с
  // обработчиками: пустая кнопка в медицинской программе хуже, чем её
  // отсутствие — врач на неё рассчитывает.
  //
  // Девятая, btn-export-stl, из списка убрана по другой причине: у неё есть
  // НАСТОЯЩИЙ обработчик (инлайновый модуль в index.html → exportSTL из
  // vtkModule), и пометка «в разработке» на ней была неправдой.
  //
  // Помечать больше нечего, поэтому и списка нет.

  // ── ВЫКЛЮЧАТЕЛИ ОСЕЙ ОТСЕЧЕНИЯ [10.19.30] ─────────────────────────────
  // Были украшением: щёлкали классом (общий bindToggles), а плоскость стояла
  // по одному значению ползунка — выключить срез выключателем было НЕЛЬЗЯ.
  // Теперь выключатель зовёт setClipAxisEnabled: ось снимается сразу, значение
  // ползунка сохраняется, повторное включение возвращает срез на место.
  // Движение ползунка включает свою ось само (двигать выключенный срез —
  // бессмыслица) и подсвечивает выключатель, чтобы показ не расходился с делом.
  // [12.0.57] Включение выключателя БЕЗ движения ползунка не резало ничего:
  // ползунок стоит на 50%, а внутреннее значение оси — 0 (его задаёт только
  // движение ползунка), и включённая ось с нулём плоскости не ставит. Теперь
  // включение берёт значение с ползунка. Отказ (нет объёмного окна, шесть
  // плоскостей уже заняты вкладкой «3D») говорится вслух — раньше ползунок
  // двигался, а на экране не менялось ничего и без объяснений.
  let _отчётОтсеченияВ = 0;
  const _отчётОтсечения = (р) => {
    if (!р?.причина || Date.now() - _отчётОтсеченияВ < 4000) return;
    _отчётОтсеченияВ = Date.now();
    showToast(`Сечение: ${р.причина}`, 'warning', 5000);
  };
  for (const ось of ['x', 'y', 'z']) {
    _ownToggle(`clip-${ось}-on`, (вкл) => {
      if (!вкл) { Promise.resolve(setClipAxisEnabled(ось, false)).then(_отчётОтсечения); return; }
      const значение = Number($(`clip-${ось}`)?.value) || 0;
      const зн = { x: null, y: null, z: null };
      зн[ось] = значение;
      setVolumeClipping(зн.x, зн.y, зн.z).then(_отчётОтсечения);
      if (!значение) showToast(`Сечение ${ось.toUpperCase()}: ползунок на 0% — резать нечего, сдвиньте его`, 'info', 3000);
    });
    on(`clip-${ось}`, 'input', () => {
      const т = $(`clip-${ось}-on`);
      if (т && !т.classList.contains('on')) { т.classList.add('on'); т.setAttribute('aria-checked', 'true'); }
      // Само отсечение ставит слушатель в sidebarBindings; здесь — ось и отказ.
      const зн = { x: null, y: null, z: null };
      зн[ось] = Number($(`clip-${ось}`)?.value) || 0;
      setVolumeClipping(зн.x, зн.y, зн.z).then(_отчётОтсечения);
    });
  }

  // ── АВТОВРАЩЕНИЕ И «ПОВОРОТНЫЙ» [10.19.30] ────────────────────────────
  // Оба выключателя ничего не крутили. Теперь: «Автовращение» облетает камерой
  // объёмного окна точку фокуса (18°/с, по часам, а не по кадрам); «Поворотный»
  // задаёт характер облёта — гончарный круг вокруг оси Z мира с ровным
  // горизонтом, либо свободная орбита вокруг текущей вертикали камеры.
  // Без объёмного окна включение ОТКАЗЫВАЕТ с объяснением, а не делает вид.
  _ownToggle('toggle-autospin', (вкл) => {
    if (вкл) {
      // [10.19.31] Два двигателя не крутят одну камеру: перед стартом глушим
      // кнопочное вращение из левого сайдбара (Гориз./Верт., viewportCamera).
      for (const id of getViewportIds() || []) { try { stopAutoRotate(id); } catch (e) { /* окна без вращения */ } }
      if (!startAutoSpin()) {
        showToast('Автовращение: нет объёмного окна — откройте раскладку с 3D', 'warning', 3500);
        return false; // отказ: выключатель остаётся выключенным
      }
    } else {
      stopAutoSpin();
    }
  });
  _ownToggle('toggle-turntable', (вкл) => {
    setAutoSpinTurntable(вкл);
    if (isAutoSpinOn()) showToast(вкл ? 'Поворотный: гончарный круг, горизонт ровный' : 'Поворотный выключен: свободная орбита', 'info', 2000);
  });

  // ── УМНЫЙ W/L [10.19.30] ──────────────────────────────────────────────
  // Подпись «Кликните по ткани для определения» висела при выключателе,
  // который никого не слушал. Теперь режим настоящий: пока включён, клик по
  // снимку берёт пробу 7×7 вокруг точки, по медиане ОПРЕДЕЛЯЕТ ткань и ставит
  // окно её класса: лёгкое (≤ −300 HU) → WW 1500 / WL −600, кость (≥ 200 HU)
  // → WW 1800 / WL 400, между ними — мягкие ткани, WW 350 и WL по самой пробе.
  // Границы — это радиологические соглашения по HU, а не подгонка: воздух в
  // лёгком глубоко отрицателен, губчатая кость начинается за +200.
  // Если включён «ROI W/L» (он ведёт окно по разбросу области), уступаем ему.
  {
    let _smartOn = false;
    const _вк = $('viewport-container');
    // [12.0.57] Проба переписана. На стенде с настоящим Cornerstone щелчок в
    // лёгкое давал «Умный W/L: мягкие ткани (медиана NaN HU) → WW 350 / WL NaN»:
    // значения брались getVolumeScalarData (в окнах MPR она пуста), а точка
    // щелчка переводилась в воксель по прямоугольнику ВСЕЙ области окон — в
    // раскладке из пяти окон это чужое окно. Теперь: окно — то, по которому
    // щёлкнули; точка — его canvasToWorld; проба 7×7 вокселей в плоскости
    // этого окна (ui/specModes.js); окно W/L ложится по общему правилу 12.0.49
    // — в это окно и окна той же модальности (applyWindowToSlices).
    const _проба = (e) => {
      if (!_smartOn) return;
      if ($('btn-roi-wl')?.classList.contains('active')) return; // ROI W/L главнее
      try {
        const п = пробаПодМышью(e, 3);
        if (!п.ok) { showToast(`Умный W/L: ${п.причина}`, 'warning', 3000); return; }
        if (п.модальность && п.модальность !== 'CT') {
          showToast(`Умный W/L различает ткани по HU — они есть только у КТ, а в этом окне ${п.модальность}`, 'warning', 4500);
          return;
        }
        const мед = медиана(п.значения);
        const т = тканьПоHU(мед);
        if (!т) { showToast('Умный W/L: в точке нет чисел снимка', 'warning', 3000); return; }
        const окон = applyWindowToSlices({ ww: т.ww, wc: т.wc }, п.id);
        showToast(`Умный W/L: ${т.ткань} (медиана ${Math.round(мед)} HU по ${п.значения.length} точкам) → WW ${т.ww} / WL ${т.wc}${окон > 1 ? ` · окон: ${окон}` : ''}`, 'success', 3000);
      } catch (err) { log.warn('[SmartWL]', err); showToast('Умный W/L: ' + err.message, 'warning', 3500); }
    };
    _ownToggle('toggle-smart-wl', (вкл) => {
      if (!_вк) return false;
      _smartOn = вкл;
      if (вкл) { _вк.addEventListener('click', _проба); _вк.style.cursor = 'crosshair'; showToast('Умный W/L: кликните по ткани — лёгкое, мягкие или кость', 'info', 2500); }
      else { _вк.removeEventListener('click', _проба); _вк.style.cursor = ''; }
    });
  }

  // ── DSA: ВЫЧИТАНИЕ ДВУХ ОБЪЁМОВ [10.19.30] ────────────────────────────
  // Раздел стоял мёртвым с 10.3.5: списки «— выбрать —» никто не заполнял,
  // «Усиление» меняло только цифру. Теперь вычитание настоящее и работает по
  // УЖЕ ПОСТРОЕННЫМ объёмам (реестр volumeRegistry — основной том, наложение
  // добавленный «Слиянием PET-CT», предыдущий из «Сравнения»): контраст −
  // маска, воксель
  // к вокселю, разность умножается на усиление и показывается MIP-картинкой —
  // это и есть классический вид субтракционной ангиограммы. Разные размеры
  // объёмов — честный отказ с обоими размерами: без совмещения такое
  // вычитание было бы кашей, а совмещение здесь не делается и не обещано.
  {
    // [12.0.57] DSA НЕ СЧИТАЛ НИ РАЗУ. Тома брались через window.cornerstone —
    // программа это имя не заводит (ПЕРЕДАЧА-ДЕЛ-12.0.54, §3), — да ещё по
    // имени из реестра, где оно хранится без приставки тома. На стенде: в
    // списках «грудь» без размеров, по кнопке — «не удалось прочитать данные
    // объёма из кэша». Теперь тома — из кэша Cornerstone через volumePick
    // (имя понимается и с приставкой, и без), сетки сверяются целиком (размер,
    // шаг, начало, оси), а MIP разности — фронтальный, голова сверху, правая
    // сторона пациента слева: так выглядит субтракционная ангиограмма. Прежде
    // MIP шёл вдоль оси срезов — получался вид «сверху», а не ангиограмма.
    const _списки = () => [$('dsa-mask-series'), $('dsa-contrast-series')];
    const _объём = (vid) => {
      try { const н = найтиТом(cornerstone.cache, vid, []); return н.ok ? н.том : null; } catch (e) { return null; }
    };
    const _заполнить = () => {
      const ids = knownVolumeIds();
      for (const сп of _списки()) {
        if (!сп) continue;
        const было = сп.value;
        сп.innerHTML = '<option value="">— выбрать —</option>';
        for (const vid of ids) {
          const v = _объём(vid);
          const d = v?.dimensions;
          const о = document.createElement('option');
          о.value = vid;
          const хвост = String(vid).split(/[:/]/).pop().slice(-24);
          const мод = v?.metadata?.Modality ? `${v.metadata.Modality} · ` : '';
          о.textContent = d ? `${мод}${хвост} · ${d[0]}×${d[1]}×${d[2]}` : хвост;
          сп.appendChild(о);
        }
        if (было && ids.includes(было)) сп.value = было;
      }
    };
    _заполнить();
    onRegistryChange(_заполнить);
    for (const сп of _списки()) if (сп) сп.addEventListener('focus', _заполнить, { signal: _getSignal() });

    on('btn-dsa-run', 'click', async () => {
      const [мс, кс] = _списки();
      const мид = мс?.value, кид = кс?.value;
      if (!мид || !кид) { showToast('DSA: выберите обе серии — маску и контраст. В списке — уже построенные объёмы: основной, добавленный «Слиянием PET-CT» и предыдущий из «Сравнения»', 'warning', 4500); return; }
      if (мид === кид) { showToast('DSA: маска и контраст — один и тот же объём, вычитать нечего', 'warning', 3500); return; }
      const мв = _объём(мид), кв = _объём(кид);
      if (!мв || !кв) { showToast('DSA: объём из списка уже выгружен из памяти — откройте серию заново', 'error', 4500); return; }
      showToast('DSA: вычитаю и строю MIP…', 'info', 1500);
      await new Promise((r) => setTimeout(r, 30));   // дать тосту показаться до долгого счёта
      const t0 = Date.now();
      try {
        const мд = данныеТома(мв), кд = данныеТома(кв);
        if (!мд || !кд) { showToast('DSA: данные объёма не читаются — подождите окончания загрузки и повторите', 'error', 4500); return; }
        const г = геометрияСовпадает(мд, кд);
        if (!г.ok) {
          showToast(`DSA: ${г.причина}. Вычитание воксель-к-вокселю без совмещения тут дало бы кашу`, 'error', 7000);
          return;
        }
        const усил = parseFloat($('dsa-gain')?.value || '1') || 1;
        const r = мипРазности(кд.scalarData, мд.scalarData, кд.dims, кд.direction, усил, кд.spacing);
        const разм = r.макс - r.мин || 1;
        const холст = document.createElement('canvas');
        холст.width = r.width; холст.height = r.height;
        // Пиксель картинки — шаг по горизонтали × шаг по вертикали (толщина
        // среза больше шага в плоскости): пропорции держит CSS.
        холст.style.cssText = `max-width:100%;width:100%;aspect-ratio:${r.width * r.шагГор} / ${r.height * r.шагВерт};image-rendering:pixelated;border:1px solid #2a3546;border-radius:8px;`;
        const ctx2 = холст.getContext('2d');
        const img = ctx2.createImageData(r.width, r.height);
        for (let i = 0; i < r.data.length; i++) {
          const g = Math.round(((r.data[i] - r.мин) / разм) * 255);
          img.data[i * 4] = img.data[i * 4 + 1] = img.data[i * 4 + 2] = g;
          img.data[i * 4 + 3] = 255;
        }
        ctx2.putImageData(img, 0, 0);
        const w = _окноРезультата(`DSA · контраст − маска, усиление ×${усил.toFixed(1)}`);
        w.тело.appendChild(холст);
        w.тело.insertAdjacentHTML('beforeend',
          `<div style="margin-top:8px;color:#9fb3cf;">Фронтальный MIP разности (голова сверху, правая сторона пациента слева) · ${r.width}×${r.height} · разброс ${Math.round(r.мин)}…${Math.round(r.макс)} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
          + '<div style="margin-top:6px;color:#8fa3c0;">Вычитание воксель-к-вокселю без совмещения: любое смещение пациента между сериями останется на картинке. Не для диагностики.</div>');
        w.тело.appendChild(w.закрыть);
      } catch (e) {
        showToast('DSA: ' + e.message, 'error', 5000);
      }
    });
  }

  // [12.0.57] «УДАЛИТЬ СТОЛ» — ЯРЛЫК на «Стол (сзади)» вкладки 3D.
  //
  // Здесь стоял свой обработчик, и он не сработал ни разу: том брался через
  // window.cornerstone, которого программа не заводит, — на стенде при
  // открытой раскладке MPR кнопка отвечала «объём не загружен. Загрузите
  // серию в MPR». Хуже то, что он делал бы, если бы сработал: искал стол по
  // средней плотности строк одного среза и ПЕРЕПИСЫВАЛ воксели ниже найденной
  // строки на −1024 прямо в томе, по которому идут все замеры, — до
  // перезагрузки исследования, без отмены.
  //
  // Настоящее «убрать стол» в программе уже есть (sidebarBindings, 11.1.26 →
  // 12.0.31): плоскость отсечения режет ПОКАЗ во всех объёмных окнах, данные
  // не трогает, уровень правится ползунком «Глубина сзади», после перезагрузки
  // кладётся заново. Кнопка нажимает тот тумблер — путь один, хозяин один, —
  // и подсвечена, пока стол отсечён.
  {
    const кнопка = $('btn-remove-table');
    const тумблер = () => $('vrt-crop-table');
    const отразить = () => { const т = тумблер(); if (кнопка && т) кнопка.classList.toggle('active', т.classList.contains('on')); };
    on('btn-remove-table', 'click', () => {
      const т = тумблер();
      if (!т) { showToast('Отсечение стола — во вкладке «3D»: тумблер «Стол (сзади)»', 'info', 4000); return; }
      т.click();
    });
    if (кнопка && тумблер() && typeof MutationObserver === 'function') {
      new MutationObserver(отразить).observe(тумблер(), { attributes: true, attributeFilter: ['class'] });
      отразить();
    }
  }
  // [10.19.11] Сброс наклона тоже переехал в ui/obliqueBindings.js. Здесь он
  // только обнулял ползунки и печатал «Oblique reset» — камеру не трогал,
  // потому что её и не наклоняли. Новый сброс возвращает ЗАПОМНЕННУЮ исходную
  // ориентацию: на косой серии нули дали бы не то, с чего начали.
  // [10.19.30] Три лживых обработчика закладок УБРАНЫ. Они печатали «⭐ Срез в
  // закладках» / «⬅ Предыдущая», НИЧЕГО не делая, — и держались только на том,
  // что proFeaturesBindings позже подменял узлы через _rebind настоящими
  // обработчиками (addBookmark / navigateBookmarks из viewport.js). Подмена —
  // страховка, а не оправдание: врать до неё нельзя. Хозяин закладок один —
  // proFeaturesBindings.bindBookmarks().
  // Scout
  // Export formats
  // [10.19.10] Здесь был второй обработчик на btn-export-stl — подсказка
  // «Exporting STL...», за которой ничего не происходило. У кнопки было два
  // хозяина, и оба не работали. Единственный обработчик теперь в
  // src/ui/toolsBindings.js, рядом с glTF и VRML: сетка строится из тома.

  // Memory cleanup
  // [FIX-5] Memory cleanup — полная очистка включая кэш Cornerstone
  // [12.0.57] «Очистить память» закрывала исследование БЕЗ ВОПРОСА — тем же
  // _ctx.clearAllData, что и «Очистить исследования» в верхней панели, у
  // которой вопрос стоит с 11.0.6 ровно из-за цены промаха (5097 файлов —
  // 38 с на компьютере, 202 с на телефоне). Здесь вопроса не было: на стенде
  // нажатие — и очистка, вопросов 0. Теперь кнопка нажимает ту кнопку: путь
  // один, вопрос один. Без неё (урезанная разметка) — тот же вопрос здесь.
  on('btn-memory-clean', 'click', () => {
    const главная = $('btn-clear');
    if (главная) { главная.click(); return; }
    const серий = (() => { try { return (_ctx.getAllSeries?.() || []).length; } catch (e) { return 0; } })();
    if (серий === 0) { showToast('Нечего очищать — исследования не загружены', 'info', 2000); return; }
    if (!confirm(`Закрыть загруженные исследования?\n\nСерий в памяти: ${серий}. Файлы на диске не изменятся — их можно открыть заново.`)) return;
    _ctx.clearAllData();
  });
}

function bindClinicalExtras() {
  bindTAVI();
  // [12.0.52] bindTAVIMeasurement() удалена — см. надгробие у openMeasDB.
  bindROIHistogram();
  bindROIWL();
  bindContrastGraph();
  // bindAnonymize, bindQRSharing — перенесены в fileOps.js (вызываются из initFileOps)
  // [11.1.2] bindVoiceControl() больше не зовётся: привязки к кнопке нет,
  // голос включается пунктом сайдбара через переключитьГолос().
  bindWebGPUCheck();
  bindTFEditor();
  bindMeasurementTrend();    // ПУНКТ 16
  // bindLeftPanelVRT / bindLeftPanelOrient — УДАЛЕНЫ, дублировали bindVRTSection()
  window.__uiManagerReady = true;
}

// ─── TAVI ─────────────────────────────────────────────────────
/**
 * [12.0.52] ЕДИНСТВЕННЫЙ хозяин окна TAVI. Второй обработчик «Рассчитать»
 * жил в ui/appInit.js со своей таблицей; срабатывали оба, побеждал
 * последний. Таблицы и расчёт — core/taviSizing.js (диапазоны — по памяти,
 * по инструкциям производителей, с оговоркой в окне).
 *
 * Поля ввода больше НЕ дописываются расчётом: прежде после первого
 * «Рассчитать» по периметру в поле площади появлялась площадь круга, и
 * следующий расчёт принимал её за измеренную.
 */
function bindTAVI() {
  on('btn-tavi', 'click', () => {
    const modal = $('modal-tavi');
    if (modal) modal.classList.add('open');
  });

  on('btn-tavi-calc', 'click', async () => {
    const rec = $('tavi-recommendation');
    const { подобратьTAVI } = await import('../core/taviSizing.js');
    const р = подобратьTAVI({
      диаметр: $('tavi-annulus-d')?.value,
      периметр: $('tavi-annulus-p')?.value,
      площадь: $('tavi-annulus-a')?.value,
      коронары: $('tavi-coronary-dist')?.value,
    });
    if (!rec) return;
    if (!р.ok) { rec.innerHTML = `<span style="color:var(--warning)">${р.причина}</span>`; return; }
    rec.innerHTML =
      `<b>Edwards SAPIEN 3</b> (по площади ${р.площадь} мм² — ${р.площадьОткуда}): ${р.sapien.текст}<br>`
      + `<b>Medtronic Evolut</b> (по периметру ${р.периметр} мм — ${р.периметрОткуда}): ${р.evolut.текст}`
      + р.предупреждения.map((т) => `<br><span style="color:var(--warning)">${т}</span>`).join('')
      + '<br><small style="color:var(--text-dim)">Диапазоны размеров — по инструкциям производителей, внесены по памяти: '
      + 'перед планированием сверьте с действующей инструкцией. Окончательный выбор — за командой TAVI.</small>';
  });

  // [12.0.52] Обработчик скрытой кнопки «PDF» убран вместе с кнопкой: он
  // показывал «Экспорт TAVI-отчёта в PDF…» и не делал ничего.
}

// ─── ROI HISTOGRAM ────────────────────────────────────────────
function bindROIHistogram() {
  // [12.0.57] Окно открывается через распорядителя окон и сразу считает:
  // прежде открывалось пустым, и до «Обновить» врач видел чёрный холст.
  on('btn-roi-histogram', 'click', () => {
    try { (_ctx?.openModal || ((id) => $(id)?.classList.add('open')))('modal-roi-hist'); }
    catch (e) { $('modal-roi-hist')?.classList.add('open'); }
    $('btn-rh-update')?.click();
  });

  // [12.0.57] ГИСТОГРАММА — ВЫБРАННОГО ОКНА И ПО ROI, КАК ОБЕЩАНО.
  // Окно гистограммы говорило «Выделите RectangleROI, затем нажмите
  // „Обновить“», а расчёт ROI не смотрел вовсе: брал ВЕСЬ снимок первой стопки
  // раскладки через getVolumeScalarData. На стенде (MPR 6): выбрано
  // аксиальное окно на 20-м срезе — гистограмма показывала стопку «Нативные
  // срезы» на её срезе; в раскладке без стопки — «нет данных снимка» при
  // открытом исследовании. Теперь: окно — выбранное щелчком; срез — тот, что
  // на экране (в реформате тоже); если на нём нарисован прямоугольник, эллипс
  // или круг — гистограмма по нему, иначе по всему срезу, и это сказано.
  on('btn-rh-update', 'click', () => {
    const canvas = $('roi-hist-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const setText = (id, txt) => { const el = $(id); if (el) el.textContent = txt; };
    const где = $('rh-where');

    const о = окноВыбранное({ плоское: true });
    const с = о.ok ? срезОкна(о.vp) : о;
    const ст = с.ok ? статистика(с.значения) : null;
    if (!с.ok || !ст) {
      ['rh-min', 'rh-max', 'rh-mean', 'rh-std'].forEach((id) => setText(id, '—'));
      const причина = с.ok ? 'на срезе нет чисел снимка' : с.причина;
      if (где) где.textContent = `Гистограммы нет: ${причина}`;
      showToast(`Гистограмма: ${причина}`, 'warning', 4000);
      return;
    }
    const ед = с.модальность === 'CT' ? ' HU' : '';
    setText('rh-min', `${ст.мин.toFixed(0)}${ед}`);
    setText('rh-max', `${ст.макс.toFixed(0)}${ед}`);
    setText('rh-mean', `${ст.среднее.toFixed(1)}${ед}`);
    setText('rh-std', ст.ско.toFixed(1));
    const подпись = `${с.где} · срез ${с.номер ?? '?'} из ${с.всего ?? '?'} · окно «${о.id}» · вокселей: ${ст.n}`;
    if (где) где.textContent = подпись;
    showToast(`Гистограмма: ${подпись}`, 'success', 2500);

    // Гистограмма 256 корзин
    const bins = 256;
    const { корзины: hist } = гистограмма(с.значения, bins, ст.мин, ст.макс);
    let maxCount = 0;
    for (let i = 0; i < bins; i++) if (hist[i] > maxCount) maxCount = hist[i];

    // Рисуем
    const w = canvas.width, h = canvas.height, pad = 30;
    ctx.fillStyle = '#0a0f16';
    ctx.fillRect(0, 0, w, h);
    const barW = (w - pad * 2) / bins;
    for (let i = 0; i < bins; i++) {
      const barH = (hist[i] / (maxCount || 1)) * (h - pad * 2);
      ctx.fillStyle = `hsl(${(i / bins) * 240}, 70%, 55%)`;
      ctx.fillRect(pad + i * barW, h - pad - barH, barW, barH);
    }
    // Оси
    ctx.strokeStyle = '#334';
    ctx.beginPath(); ctx.moveTo(pad, pad); ctx.lineTo(pad, h - pad); ctx.lineTo(w - pad, h - pad); ctx.stroke();
    ctx.fillStyle = '#889'; ctx.font = '9px monospace'; ctx.textAlign = 'center';
    ctx.fillText(`${ст.мин.toFixed(0)}${ед}`, pad + 10, h - pad + 12);
    ctx.fillText(`${ст.макс.toFixed(0)}${ед}`, w - pad - 10, h - pad + 12);
  });
}

// ─── ROI W/L (Smart Contrast) ─────────────────────────────────
// [12.0.57] Щелчок давал «🎯 WW=NaN / WL=NaN» и окно не менялось: те же
// пустые значения getVolumeScalarData и та же точка «по прямоугольнику всей
// области окон», что у «Умного W/L». Теперь — окно, по которому щёлкнули,
// проба 21×21 вокселей в его плоскости (ui/specModes.js), края окна — 5-й и
// 95-й перцентили пробы (core/specModesCore.окноПоОбласти), окно ложится по
// общему правилу 12.0.49: в это окно и окна той же модальности.
function bindROIWL() {
  let handler = null;

  on('btn-roi-wl', 'click', () => {
    _roiWlActive = !_roiWlActive;
    const btn = $('btn-roi-wl');
    if (btn) btn.classList.toggle('active', _roiWlActive);
    const vc = $('viewport-container');
    if (!vc) return;

    if (_roiWlActive) {
      vc.style.cursor = 'crosshair';
      showToast('ROI W/L: щёлкните по области снимка — окно подберётся по квадрату 21×21 точку с шагом в воксель', 'info', 3000);
      handler = (e) => {
        if (!_roiWlActive) return;
        try {
          const п = пробаПодМышью(e, 10);
          if (!п.ok) { showToast(`ROI W/L: ${п.причина}`, 'warning', 3000); return; }
          const w = окноПоОбласти(п.значения);
          if (!w) { showToast('ROI W/L: в области нет чисел снимка', 'warning', 3000); return; }
          const окон = applyWindowToSlices({ ww: w.ww, wc: w.wc }, п.id);
          const ед = п.модальность === 'CT' ? ' HU' : '';
          showToast(`ROI W/L: WW ${w.ww} / WL ${w.wc}${ед} — по ${w.n} точкам (5–95 перцентиль)${окон > 1 ? ` · окон: ${окон}` : ''}`, 'success', 2500);
        } catch (err) { log.warn('ROI W/L:', err); showToast('ROI W/L: ' + err.message, 'warning', 3500); }
      };
      vc.addEventListener('click', handler);
    } else {
      vc.style.cursor = '';
      if (handler) { vc.removeEventListener('click', handler); handler = null; }
      showToast('ROI W/L выключен', 'info', 800);
    }
  });
}

// ─── CONTRAST GRAPH ───────────────────────────────────────────
function bindContrastGraph() {
  on('btn-contrast-graph', 'click', () => {
    const modal = $('modal-contrast-graph');
    if (modal) modal.classList.add('open');
  });

  on('btn-cg-draw', 'click', () => {
    const canvas = $('contrast-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width, h = canvas.height, pad = 40;
    const huMin = parseInt($('cg-min')?.value) || -1024;
    const huMax = parseInt($('cg-max')?.value) || 3071;

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#0a0f16';
    ctx.fillRect(0, 0, w, h);

    // Текущие W/L из viewport
    let currentWW = 400, currentWL = 40;
    try {
      const re = getRenderingEngine();
      if (re) {
        const vp = re.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        const props = vp?.getProperties?.();
        if (props?.voiRange) {
          currentWW = props.voiRange.upper - props.voiRange.lower;
          currentWL = (props.voiRange.upper + props.voiRange.lower) / 2;
        }
      }
    } catch (e) { log.debug('[FeatureBindings]', e.message); }

    const range = huMax - huMin;
    const rampLeft = (currentWL - currentWW / 2 - huMin) / range * (w - pad * 2) + pad;
    const rampRight = (currentWL + currentWW / 2 - huMin) / range * (w - pad * 2) + pad;
    const centerX = (rampLeft + rampRight) / 2;

    // Фоновый градиент
    const grad = ctx.createLinearGradient(rampLeft, 0, rampRight, 0);
    grad.addColorStop(0, 'rgba(0,157,255,0.05)');
    grad.addColorStop(0.5, 'rgba(0,157,255,0.15)');
    grad.addColorStop(1, 'rgba(0,157,255,0.05)');
    ctx.fillStyle = grad;
    ctx.fillRect(rampLeft, pad, rampRight - rampLeft, h - pad * 2);

    // Трансфер-функция
    ctx.strokeStyle = '#0af'; ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(pad, h - pad);
    ctx.lineTo(Math.max(pad, rampLeft), h - pad);
    ctx.lineTo(Math.min(w - pad, rampRight), pad);
    ctx.lineTo(w - pad, pad);
    ctx.stroke();

    // Центральная линия W/L
    ctx.strokeStyle = '#fa4'; ctx.lineWidth = 1; ctx.setLineDash([4, 4]);
    ctx.beginPath(); ctx.moveTo(centerX, pad); ctx.lineTo(centerX, h - pad); ctx.stroke();
    ctx.setLineDash([]);

    // Оси
    ctx.strokeStyle = '#334'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(pad, pad); ctx.lineTo(pad, h - pad); ctx.lineTo(w - pad, h - pad); ctx.stroke();

    // Подписи
    ctx.fillStyle = '#889'; ctx.font = '10px monospace'; ctx.textAlign = 'center';
    ctx.fillText(`${huMin} HU`, pad + 30, h - pad + 14);
    ctx.fillText(`${huMax} HU`, w - pad - 30, h - pad + 14);
    ctx.fillStyle = '#fa4'; ctx.fillText(`WL: ${currentWL.toFixed(0)}`, centerX, pad - 6);
    ctx.fillStyle = '#0af'; ctx.fillText(`WW: ${currentWW.toFixed(0)}`, centerX, h - pad + 14);

    // Y label
    ctx.save();
    ctx.translate(12, h / 2); ctx.rotate(-Math.PI / 2);
    ctx.fillStyle = '#889'; ctx.fillText('Яркость', 0, 0);
    ctx.restore();
  });
}

// ─── ANONYMIZE ────────────────────────────────────────────────
// ════════════════════════════════════════════════════════════════
// ПУНКТ 12: DICOM Structured Report Export
// ════════════════════════════════════════════════════════════════
/**
 * [6.7.18 FIX] Экспорт DICOM SR.
 *
 * БЫЛО: эта функция собирала объект и сохраняла его как **JSON**
 *   (файл `*.dicom-sr.json`), хотя кнопка называется «DICOM SR».
 *   То есть настоящий DICOM-файл не создавался вообще — получить его можно
 *   было только из панели Enterprise, где вызывался dicomSRModule.
 *   Плюс SOP Class здесь был 88.33, а в самом модуле 88.22 — расхождение.
 *
 * СТАЛО: кнопка вызывает тот же проверенный бинарный писатель
 *   (dicomSRModule), что и панель Enterprise. Один путь, один SOP Class,
 *   на выходе настоящий .dcm.
 */
async function exportDICOMSR() {
  showToast('📦 Создание DICOM SR...', 'info');

  try {
    // Собираем аннотации из Cornerstone3D
    const csTools = window.cornerstoneTools || window.MikhmelViewer?._csTools;
    let annotations = [];
    if (csTools?.annotation?.state?.getAllAnnotations) {
      annotations = csTools.annotation.state.getAllAnnotations() || [];
    }
    if (!Array.isArray(annotations) || annotations.length === 0) {
      showToast('⚠️ Нет измерений для экспорта — сделайте хотя бы одно', 'warning', 4000);
      return;
    }

    // Метаданные текущей серии
    const allSeries = _ctx.getAllSeries?.() || [];
    const series = allSeries.find(s => s.seriesUID === _ctx.getCurrentSeries?.()) || allSeries[0] || {};

    const { exportAnnotationsToDicomSR, downloadDicomSR } = await import('../io/dicomSRModule.js');
    const blob = await exportAnnotationsToDicomSR(annotations, {
      patientName: series.patientName || 'ANONYMOUS',
      patientId: series.patientId || '',
      studyUID: series.studyUID || undefined,
      modality: series.modality || 'CT',
      observerName: 'Mikhmel A.V.',
    });

    const patName = (series.patientName || 'ANON').replace(/[^a-zA-Z0-9]/g, '_').slice(0, 32);
    downloadDicomSR(blob, `SR_${patName}_${formatDate(new Date())}.dcm`);

    showToast(`✅ DICOM SR сохранён (${annotations.length} измерений, ${(blob.size / 1024).toFixed(1)} КБ)`, 'success', 3000);
  } catch (err) {
    log.error('[DICOM SR]', err);
    showToast(`❌ Ошибка экспорта SR: ${err.message}`, 'error', 5000);
  }
}

/**
 * [12.0.57] Главное число замера для тренда — по инструменту. Прежде
 * брались `length || area || mean` первой записи cachedStats: у угла все три
 * пусты, и угол 37° сохранялся как «0 mm»; единицы шли по-английски.
 * @returns {{значение:number, ед:string, тип:string, среднее?:number}|null}
 */
const _ЗАМЕРЫ = {
  Length: { тип: 'Длина', поле: 'length', ед: 'мм' },
  Bidirectional: { тип: 'Длинная ось', поле: 'length', ед: 'мм' },
  Angle: { тип: 'Угол', поле: 'angle', ед: '°' },
  CobbAngle: { тип: 'Угол Кобба', поле: 'angle', ед: '°' },
  RectangleROI: { тип: 'Площадь (прямоуг.)', поле: 'area', ед: 'мм²' },
  EllipticalROI: { тип: 'Площадь (эллипс)', поле: 'area', ед: 'мм²' },
  CircleROI: { тип: 'Площадь (круг)', поле: 'area', ед: 'мм²' },
  PlanarFreehandROI: { тип: 'Площадь (контур)', поле: 'area', ед: 'мм²' },
};
function extractMeasurement(annotation) {
  const инстр = annotation?.metadata?.toolName;
  const з = _ЗАМЕРЫ[инстр];
  if (!з) return null;
  const все = Object.values(annotation?.data?.cachedStats || {});
  const ст = все.find((с) => Number.isFinite(с?.[з.поле]));
  if (!ст) return null;
  return { значение: ст[з.поле], ед: з.ед, тип: з.тип, ...(Number.isFinite(ст.mean) ? { среднее: ст.mean } : {}) };
}

function generateUID() {
  return '2.25.' + Date.now() + '.' + Math.floor(Math.random() * 1e9);
}

function formatDate(d) {
  return d.getFullYear().toString() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
}

function formatTime(d) {
  return String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0') + String(d.getSeconds()).padStart(2, '0');
}

// [12.0.52] bindTAVIMeasurement и drawAngleOverlay удалены. «Измерить на
// изображении» в окне TAVI не могло сработать: открытое окно накрывает
// снимок слоем на весь экран (.modal-overlay) и само получает щелчки, а
// #viewport-container при открытом окне ещё и pointer-events:none. Угол
// писался в поле, которое не читал ни один расчёт, а «расстояние в мм»
// считалось по пикселям ЭКРАНА, умноженным на шаг снимка, — без учёта
// увеличения окна. Угол на снимке меряет инструмент «Угол» (клавиша G).

function openMeasDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(MEAS_DB_NAME, MEAS_DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains('measurements')) {
        const store = db.createObjectStore('measurements', { keyPath: 'id', autoIncrement: true });
        store.createIndex('patientId', 'patientId', { unique: false });
        store.createIndex('type', 'type', { unique: false });
        store.createIndex('date', 'date', { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function saveMeasurement(measurement) {
  // measurement = { patientId, patientName, type, value, unit, location, date, seriesUID }
  const db = await openMeasDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('measurements', 'readwrite');
    tx.objectStore('measurements').add({
      ...measurement,
      date: measurement.date || new Date().toISOString(),
      savedAt: Date.now()
    });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

async function getMeasurements(patientId, type) {
  const db = await openMeasDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('measurements', 'readonly');
    const store = tx.objectStore('measurements');
    const idx = store.index('patientId');
    const req = idx.getAll(patientId);
    req.onsuccess = () => {
      let results = req.result;
      if (type) results = results.filter(m => m.type === type);
      results.sort((a, b) => new Date(a.date) - new Date(b.date));
      resolve(results);
    };
    req.onerror = () => reject(req.error);
  });
}

function bindMeasurementTrend() {
  // Кнопка «Сохранить измерение»
  // [12.0.57] Замеры брались из window.cornerstoneTools — программа это имя
  // не заводит (ПЕРЕДАЧА-ДЕЛ-12.0.54, §3): на стенде с нарисованной линейкой
  // кнопка отвечала «❌ Нет измерений для сохранения». Источник теперь тот же,
  // что у отчёта SR, — toolManager.getAnnotations(); берётся последний ЗАМЕР
  // (линейка, угол, площадь), а не последняя аннотация любого рода.
  on('btn-save-measurement', 'click', async () => {
    try {
      const series = _ctx.getAllSeries().find(s => s.seriesUID === _ctx.getCurrentSeries()) || {};
      let annotations = [];
      try { annotations = getAnnotations() || []; } catch (e) { annotations = []; }
      if (!Array.isArray(annotations)) annotations = [];
      const замеры = annotations.map((а) => ({ а, з: extractMeasurement(а) })).filter((x) => x.з);
      if (!замеры.length) {
        showToast('Сохранять нечего: на снимке нет замера — линейки, угла или площади', 'warning', 3500);
        return;
      }
      const { а: lastAnn, з: meas } = замеры[замеры.length - 1];
      if (!series.patientId) {
        showToast('У серии нет ID пациента (0010,0020) — без него тренд перепутает пациентов. Замер не сохранён', 'warning', 5000);
        return;
      }
      await saveMeasurement({
        patientId: series.patientId,
        patientName: series.patientName || '',
        type: meas.тип,
        value: meas.значение,
        unit: meas.ед,
        ...(meas.среднее != null ? { mean: meas.среднее } : {}),
        location: lastAnn.metadata?.referencedImageId || '',
        seriesUID: _ctx.getCurrentSeries()
      });
      showToast(`Замер сохранён в тренд: ${meas.тип} ${meas.значение.toFixed(1)} ${meas.ед}`, 'success', 2500);
    } catch (err) {
      showToast(`Замер не сохранён: ${err.message}`, 'error', 4000);
    }
  });

  // Кнопка «Показать тренд»
  on('btn-show-trend', 'click', async () => {
    try {
      const series = _ctx.getAllSeries().find(s => s.seriesUID === _ctx.getCurrentSeries()) || {};
      // [12.0.57] Без ID пациента тренд собирал в одну кучу всех, у кого его
      // нет («unknown»). Нет ID — честно сказать.
      if (!series.patientId) { showToast('У серии нет ID пациента (0010,0020) — тренд не по кому строить', 'info', 4000); return; }
      const measurements = await getMeasurements(series.patientId);

      if (measurements.length === 0) {
        showToast('📊 Нет сохранённых измерений для этого пациента', 'info');
        return;
      }

      // Рисуем тренд в модальном окне
      showMeasurementTrendChart(measurements, series.patientName);
    } catch (err) {
      showToast(`❌ Ошибка: ${err.message}`, 'error');
    }
  });
}

/**
 * [12.0.57] График — ОДНОГО вида замера. Прежде линии длины (мм), площади
 * (мм²) и угла (°) рисовались на одной оси с одной шкалой: площадь 300 мм²
 * прижимала длину 20 мм к нулю, а подписи шкалы были без единиц. Теперь над
 * графиком выбор вида (по умолчанию — вид последнего сохранённого), шкала
 * подписана единицами; таблица ниже — все замеры пациента.
 */
function showMeasurementTrendChart(measurements, patientName) {
  // Создаём модальное окно с графиком
  let modal = $('modal-trend');
  if (!modal) {
    modal = document.createElement('div');
    modal.className = 'modal-overlay';
    modal.id = 'modal-trend';
    modal.innerHTML = `
      <div class="modal" style="min-width:600px;">
        <div class="modal-title">📈 Тренд замеров — <span id="trend-patient"></span><button class="modal-close" data-close="modal-trend">✕</button></div>
        <div class="ctrl-row" style="gap:6px;margin-bottom:6px;"><span class="ctrl-label">Вид замера</span><select id="trend-type" style="flex:1;"></select></div>
        <canvas id="trend-canvas" width="560" height="300" style="width:100%;background:#0a0f16;border-radius:6px;"></canvas>
        <div id="trend-table" style="max-height:200px;overflow-y:auto;margin-top:8px;"></div>
        <div class="ctrl-row" style="justify-content:flex-end;margin-top:8px;">
          <button class="ctrl-btn" id="btn-trend-export">📄 Экспорт CSV</button>
          <button class="ctrl-btn" data-close="modal-trend">Закрыть</button>
        </div>
      </div>`;
    document.body.appendChild(modal);
    // Close handler
    modal.querySelectorAll('[data-close]').forEach((к) => к.addEventListener('click', () => modal.classList.remove('open')));
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.classList.remove('open'); });
  }
  const имя = modal.querySelector('#trend-patient');
  if (имя) имя.textContent = patientName || '';

  modal.classList.add('open');
  if (!measurements.length) return;

  const types = [...new Set(measurements.map(m => m.type))];
  const выбор = modal.querySelector('#trend-type');
  const последний = measurements.reduce((a, b) => ((b.savedAt || 0) >= (a.savedAt || 0) ? b : a)).type;
  if (выбор) {
    выбор.innerHTML = types.map((t) => `<option>${escapeHtml(String(t))}</option>`).join('');
    выбор.value = последний;
    выбор.onchange = () => нарисовать(выбор.value);
  }

  const нарисовать = (тип) => {
    const canvas = modal.querySelector('#trend-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width, h = canvas.height, pad = 50;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#0a0f16';
    ctx.fillRect(0, 0, w, h);
    const ряд = measurements.filter((m) => m.type === тип);
    if (!ряд.length) return;
    const ед = ряд[ряд.length - 1].unit || '';
    const vals = ряд.map(m => m.value);
    const minVal = Math.min(...vals) * 0.9;
    const maxVal = Math.max(...vals) * 1.1 || 1;
    const minDate = new Date(ряд[0].date).getTime();
    const maxDate = new Date(ряд[ряд.length - 1].date).getTime();
    const dateRange = maxDate - minDate || 1;
    ctx.strokeStyle = '#334'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(pad, pad); ctx.lineTo(pad, h - pad); ctx.lineTo(w - pad, h - pad); ctx.stroke();
    ctx.strokeStyle = '#3b82f6'; ctx.fillStyle = '#3b82f6'; ctx.lineWidth = 2;
    const точки = ряд.map((m) => [
      ряд.length === 1 ? w / 2 : pad + ((new Date(m.date).getTime() - minDate) / dateRange) * (w - pad * 2),
      h - pad - ((m.value - minVal) / ((maxVal - minVal) || 1)) * (h - pad * 2),
    ]);
    ctx.beginPath(); точки.forEach(([x, y], i) => (i ? ctx.lineTo(x, y) : ctx.moveTo(x, y))); ctx.stroke();
    for (const [x, y] of точки) { ctx.beginPath(); ctx.arc(x, y, 4, 0, Math.PI * 2); ctx.fill(); }
    ctx.fillStyle = '#889'; ctx.font = '9px monospace'; ctx.textAlign = 'center';
    ctx.fillText(new Date(minDate).toLocaleDateString('ru'), pad + 20, h - pad + 14);
    ctx.fillText(new Date(maxDate).toLocaleDateString('ru'), w - pad - 20, h - pad + 14);
    ctx.textAlign = 'right';
    ctx.fillText(`${minVal.toFixed(1)} ${ед}`, pad - 4, h - pad);
    ctx.fillText(`${maxVal.toFixed(1)} ${ед}`, pad - 4, pad + 4);
    ctx.textAlign = 'left'; ctx.fillStyle = '#3b82f6'; ctx.font = '11px sans-serif';
    ctx.fillText(`● ${тип}, ${ед}`, pad + 6, pad - 8);
  };
  нарисовать(последний);

  // Таблица
  const table = modal.querySelector('#trend-table');
  if (table) {
    table.innerHTML = '<table style="width:100%;font-size:11px;border-collapse:collapse;">' +
      '<tr style="color:var(--text-dim);"><th style="text-align:left;padding:2px 6px;">Дата</th><th>Вид</th><th>Значение</th><th>Единицы</th><th>Среднее</th></tr>' +
      measurements.map(m => `<tr style="border-top:1px solid rgba(255,255,255,0.05);">
        <td style="padding:2px 6px;">${new Date(m.date).toLocaleDateString('ru')}</td>
        <td style="text-align:center;">${escapeHtml(String(m.type))}</td>
        <td style="text-align:center;font-weight:600;">${Number(m.value).toFixed(1)}</td>
        <td style="text-align:center;">${escapeHtml(String(m.unit || ''))}</td>
        <td style="text-align:center;">${Number.isFinite(m.mean) ? m.mean.toFixed(0) : '—'}</td>
      </tr>`).join('') +
      '</table>';
  }

  // CSV экспорт
  const exportBtn = modal.querySelector('#btn-trend-export');
  if (exportBtn) {
    exportBtn.onclick = () => {
      const csv = 'Дата;Вид;Значение;Единицы;Среднее;ID пациента\n' +
        measurements.map(m => [m.date, m.type, m.value, m.unit, Number.isFinite(m.mean) ? m.mean : '', m.patientId].join(';')).join('\n');
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `замеры_${(patientName || 'пациент').replace(/[^\p{L}\p{N}]+/gu, '_')}.csv`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 4000);
      showToast('Таблица замеров сохранена (CSV)', 'success', 1500);
    };
  }
}

// ─── VOICE CONTROL ────────────────────────────────────────────
// [11.1.2] Обёртка bindVoiceControl УДАЛЕНА: она существовала ради одной
// привязки к кнопке btn-voice-control, а кнопки больше нет — голос живёт
// пунктом «Голос: команды» в группе «Голос и жесты» правого сайдбара,
// который зовёт функцию напрямую.
/**
 * [11.1.2] Голосовые команды — ЭКСПОРТИРУЕМАЯ функция, а не обработчик кнопки.
 *
 * Кнопки btn-voice-control больше нет в разметке: голос переехал в группу
 * «Голос и жесты» правого сайдбара пунктом «Голос: команды». Группа строится
 * кодом, кнопки в index.html у неё нет — значит и щёлкать по ней неоткуда.
 * Оставить прежнюю привязку значило бы получить пункт, который молчит: ровно
 * та беда, за которую владелец справедливо назвал мёртвой синхронизацию окон.
 *
 * Возвращает true, если распознавание включилось, — чтобы вызывающая сторона
 * могла отчитаться человеку.
 */
export function переключитьГолос() {
    const SpeechRecog = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecog) {
      showToast('🎤 Браузер не поддерживает голосовое управление', 'error');
      return;
    }
    const btn = $('btn-voice-control');

    if (_voiceRecognition) {
      _voiceRecognition.stop();
      _voiceRecognition = null;
      btn?.classList.remove('active');
      showToast('🎤 Голос. управление отключено', 'info', 800);
      return;
    }

    _voiceRecognition = new SpeechRecog();
    _voiceRecognition.lang = 'ru-RU';
    _voiceRecognition.continuous = true;
    _voiceRecognition.interimResults = false;

    const commands = {
      // ── 3D пресеты ──
      'кости':        () => $$('.preset-chip[data-render-preset="ct-bone-3d"]')[0]?.click(),
      'лёгкие':       () => $$('.preset-chip[data-render-preset="ct-lung-3d"]')[0]?.click(),
      'сосуды':       () => $$('.preset-chip[data-render-preset="ct-vascular"]')[0]?.click(),
      'мозг':         () => $$('.preset-chip[data-render-preset="mri-brain-3d"]')[0]?.click(),
      'сердце':       () => $$('.preset-chip[data-render-preset="cardiac-3d"]')[0]?.click(),
      'кожа':         () => $$('.preset-chip[data-render-preset="ct-skin"]')[0]?.click(),
      // ── Проекции ──
      'аксиальный':   () => $('btn-mode-axial')?.click(),
      'сагиттальный': () => $('btn-mode-sagittal')?.click(),
      'корональный':  () => $('btn-mode-coronal')?.click(),
      'объём':        () => $('btn-mode-3d')?.click(),
      '3d':           () => $('btn-mode-3d')?.click(),
      '2d':           () => $('btn-mode-2d')?.click(),
      // ── Действия ──
      'инверсия':     () => $('btn-invert')?.click(),
      'снимок':       () => $('btn-screenshot')?.click(),
      'сброс':        () => $('btn-reset')?.click(),
      'отменить':     () => { if (window.MikhmelViewer?.undoAnnotation) window.MikhmelViewer.undoAnnotation(); },
      'повторить':    () => { if (window.MikhmelViewer?.redoAnnotation) window.MikhmelViewer.redoAnnotation(); },
      // ── Навигация по срезам ──
      'следующий':    () => scrollSlice(1),
      'дальше':       () => scrollSlice(1),
      'вперёд':       () => scrollSlice(1),
      'предыдущий':   () => scrollSlice(-1),
      'назад':        () => scrollSlice(-1),
      'начало':       () => jumpToSlice(0),
      'конец':        () => jumpToSlice(-1),
      'середина':     () => jumpToSlice('mid'),
      // ── Срез по номеру (парсится отдельно) ──
      // ── Инструменты ──
      'зум':          () => activateTool('Zoom'),
      'масштаб':      () => activateTool('Zoom'),
      'увеличить':    () => zoomBy(1.3),
      'уменьшить':    () => zoomBy(0.7),
      'линейка':      () => activateTool('Length'),
      'длина':        () => activateTool('Length'),
      'угол':         () => activateTool('Angle'),
      'листание':     () => activateTool('StackScroll'),
      'прокрутка':    () => activateTool('StackScroll'),
      'двигать':      () => activateTool('Pan'),
      'вращение':     () => activateTool('TrackballRotate'),
      'вращать':      () => activateTool('TrackballRotate'),
      'лупа':         () => activateTool('Magnify'),
      'крест':        () => activateTool('Crosshairs'),
      'кисть':        () => activateTool('Brush'),
      'стрелка':      () => activateTool('ArrowAnnotate'),
      'текст':        () => activateTool('TextAnnotation'),
      'контраст':     () => activateTool('WindowLevel'),
      'яркость':      () => activateTool('WindowLevel'),
      // ── W/L пресеты ──
      // [12.0.49] Числа — из каталога чипов. Здесь жила четвёртая копия
      // окон, и она разъехалась: кости 1500/400 (каталог 2500/480), лёгкие
      // 1500/−500 (−600), печень 150/70 (150/30) — голос и чип с одним
      // названием давали разную картинку.
      'лёгочное окно':() => applyWLPreset('ct-lung'),
      'костное окно': () => applyWLPreset('ct-bone'),
      'мягкие ткани': () => applyWLPreset('ct-soft'),
      'мозговое окно':() => applyWLPreset('ct-brain'),
      'абдоминальное':() => applyWLPreset('ct-abdomen'),
      'печёночное':   () => applyWLPreset('ct-liver'),
      // ── Стоп ──
      'стоп': () => {
        _voiceRecognition?.stop();
        _voiceRecognition = null;
        btn?.classList.remove('active');
        showToast('🎤 Стоп', 'info', 800);
      }
    };

    // Вспомогательные функции для голосовых команд
    function scrollSlice(dir) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (!vp) return;
        const idx = vp.getCurrentImageIdIndex?.() || 0;
        const total = vp.getImageIds?.()?.length || 0;
        const newIdx = Math.max(0, Math.min(total - 1, idx + dir));
        vp.setImageIdIndex?.(newIdx);
        vp.render();
        showToast(`📜 Срез ${newIdx + 1}/${total}`, 'info', 600);
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    function jumpToSlice(target) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (!vp) return;
        const total = vp.getImageIds?.()?.length || 0;
        let idx = 0;
        if (target === -1) idx = total - 1;
        else if (target === 'mid') idx = Math.floor(total / 2);
        else idx = Math.max(0, Math.min(total - 1, target));
        vp.setImageIdIndex?.(idx);
        vp.render();
        showToast(`📜 Срез ${idx + 1}/${total}`, 'info', 600);
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    function activateTool(toolName) {
      setActiveTool(toolName);
      $$('.tool-btn').forEach(b => b.classList.toggle('active', b.dataset.tool === toolName));
      if (window.showToolIndicator) window.showToolIndicator(toolName);
      showToast(`🔧 ${toolName}`, 'info', 600);
    }

    function zoomBy(factor) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (!vp) return;
        const cam = vp.getCamera();
        if (cam.parallelProjection) {
          vp.setCamera({ parallelScale: cam.parallelScale / factor });
        }
        vp.render();
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    // [12.0.49] Окно голосом — как чип правой панели: в выбранное окно и в
    // окна срезов той же модальности (core/wlApply.js), с надписью W/L,
    // подсветкой чипов и ползунками (событие «окно извне»). Раньше голос
    // менял одно окно своими числами.
    function applyWLPreset(idЧипа) {
      const ч = ЧИПЫ_ПО_ID[idЧипа];
      if (!ч || !Number.isFinite(ч.ww)) return;
      try {
        if (!applyWindowToSlices({ ww: ч.ww, wc: ч.wc })) return;
        document.dispatchEvent(new CustomEvent('mikhmel:окно-извне', { detail: { ww: ч.ww, wc: ч.wc } }));
        showToast(`🌓 ${ч.label}: W:${ч.ww} / L:${ч.wc}`, 'info', 1200);
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    _voiceRecognition.onresult = (event) => {
      const text = event.results[event.results.length - 1][0].transcript.toLowerCase().trim();
      showToast(`🎤 «${text}»`, 'info', 2000);

      // Парсинг номера среза: "срез 50", "срез номер 120", "покажи 42"
      const sliceMatch = text.match(/(?:срез|слайс|покажи)\s*(?:номер\s*)?(\d+)/);
      if (sliceMatch) {
        const num = parseInt(sliceMatch[1]) - 1; // в 0-based
        jumpToSlice(num);
        return;
      }

      // Парсинг "десять вперёд", "двадцать назад"
      const skipMatch = text.match(/(\d+)\s*(вперёд|дальше|назад)/);
      if (skipMatch) {
        const n = parseInt(skipMatch[1]);
        const dir = skipMatch[2] === 'назад' ? -n : n;
        scrollSlice(dir);
        return;
      }

      // Стандартные команды
      Object.entries(commands).forEach(([key, fn]) => { if (text.includes(key)) fn(); });
    };

    _voiceRecognition.onerror = (e) => {
      if (e.error === 'no-speech') return;
      log.warn('Voice error:', e.error);
      _voiceRecognition = null;
      btn?.classList.remove('active');
      showToast(`🎤 Ошибка: ${e.error}`, 'error');
    };

    _voiceRecognition.onend = () => {
      if (_voiceRecognition && btn?.classList.contains('active')) {
        try { _voiceRecognition.start(); } catch (e) { log.debug('[FeatureBindings]', e.message); }
      }
    };

    _voiceRecognition.start();
    btn?.classList.add('active');
    showToast('🎤 Голосовое управление (ru-RU)\n' +
      'Навигация: следующий, предыдущий, срез 50, начало, конец\n' +
      'Инструменты: линейка, зум, лупа, листание, вращать\n' +
      'Окно: лёгочное окно, костное окно, мягкие ткани\n' +
      'Пресеты: кости, лёгкие, сосуды, мозг, сердце\n' +
      'Действия: увеличить, уменьшить, инверсия, снимок, стоп', 'success', 5000);
  }

// ─── WebGPU CHECK ─────────────────────────────────────────────
function bindWebGPUCheck() {
  // [12.0.57] Кнопка затирала свою надпись вместе со значком текстом
  // «⚠️ No Adapter» / «❌ Error» и так и оставалась до перезагрузки; в плашке
  // — «Vendor», «Architecture», «Max buffer». Теперь значок на месте, итог
  // проверки — словами в подписи кнопки и в плашке по-русски.
  const btn0 = $('btn-webgpu-check');
  const значок = btn0?.querySelector('svg')?.outerHTML || '';
  const подписать = (т) => { const b = $('btn-webgpu-check'); if (b) b.innerHTML = `${значок} ${т}`; };
  on('btn-webgpu-check', 'click', async () => {
    const btn = $('btn-webgpu-check');
    if (!btn) return;
    подписать('WebGPU: проверка…');

    if (!navigator.gpu) {
      showToast('WebGPU в этом браузере нет — расчёты пойдут на процессоре (медленнее, но так же точно)', 'warning', 5000);
      подписать('WebGPU: нет');
      return;
    }
    try {
      const adapter = await navigator.gpu.requestAdapter();
      if (!adapter) {
        showToast('WebGPU есть, но видеокарта его не дала (драйвер или запрет браузера) — расчёты пойдут на процессоре', 'warning', 5000);
        подписать('WebGPU: нет видеокарты');
        return;
      }
      const device = await adapter.requestDevice();
      const info = adapter.info || {};
      const details = [
        'WebGPU работает',
        `Производитель: ${info.vendor || 'не сообщает'}`,
        `Архитектура: ${info.architecture || 'не сообщает'}`,
        `Наибольший буфер: ${(device.limits.maxBufferSize / 1024 / 1024).toFixed(0)} МБ`,
        `Рабочая группа: до ${device.limits.maxComputeWorkgroupSizeX}`,
      ].join('\n');
      showToast(details, 'success', 8000);
      подписать('WebGPU: есть');
      btn.style.borderColor = 'var(--success)';

      // Обновляем бейдж в statusbar
      const badge = $('webgpu-badge');
      if (badge) {
        badge.textContent = 'WebGPU ✓';
        badge.style.background = 'rgba(34,197,94,0.15)';
        badge.style.color = '#22c55e';
      }
      device.destroy();
    } catch (e) {
      showToast(`Ошибка WebGPU: ${e.message}`, 'error', 5000);
      подписать('WebGPU: ошибка');
    }
  });
}


// ══════════════════════════════════════════════════════════════
// ENTERPRISE FEATURES (v6) — Real functionality
// ══════════════════════════════════════════════════════════════

/** @type {Map<string, boolean>} Feature flags — toggle groups on/off */
const _featureFlags = new Map();
/** @type {Map<string, number>} Feature usage counters */
const _featureUsage = new Map();
const _featureGroups = {
  // [12.0.56] Группа ИИ — кнопки, что остались во вкладке ИИ (прежние карточки удалены, надгробие — index.html).
  'ai': ['btn-medsam','btn-sam-undo','btn-sam-clear','btn-sam-run','btn-ai-lung-seg','btn-liver-auto','btn-organs','btn-organs-3d','btn-organs-3d-off','btn-totalseg','btn-ai-preload','btn-ai-check-models','btn-ai-release'],
  'seg': ['btn-seg-undo','btn-seg-redo','btn-seg-clear'], // [11.1.21] «btn-seg-opacity» убран: кнопки с таким id никогда не было (ползунок зовётся seg-opacity) — счётчик бил в призрак
  '4d': ['btn-pro-4d-prev','btn-pro-4d-next','btn-pro-4d-play','btn-pro-4d-stop'],
  'sync': ['btn-pro-pos-sync','btn-pro-mpr-sync','btn-pro-smart-compare'],
  'session': ['btn-pro-session-start','btn-pro-session-stop','btn-pro-session-replay','btn-pro-session-export'], // [12.0.57] + «Повтор»
  'camera': ['btn-pro-cam-push','btn-pro-cam-pop'],
  'slab': ['btn-pro-slab-mip','btn-pro-slab-minip','btn-pro-slab-avg','btn-pro-slab-cycle'],
};

/**
 * Enable/disable a feature group (hides/shows related buttons)
 * @param {string} group — 'ai'|'seg'|'4d'|'sync'|'session'|'camera'|'slab'
 * @param {boolean} enabled
 */
export function setFeatureGroupEnabled(group, enabled) {
  const ids = _featureGroups[group];
  if (!ids) return;
  _featureFlags.set(group, enabled);
  for (const id of ids) {
    const el = document.getElementById(id);
    if (el) {
      el.style.display = enabled ? '' : 'none';
      el.disabled = !enabled;
    }
  }
  log.debug(`[Features] Group '${group}' ${enabled ? 'enabled' : 'disabled'} (${ids.length} buttons)`);
}

/**
 * Get all feature groups and their enabled state
 * @returns {Object}
 */
export function getFeatureGroups() {
  const result = {};
  for (const [group, ids] of Object.entries(_featureGroups)) {
    result[group] = {
      enabled: _featureFlags.get(group) !== false,
      buttonCount: ids.length,
      buttons: ids,
    };
  }
  return result;
}

/**
 * Track feature usage (call when a feature button is clicked)
 * @param {string} featureId
 */
export function trackFeatureUsage(featureId) {
  _featureUsage.set(featureId, (_featureUsage.get(featureId) || 0) + 1);
}

/**
 * Get feature usage analytics — top used features
 * @param {number} [topN=10]
 * @returns {Array<{feature:string, count:number}>}
 */
export function getFeatureUsageStats(topN = 10) {
  return [..._featureUsage.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, topN)
    .map(([feature, count]) => ({ feature, count }));
}

/**
 * Search features by name/description across all panel buttons
 * @param {string} query
 * @returns {Array<{id:string, text:string, group:string}>}
 */
export function searchFeatures(query) {
  const q = query.toLowerCase();
  const results = [];
  for (const [group, ids] of Object.entries(_featureGroups)) {
    for (const id of ids) {
      const el = document.getElementById(id);
      if (!el) continue;
      const text = el.textContent || el.title || id;
      if (text.toLowerCase().includes(q) || id.toLowerCase().includes(q)) {
        results.push({ id, text: text.trim(), group });
      }
    }
  }
  return results;
}

/**
 * Enable all feature groups
 */
export function enableAllFeatures() {
  for (const group of Object.keys(_featureGroups)) setFeatureGroupEnabled(group, true);
  showToast('✅ Все функции включены', 'success', 1200);
}

/**
 * Disable all feature groups (minimal mode)
 */
export function disableAllFeatures() {
  for (const group of Object.keys(_featureGroups)) setFeatureGroupEnabled(group, false);
  showToast('🔒 Все функции отключены (минимальный режим)', 'warning', 1500);
}

/**
 * Reset usage analytics
 */
export function resetFeatureUsage() {
  _featureUsage.clear();
  log.debug('[Features] Usage stats reset');
}
